import "react-tippy/dist/tippy.css";
import {library as $1mgSD$library} from "@fortawesome/fontawesome-svg-core";
import {faBarcodeRead as $1mgSD$faBarcodeRead} from "@fortawesome/pro-regular-svg-icons/faBarcodeRead";
import {faCheck as $1mgSD$faCheck} from "@fortawesome/pro-regular-svg-icons/faCheck";
import {faChevronDown as $1mgSD$faChevronDown} from "@fortawesome/pro-regular-svg-icons/faChevronDown";
import {faChevronLeft as $1mgSD$faChevronLeft} from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import {faChevronRight as $1mgSD$faChevronRight} from "@fortawesome/pro-regular-svg-icons/faChevronRight";
import {faEllipsisV as $1mgSD$faEllipsisV} from "@fortawesome/pro-regular-svg-icons/faEllipsisV";
import {faInfoCircle as $1mgSD$faInfoCircle} from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import {faMinus as $1mgSD$faMinus} from "@fortawesome/pro-regular-svg-icons/faMinus";
import {faPlus as $1mgSD$faPlus} from "@fortawesome/pro-regular-svg-icons/faPlus";
import {faTimes as $1mgSD$faTimes} from "@fortawesome/pro-regular-svg-icons/faTimes";
import {faCheckCircle as $1mgSD$faCheckCircle} from "@fortawesome/pro-solid-svg-icons/faCheckCircle";
import {faExclamationCircle as $1mgSD$faExclamationCircle} from "@fortawesome/pro-solid-svg-icons/faExclamationCircle";
import {faInfoCircle as $1mgSD$faInfoCircle1} from "@fortawesome/pro-solid-svg-icons/faInfoCircle";
import {faMoneyBill as $1mgSD$faMoneyBill} from "@fortawesome/pro-solid-svg-icons/faMoneyBill";
import {faTimesCircle as $1mgSD$faTimesCircle} from "@fortawesome/pro-solid-svg-icons/faTimesCircle";
import {faPencil as $1mgSD$faPencil} from "@fortawesome/pro-solid-svg-icons/faPencil";
import {faPrescriptionBottle as $1mgSD$faPrescriptionBottle} from "@fortawesome/pro-solid-svg-icons/faPrescriptionBottle";
import {faPrescriptionBottleAlt as $1mgSD$faPrescriptionBottleAlt} from "@fortawesome/pro-solid-svg-icons/faPrescriptionBottleAlt";
import {faSearch as $1mgSD$faSearch} from "@fortawesome/pro-light-svg-icons/faSearch";
import {faTimesCircle as $1mgSD$faTimesCircle1} from "@fortawesome/pro-light-svg-icons/faTimesCircle";
import $1mgSD$react, {createElement as $1mgSD$createElement, useState as $1mgSD$useState, Children as $1mgSD$Children, cloneElement as $1mgSD$cloneElement, PureComponent as $1mgSD$PureComponent, Component as $1mgSD$Component, useRef as $1mgSD$useRef, useEffect as $1mgSD$useEffect} from "react";
import $1mgSD$styledcomponents, {css as $1mgSD$css, keyframes as $1mgSD$keyframes, ThemeProvider as $1mgSD$ThemeProvider, useTheme as $1mgSD$useTheme} from "styled-components";
import {COLORS as $1mgSD$COLORS, TYPOGRAPHY as $1mgSD$TYPOGRAPHY} from "@alto/design-library-tokens";
import $1mgSD$reactspinner from "react-spinner";
import $1mgSD$swchelperslib_define_propertyjs from "@swc/helpers/lib/_define_property.js";
import {FontAwesomeIcon as $1mgSD$FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import $1mgSD$reactselect, {components as $ca99b2599154b655$re_export$SelectComponents} from "react-select";
import $1mgSD$reactselectlibAsync from "react-select/lib/Async";
import $1mgSD$reactselectlibAsyncCreatable from "react-select/lib/AsyncCreatable";
import {Tooltip as $1mgSD$Tooltip} from "react-tippy";
import $1mgSD$reacttoggle from "react-toggle";
import "react-toggle/style.css";
import $1mgSD$reactdropzone from "react-dropzone";
import {faCamera as $1mgSD$faCamera} from "@fortawesome/pro-solid-svg-icons/faCamera";
import {faTrashAlt as $1mgSD$faTrashAlt} from "@fortawesome/pro-light-svg-icons/faTrashAlt";
import {faTimes as $1mgSD$faTimes1} from "@fortawesome/pro-light-svg-icons/faTimes";
import {Transition as $1mgSD$Transition} from "react-transition-group";
import {faArrowRight as $1mgSD$faArrowRight} from "@fortawesome/pro-light-svg-icons/faArrowRight";
import {faArrowLeft as $1mgSD$faArrowLeft} from "@fortawesome/pro-light-svg-icons/faArrowLeft";
import $1mgSD$reactdom from "react-dom";

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $73d1fdfde4d09865$exports = {};
var $5ebe933df9edf9d7$exports = {};

$parcel$export($5ebe933df9edf9d7$exports, "icons", function () { return $ae186192d622cbfc$exports; });
var $ae186192d622cbfc$exports = {};





















(0, $1mgSD$library).add(// Regular
(0, $1mgSD$faBarcodeRead), (0, $1mgSD$faCheck), (0, $1mgSD$faChevronDown), (0, $1mgSD$faChevronLeft), (0, $1mgSD$faChevronRight), (0, $1mgSD$faEllipsisV), (0, $1mgSD$faInfoCircle), (0, $1mgSD$faMinus), (0, $1mgSD$faPlus), (0, $1mgSD$faTimes), (0, $1mgSD$faCheckCircle), (0, $1mgSD$faExclamationCircle), (0, $1mgSD$faInfoCircle1), (0, $1mgSD$faMoneyBill), (0, $1mgSD$faTimesCircle), (0, $1mgSD$faPencil), (0, $1mgSD$faPrescriptionBottle), (0, $1mgSD$faPrescriptionBottleAlt), (0, $1mgSD$faSearch), (0, $1mgSD$faTimesCircle1));




var $914c88bdea61f2b6$exports = {};
var $f8bea99cab290f06$exports = {};

$parcel$export($f8bea99cab290f06$exports, "ActionBar", function () { return $f8bea99cab290f06$export$e213cebad6250b4a; });
$parcel$export($f8bea99cab290f06$exports, "ActionBarWrapper", function () { return $f8bea99cab290f06$export$af98ebab6701b942; });


const $aaac76de4690e7ff$export$e73d0868f38cb1d = "#00263E";
const $aaac76de4690e7ff$export$b33c7b711cacd17d = "#0B4A72";
const $aaac76de4690e7ff$export$fe1c5ace6f02cfbf = "#084367";
const $aaac76de4690e7ff$export$33af1cdf0dd1ede7 = $aaac76de4690e7ff$export$e73d0868f38cb1d;
const $aaac76de4690e7ff$export$87a86361d063ff10 = "#EEF4F9";
const $aaac76de4690e7ff$export$6d4bd4305d16dfab = "#DCE9EF";
const $aaac76de4690e7ff$export$8789b5d1f1beb293 = "#1976D2"; // FIXME
const $aaac76de4690e7ff$export$d913daa7170c2f9f = "#1976D2";
const $aaac76de4690e7ff$export$775ceeacde47cab2 = $aaac76de4690e7ff$export$87a86361d063ff10;
const $aaac76de4690e7ff$export$3fba6270ac3a5805 = "#DCE9EF";
const $aaac76de4690e7ff$export$d64337d93117d1ad = "#1976D2"; // FIXME
const $aaac76de4690e7ff$export$efbeee5f72946d45 = $aaac76de4690e7ff$export$8789b5d1f1beb293;
const $aaac76de4690e7ff$export$2cc8ba0276e7dc05 = $aaac76de4690e7ff$export$d913daa7170c2f9f;
const $aaac76de4690e7ff$export$5c7005e62f2afea = $aaac76de4690e7ff$export$775ceeacde47cab2;
const $aaac76de4690e7ff$export$9d750e1fb2345249 = $aaac76de4690e7ff$export$3fba6270ac3a5805;
const $aaac76de4690e7ff$export$5057a5936ce0c0a5 = $aaac76de4690e7ff$export$d64337d93117d1ad;
const $aaac76de4690e7ff$export$689894fd5b69c1a5 = "#E53935"; // FIXME
const $aaac76de4690e7ff$export$4c90220182e0b14 = "#E53935";
const $aaac76de4690e7ff$export$a9a9aec38bf931d8 = "#CD332F";
const $aaac76de4690e7ff$export$af7315ffdcd84ac3 = "#AE2B28";
const $aaac76de4690e7ff$export$6c9b3104157f8389 = "#FFEBEE";
const $aaac76de4690e7ff$export$da9db0a7af92f233 = $aaac76de4690e7ff$export$6c9b3104157f8389;
const $aaac76de4690e7ff$export$ff334fa2eb55a335 = "#FFCDD2";
const $aaac76de4690e7ff$export$df5574606a94f191 = "#00897B"; // FIXME
const $aaac76de4690e7ff$export$e52bbaa2db5579b1 = "#00897B";
const $aaac76de4690e7ff$export$7e843862c500fadd = "#E0F2F1";
const $aaac76de4690e7ff$export$fc4f51108032ddec = "#B9D276";
const $aaac76de4690e7ff$export$df987b01b59e4e45 = "#F6FAE7";
const $aaac76de4690e7ff$export$eafd9d6862ca17a9 = "#FFA000"; // FIXME
const $aaac76de4690e7ff$export$a407bb5b45f88e9f = "#FFA000";
const $aaac76de4690e7ff$export$f8a16a30e3179648 = "#FFF8E1";
const $aaac76de4690e7ff$export$5785ba937f4c5d42 = "rgba(255,248,225,0.5)";
const $aaac76de4690e7ff$export$55064c834975c010 = "#FFF2CD";
const $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f = "#192026";
const $aaac76de4690e7ff$export$7b1dbb1d9e615f91 = "#192026"; // FIXME
const $aaac76de4690e7ff$export$abc95940fda32f98 = "#687382";
const $aaac76de4690e7ff$export$1dfa4a610aaefe1 = "#687382"; // FIXME
const $aaac76de4690e7ff$export$545251b0d520f8ad = "#DCE1E6";
const $aaac76de4690e7ff$export$40e746099f73c094 = "#DCE1E6"; // FIXME
const $aaac76de4690e7ff$export$ed73c413f4c945c9 = "#FFFFFF"; // TODO: REMOVE
const $aaac76de4690e7ff$export$ea856c4df433fa56 = "#FFFFFF"; // TODO: REMOVE
const $aaac76de4690e7ff$export$91270c6916e25d70 = "#F7F5F4"; // FIXME
const $aaac76de4690e7ff$export$6206133e1543f249 = "#F7F5F4"; // FIXME
const $aaac76de4690e7ff$export$76ad689e70c7691d = "#F7F5F4";
const $aaac76de4690e7ff$export$3b058bf22d3a92e9 = "#FFFFFF";
const $aaac76de4690e7ff$export$f858cd7b6506d226 = $aaac76de4690e7ff$export$5785ba937f4c5d42;
const $aaac76de4690e7ff$export$3209604dab7b9537 = $aaac76de4690e7ff$export$87a86361d063ff10;
const $aaac76de4690e7ff$export$2ad0c329ccd958f8 = $aaac76de4690e7ff$export$8789b5d1f1beb293;
const $aaac76de4690e7ff$export$8bf7dff220b82b4a = $aaac76de4690e7ff$export$e52bbaa2db5579b1;
const $aaac76de4690e7ff$export$6d8f981b04aed00b = $aaac76de4690e7ff$export$7e843862c500fadd;
const $aaac76de4690e7ff$export$594c5a8758200c32 = $aaac76de4690e7ff$export$a407bb5b45f88e9f;
const $aaac76de4690e7ff$export$2f350c514d155d6c = $aaac76de4690e7ff$export$f8a16a30e3179648;
const $aaac76de4690e7ff$export$a90204d1394caf30 = $aaac76de4690e7ff$export$4c90220182e0b14;
const $aaac76de4690e7ff$export$2f95049e6b041020 = $aaac76de4690e7ff$export$6c9b3104157f8389;
const $aaac76de4690e7ff$export$9fc8e71a68236410 = $aaac76de4690e7ff$export$e73d0868f38cb1d;
const $aaac76de4690e7ff$export$54a390250b5a3226 = $aaac76de4690e7ff$export$b33c7b711cacd17d;
const $aaac76de4690e7ff$export$141f6f97ca17eff0 = $aaac76de4690e7ff$export$6d4bd4305d16dfab;
const $aaac76de4690e7ff$export$d36ef3fb6733a582 = $aaac76de4690e7ff$export$87a86361d063ff10;
const $aaac76de4690e7ff$export$4b03d8f78bb232ec = $aaac76de4690e7ff$export$d913daa7170c2f9f;
const $aaac76de4690e7ff$export$3c81d76652c0ee8d = $aaac76de4690e7ff$export$76ad689e70c7691d;
const $aaac76de4690e7ff$export$cb81ca6e31dfb4ee = $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f;
const $aaac76de4690e7ff$export$26de6a0f89719481 = $aaac76de4690e7ff$export$abc95940fda32f98;
const $aaac76de4690e7ff$export$15e963ace12d673f = $aaac76de4690e7ff$export$545251b0d520f8ad;
const $aaac76de4690e7ff$export$8fa4e5556fd77a60 = $aaac76de4690e7ff$export$3b058bf22d3a92e9;
const $aaac76de4690e7ff$export$b44088c8267d4ac8 = $aaac76de4690e7ff$export$545251b0d520f8ad;
const $aaac76de4690e7ff$export$5b28b8c0b3900263 = $aaac76de4690e7ff$export$e52bbaa2db5579b1;
const $aaac76de4690e7ff$export$6005560f036eee53 = $aaac76de4690e7ff$export$7e843862c500fadd;
const $aaac76de4690e7ff$export$6b4b2f601e928a30 = $aaac76de4690e7ff$export$a407bb5b45f88e9f;
const $aaac76de4690e7ff$export$42bbe197447f32ff = $aaac76de4690e7ff$export$f8a16a30e3179648;
const $aaac76de4690e7ff$export$338a087f70a8f978 = $aaac76de4690e7ff$export$4c90220182e0b14;
const $aaac76de4690e7ff$export$83bd2a8eab79c8b7 = $aaac76de4690e7ff$export$6c9b3104157f8389;
const $aaac76de4690e7ff$export$9c1c8f508a671b92 = $aaac76de4690e7ff$export$fc4f51108032ddec;
const $aaac76de4690e7ff$export$3d1aee436109f0d0 = $aaac76de4690e7ff$export$fc4f51108032ddec;
const $aaac76de4690e7ff$export$30eb1f683e21ee98 = $aaac76de4690e7ff$export$df987b01b59e4e45;
const $aaac76de4690e7ff$export$5bf79effc7eac03b = $aaac76de4690e7ff$export$55064c834975c010;


const $fd37c165946cdbcc$export$4c16e5a80ec60b32 = ".25rem";
const $fd37c165946cdbcc$export$79a18a7d58eb5909 = ".5rem";
const $fd37c165946cdbcc$export$54c7853c55b55e72 = "1rem";
const $fd37c165946cdbcc$export$70173e1228291b3c = "1.5rem";
const $fd37c165946cdbcc$export$9b8cd5b0d7315663 = "2rem";
const $fd37c165946cdbcc$export$545718d17558da76 = "2.5rem";
const $fd37c165946cdbcc$export$c34a6c87634beb3f = "3.5rem";
const $fd37c165946cdbcc$export$12879c7697ed953d = "1px";
const $fd37c165946cdbcc$export$7a57f79000377ca2 = "2px";
const $fd37c165946cdbcc$export$efa65fa1092f7420 = "4px";
const $fd37c165946cdbcc$export$f0eadff003889631 = "20px";


const $f8bea99cab290f06$var$POSITIONS = Object.freeze({
    TOP: "top",
    BOTTOM: "bottom",
    LEFT: "left",
    RIGHT: "right"
});
const $f8bea99cab290f06$var$getPosition = (props)=>{
    const { borderless: borderless , position: position , size: size  } = props;
    const borderStyling = borderless ? "none" : `1px solid ${0, $aaac76de4690e7ff$export$40e746099f73c094};`;
    switch(position){
        case $f8bea99cab290f06$var$POSITIONS.RIGHT:
            return (0, $1mgSD$css)`
        right: 0;
        top: 0;
        width: ${size};
        border-left: ${borderStyling};
      `;
        case $f8bea99cab290f06$var$POSITIONS.LEFT:
            return (0, $1mgSD$css)`
        left: 0;
        top: 0;
        width: ${size};
        border-right: ${borderStyling};
      `;
        case $f8bea99cab290f06$var$POSITIONS.TOP:
            return (0, $1mgSD$css)`
        top: 0;
        height: ${size};
        border-bottom: ${borderStyling};
      `;
        case $f8bea99cab290f06$var$POSITIONS.BOTTOM:
        default:
            return (0, $1mgSD$css)`
        bottom: 0;
        height: ${size};
        border-top: ${borderStyling};
      `;
    }
};
const $f8bea99cab290f06$export$e213cebad6250b4a = (0, $1mgSD$styledcomponents)(// eslint-disable-next-line @typescript-eslint/no-unused-vars
({ backgroundColor: backgroundColor , borderless: borderless , position: position , size: size , ...rest })=>/*#__PURE__*/ $1mgSD$createElement("div", rest))`
  position: sticky;
  background-color: ${({ backgroundColor: backgroundColor  })=>backgroundColor || (0, $aaac76de4690e7ff$export$3b058bf22d3a92e9)};
  box-sizing: border-box;
  ${(props)=>$f8bea99cab290f06$var$getPosition(props)}
  padding: ${({ padding: padding  })=>padding || (0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  z-index: 99;
`;
const $f8bea99cab290f06$export$af98ebab6701b942 = (props)=>/*#__PURE__*/ $1mgSD$createElement($f8bea99cab290f06$export$e213cebad6250b4a, props);
$f8bea99cab290f06$export$af98ebab6701b942.defaultProps = {
    backgroundColor: undefined,
    borderless: undefined,
    children: null,
    padding: undefined,
    position: $f8bea99cab290f06$var$POSITIONS.BOTTOM,
    size: undefined
};


$parcel$exportWildcard($914c88bdea61f2b6$exports, $f8bea99cab290f06$exports);


var $f1f82bf952edd00c$exports = {};
var $a88452d480b51f6d$exports = {};

$parcel$export($a88452d480b51f6d$exports, "ButtonSelector", function () { return $a88452d480b51f6d$export$3ba8ae974671cc59; });


var $2f44d3c803347644$exports = {};
var $e1c47a8b6d5f9c8f$exports = {};

$parcel$export($e1c47a8b6d5f9c8f$exports, "Column", function () { return $e1c47a8b6d5f9c8f$export$816b5d811295e6bc; });
$parcel$export($e1c47a8b6d5f9c8f$exports, "Row", function () { return $e1c47a8b6d5f9c8f$export$b59bdbef9ce70de2; });
$parcel$export($e1c47a8b6d5f9c8f$exports, "FlexRow", function () { return $e1c47a8b6d5f9c8f$export$210ea85e49c56827; });
$parcel$export($e1c47a8b6d5f9c8f$exports, "WindowHeightRow", function () { return $e1c47a8b6d5f9c8f$export$67a48f594b188c22; });
$parcel$export($e1c47a8b6d5f9c8f$exports, "ParentHeightRow", function () { return $e1c47a8b6d5f9c8f$export$bb829a6fc8fabbe2; });
$parcel$export($e1c47a8b6d5f9c8f$exports, "FlexColumn", function () { return $e1c47a8b6d5f9c8f$export$b1a401d0eced3e7; });
$parcel$export($e1c47a8b6d5f9c8f$exports, "WindowWidthColumn", function () { return $e1c47a8b6d5f9c8f$export$c44160ab6853d556; });
$parcel$export($e1c47a8b6d5f9c8f$exports, "ParentWidthColumn", function () { return $e1c47a8b6d5f9c8f$export$db3eb31252bfec8b; });


const $e1c47a8b6d5f9c8f$var$getMarginStyle = ({ margin: margin  })=>margin && `margin: ${margin};`;
const $e1c47a8b6d5f9c8f$var$getPaddingStyle = ({ padding: padding  })=>padding && `padding: ${padding};`;
const $e1c47a8b6d5f9c8f$var$getBackgroundColor = ({ backgroundColor: backgroundColor  })=>`background-color: ${backgroundColor || (0, $1mgSD$COLORS).BACKGROUND_COLORS.TRANSPARENT};`;
const $e1c47a8b6d5f9c8f$var$Flex = (0, $1mgSD$styledcomponents).div`
  display: flex;
  ${({ evenlySpaceContent: evenlySpaceContent  })=>evenlySpaceContent && "justify-content: space-between;"}
  ${({ noShrink: noShrink  })=>noShrink && "flex-shrink: 0;"}
  ${({ growToParent: growToParent  })=>growToParent && "flex-grow: 1;"}
  // TODO: Remove for use of growToParent
  ${({ growToParentWidth: growToParentWidth  })=>growToParentWidth && "flex-grow: 1;"}
  ${$e1c47a8b6d5f9c8f$var$getMarginStyle}
  ${$e1c47a8b6d5f9c8f$var$getPaddingStyle}
  ${$e1c47a8b6d5f9c8f$var$getBackgroundColor};
`;
const $e1c47a8b6d5f9c8f$export$816b5d811295e6bc = (0, $1mgSD$styledcomponents)($e1c47a8b6d5f9c8f$var$Flex)`
  flex-direction: column;
  > *:not(:last-child) {
    margin-bottom: ${({ spacing: spacing  })=>spacing || 0};
  }
  ${({ parentHeight: parentHeight  })=>parentHeight && "height: 100%;"}
  ${({ windowHeight: windowHeight  })=>windowHeight && "height: 100vh;"}   
  ${({ verticallyAlignContent: verticallyAlignContent  })=>verticallyAlignContent && "justify-content: center;"}
  ${({ horizontallyAlignContent: horizontallyAlignContent  })=>horizontallyAlignContent && "align-items: center;"}
  ${({ leftAlignContent: leftAlignContent  })=>leftAlignContent && "align-items: flex-start;"}
  ${({ rightAlignContent: rightAlignContent  })=>rightAlignContent && "align-items: flex-end;"}
`;
const $e1c47a8b6d5f9c8f$var$getWidthStyle = ({ evenlySizeContent: evenlySizeContent , children: children  })=>{
    return evenlySizeContent && `
  > * {
      ${"" /* @ts-expect-error children can technically be something other than an array */ }
      width: calc((100% / ${(children === null || children === void 0 ? void 0 : children.length) || 1}));
    }
`;
};
const $e1c47a8b6d5f9c8f$export$b59bdbef9ce70de2 = (0, $1mgSD$styledcomponents)($e1c47a8b6d5f9c8f$var$Flex)`
  > *:not(:last-child) {
    margin-right: ${({ spacing: spacing  })=>spacing || 0};
  }
  ${({ parentWidth: parentWidth  })=>parentWidth && "width: 100%;"}
  ${({ windowWidth: windowWidth  })=>windowWidth && "width: 100vw;"}   
  ${({ wrap: wrap  })=>wrap && "flex-wrap: wrap;"}
  ${({ verticallyAlignContent: verticallyAlignContent  })=>verticallyAlignContent && "align-items: center; height: 100%;"}
  ${({ horizontallyAlignContent: horizontallyAlignContent  })=>horizontallyAlignContent && "justify-content: center;"}
  ${({ leftAlignContent: leftAlignContent  })=>leftAlignContent && "justify-content: flex-start;"}
  ${({ rightAlignContent: rightAlignContent  })=>rightAlignContent && "justify-content: flex-end;"}
  ${$e1c47a8b6d5f9c8f$var$getWidthStyle}
`;
// Legacy Components
// TODO: Remove these legacy components after removing
// existing usages
const $e1c47a8b6d5f9c8f$export$210ea85e49c56827 = (0, $1mgSD$styledcomponents)($e1c47a8b6d5f9c8f$var$Flex)`
  flex-direction: column;
  > *:not(:last-child) {
    margin-bottom: ${({ spacing: spacing  })=>spacing || 0};
  }
  ${({ verticallyAlignContent: verticallyAlignContent  })=>verticallyAlignContent && "justify-content: center;"}
  ${({ horizontallyAlignContent: horizontallyAlignContent  })=>horizontallyAlignContent && "align-items: center;"}
  ${({ leftAlignContent: leftAlignContent  })=>leftAlignContent && "align-items: flex-start;"}
  ${({ rightAlignContent: rightAlignContent  })=>rightAlignContent && "align-items: flex-end;"}
`;
const $e1c47a8b6d5f9c8f$export$67a48f594b188c22 = (0, $1mgSD$styledcomponents)($e1c47a8b6d5f9c8f$export$210ea85e49c56827)`
  height: 100vh;
`;
const $e1c47a8b6d5f9c8f$export$bb829a6fc8fabbe2 = (0, $1mgSD$styledcomponents)($e1c47a8b6d5f9c8f$export$210ea85e49c56827)`
  height: 100%;
`;
const $e1c47a8b6d5f9c8f$var$getColumnWidthStyle = ({ evenlySizeContent: evenlySizeContent , children: children  })=>{
    return evenlySizeContent && `
  > * {
      ${"" /* @ts-expect-error children can technically be something other than an array */ }
      width: calc((100% / ${(children === null || children === void 0 ? void 0 : children.length) || 1}));
    }
`;
};
const $e1c47a8b6d5f9c8f$export$b1a401d0eced3e7 = (0, $1mgSD$styledcomponents)($e1c47a8b6d5f9c8f$var$Flex)`
  > *:not(:last-child) {
    margin-right: ${({ spacing: spacing  })=>spacing || 0};
  }
  ${({ wrap: wrap  })=>wrap && "flex-wrap: wrap;"}
  ${({ verticallyAlignContent: verticallyAlignContent  })=>verticallyAlignContent && "align-items: center; height: 100%;"}
  ${({ horizontallyAlignContent: horizontallyAlignContent  })=>horizontallyAlignContent && "justify-content: center;"}
  ${({ leftAlignContent: leftAlignContent  })=>leftAlignContent && "justify-content: flex-start;"}
  ${({ rightAlignContent: rightAlignContent  })=>rightAlignContent && "justify-content: flex-end;"}
  ${$e1c47a8b6d5f9c8f$var$getColumnWidthStyle}
`;
const $e1c47a8b6d5f9c8f$export$c44160ab6853d556 = (0, $1mgSD$styledcomponents)($e1c47a8b6d5f9c8f$export$b1a401d0eced3e7)`
  width: 100vw;
`;
const $e1c47a8b6d5f9c8f$export$db3eb31252bfec8b = (0, $1mgSD$styledcomponents)($e1c47a8b6d5f9c8f$export$b1a401d0eced3e7)`
  width: 100%;
`;


$parcel$exportWildcard($2f44d3c803347644$exports, $e1c47a8b6d5f9c8f$exports);





var $75998ca0c1da2553$exports = {};
var $2cef4ff485e6f14d$exports = {};

$parcel$export($2cef4ff485e6f14d$exports, "Button", function () { return $2cef4ff485e6f14d$export$353f5b6fc5456de1; });
$parcel$export($2cef4ff485e6f14d$exports, "getButtonColors", function () { return $2cef4ff485e6f14d$export$62e197caf5c4a718; });



const $fe72a230606ab94c$export$a5975749f0374264 = `'${(0, $1mgSD$TYPOGRAPHY).FONT.BODY.REGULAR}', sans-serif`;
const $fe72a230606ab94c$export$ed2f7e77161669d = `'${(0, $1mgSD$TYPOGRAPHY).FONT.BODY.SEMIBOLD}', sans-serif`;
const $fe72a230606ab94c$export$ff91d0cf36643325 = `'${(0, $1mgSD$TYPOGRAPHY).FONT.HEADER.SEMIBOLD}', serif`;
const $fe72a230606ab94c$export$a827189a08c5a3a3 = "normal";
const $fe72a230606ab94c$export$3eb52878e4502ad1 = "-0.02em";
const $fe72a230606ab94c$export$a6217a59b1799372 = "-0.02em";



function $2cef4ff485e6f14d$var$getBorder(props) {
    switch(props.kind){
        case "secondary":
            if (props.disabled) return `1px solid ${0, $aaac76de4690e7ff$export$1dfa4a610aaefe1}`;
            return `1px solid ${props.danger ? (0, $aaac76de4690e7ff$export$4c90220182e0b14) : (0, $aaac76de4690e7ff$export$d913daa7170c2f9f)}`;
        case "primary":
        case "tertiary":
        default:
            return "none";
    }
}
function $2cef4ff485e6f14d$var$getDisabledColors(props) {
    switch(props.kind){
        case "tertiary":
            return {
                backgroundColor: "transparent",
                color: (0, $aaac76de4690e7ff$export$1dfa4a610aaefe1)
            };
        case "secondary":
            return {
                backgroundColor: (0, $aaac76de4690e7ff$export$3b058bf22d3a92e9),
                color: (0, $aaac76de4690e7ff$export$1dfa4a610aaefe1)
            };
        case "primary":
        default:
            return {
                backgroundColor: (0, $aaac76de4690e7ff$export$545251b0d520f8ad),
                color: (0, $aaac76de4690e7ff$export$1dfa4a610aaefe1)
            };
    }
}
function $2cef4ff485e6f14d$var$getDangerColors(props) {
    switch(props.kind){
        case "tertiary":
            throw new Error("Tertiary danger button is not valid.");
        case "secondary":
            return {
                activeColor: (0, $aaac76de4690e7ff$export$ff334fa2eb55a335),
                backgroundColor: (0, $aaac76de4690e7ff$export$3b058bf22d3a92e9),
                color: (0, $aaac76de4690e7ff$export$4c90220182e0b14),
                hoverColor: (0, $aaac76de4690e7ff$export$da9db0a7af92f233)
            };
        case "primary":
        default:
            return {
                activeColor: (0, $aaac76de4690e7ff$export$af7315ffdcd84ac3),
                backgroundColor: (0, $aaac76de4690e7ff$export$4c90220182e0b14),
                color: (0, $aaac76de4690e7ff$export$3b058bf22d3a92e9),
                hoverColor: (0, $aaac76de4690e7ff$export$a9a9aec38bf931d8)
            };
    }
}
function $2cef4ff485e6f14d$var$getBaseColors(props) {
    switch(props.kind){
        case "tertiary":
            return {
                activeColor: (0, $aaac76de4690e7ff$export$3fba6270ac3a5805),
                backgroundColor: "transparent",
                color: (0, $aaac76de4690e7ff$export$d913daa7170c2f9f),
                hoverColor: (0, $aaac76de4690e7ff$export$775ceeacde47cab2)
            };
        case "secondary":
            return {
                activeColor: (0, $aaac76de4690e7ff$export$3fba6270ac3a5805),
                backgroundColor: (0, $aaac76de4690e7ff$export$3b058bf22d3a92e9),
                color: (0, $aaac76de4690e7ff$export$d913daa7170c2f9f),
                hoverColor: (0, $aaac76de4690e7ff$export$775ceeacde47cab2)
            };
        case "primary":
        default:
            return {
                activeColor: (0, $aaac76de4690e7ff$export$33af1cdf0dd1ede7),
                backgroundColor: (0, $aaac76de4690e7ff$export$b33c7b711cacd17d),
                color: (0, $aaac76de4690e7ff$export$3b058bf22d3a92e9),
                hoverColor: (0, $aaac76de4690e7ff$export$fe1c5ace6f02cfbf)
            };
    }
}
function $2cef4ff485e6f14d$var$getColors(props) {
    if (props.disabled) return $2cef4ff485e6f14d$var$getDisabledColors(props);
    if (props.danger) return $2cef4ff485e6f14d$var$getDangerColors(props);
    return $2cef4ff485e6f14d$var$getBaseColors(props);
}
function $2cef4ff485e6f14d$var$getActiveColor(props) {
    return $2cef4ff485e6f14d$var$getColors(props).activeColor;
}
function $2cef4ff485e6f14d$var$getBackgroundColor(props) {
    return $2cef4ff485e6f14d$var$getColors(props).backgroundColor;
}
function $2cef4ff485e6f14d$var$getTextColor(props) {
    return $2cef4ff485e6f14d$var$getColors(props).color;
}
function $2cef4ff485e6f14d$var$getHoverColor(props) {
    return $2cef4ff485e6f14d$var$getColors(props).hoverColor;
}
const $2cef4ff485e6f14d$export$353f5b6fc5456de1 = (0, $1mgSD$styledcomponents).button.attrs((props)=>({
        "aria-disabled": props.disabled,
        "aria-busy": props.loading
    }))`
  -webkit-font-smoothing: antialiased;
  align-items: center;
  background-color: ${(props)=>props && props.loading ? $2cef4ff485e6f14d$var$getActiveColor(props) : $2cef4ff485e6f14d$var$getBackgroundColor(props)};
  border: ${$2cef4ff485e6f14d$var$getBorder};
  border-radius: ${(0, $fd37c165946cdbcc$export$f0eadff003889631)};
  color: ${$2cef4ff485e6f14d$var$getTextColor};
  cursor: pointer;
  display: flex;
  font-family: ${(0, $fe72a230606ab94c$export$ed2f7e77161669d)};
  font-size: ${({ small: small  })=>small ? ".75rem" : ".875rem"};
  font-weight: initial;
  justify-content: center;
  line-height: ${({ small: small  })=>small ? ".9375rem" : "1.0625rem"};
  min-height: ${({ small: small  })=>small ? (0, $fd37c165946cdbcc$export$9b8cd5b0d7315663) : (0, $fd37c165946cdbcc$export$545718d17558da76)};
  padding: 0 ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  outline: 0;
  ${({ full: full  })=>full && "width: 100%;"}

  &:disabled {
    cursor: not-allowed;
  }

  &:focus&:not(:disabled) {
    background-color: ${(props)=>props && props.loading ? $2cef4ff485e6f14d$var$getActiveColor(props) : $2cef4ff485e6f14d$var$getHoverColor(props)};
  }

  &:hover&:not(:disabled) {
    background-color: ${(props)=>props && props.loading ? $2cef4ff485e6f14d$var$getActiveColor(props) : $2cef4ff485e6f14d$var$getHoverColor(props)};
  }

  &:active&:not(:disabled) {
    background-color: ${$2cef4ff485e6f14d$var$getActiveColor};
  }

  ${({ loading: loading  })=>loading && "cursor: not-allowed;"}
`;
$2cef4ff485e6f14d$export$353f5b6fc5456de1.defaultProps = {
    type: "button"
};
const $2cef4ff485e6f14d$export$62e197caf5c4a718 = $2cef4ff485e6f14d$var$getColors;


var $7865a0a530ffec11$exports = {};

$parcel$export($7865a0a530ffec11$exports, "getSpinnerStyle", function () { return $7865a0a530ffec11$export$42ce4cda9cbee2be; });
$parcel$export($7865a0a530ffec11$exports, "spinnerCss", function () { return $7865a0a530ffec11$export$c9da7f48cc950c1c; });
$parcel$export($7865a0a530ffec11$exports, "LoadingButton", function () { return $7865a0a530ffec11$export$4ec83e90d030b2f3; });




function $7865a0a530ffec11$var$noop() {}
function $7865a0a530ffec11$export$42ce4cda9cbee2be({ small: small  }) {
    if (small) return {
        bottom: "-.5rem",
        height: "1rem",
        left: "unset",
        width: "1rem"
    };
    return {
        bottom: "-.75rem",
        height: "1.5rem",
        left: "unset",
        width: "1.5rem"
    };
}
const $7865a0a530ffec11$var$spin = (0, $1mgSD$keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0.15;
  }
`;
const $7865a0a530ffec11$export$c9da7f48cc950c1c = (0, $1mgSD$css)`
  position: relative;
  > .react-spinner_bar {
    animation: ${$7865a0a530ffec11$var$spin} 1.2s linear infinite;
    border-radius: 5px;
    position: absolute;
    width: 20%;
    height: 7.8%;
    top: -3.9%;
    left: -10%;
  }
`;
const $7865a0a530ffec11$var$StyledSpinner = (0, $1mgSD$styledcomponents)((0, $1mgSD$reactspinner))`
  ${$7865a0a530ffec11$export$c9da7f48cc950c1c}

  > .react-spinner_bar {
    background-color: ${(props)=>(0, $2cef4ff485e6f14d$export$62e197caf5c4a718)(props).color};
  }
`;
const $7865a0a530ffec11$export$4ec83e90d030b2f3 = (props)=>{
    const { children: children , loading: loading , loadingText: loadingText , type: type , onClick: onClick = $7865a0a530ffec11$var$noop  } = props;
    return /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $2cef4ff485e6f14d$export$353f5b6fc5456de1), {
        ...props,
        loading: loading,
        type: type || "button",
        onClick: loading ? $7865a0a530ffec11$var$noop : onClick
    }, loading && /*#__PURE__*/ (0, $1mgSD$react).createElement($7865a0a530ffec11$var$StyledSpinner, {
        ...props,
        style: $7865a0a530ffec11$export$42ce4cda9cbee2be(props)
    }), loading ? loadingText || "Submitting..." : children);
};


var $b99f2b448f214e12$exports = {};

$parcel$export($b99f2b448f214e12$exports, "IconButton", function () { return $b99f2b448f214e12$export$c25acd513dcc8062; });





const $b99f2b448f214e12$var$IconButtonWrapper = (0, $1mgSD$styledcomponents).button`
  -webkit-font-smoothing: antialiased;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid ${({ color: color  })=>color};
  width: ${({ size: size  })=>size};
  height: ${({ size: size  })=>size};
  &:hover {
    background-color: ${({ color: color  })=>color};
    svg {
      color: ${(0, $aaac76de4690e7ff$export$3b058bf22d3a92e9)};
    }
  }
`;
const $b99f2b448f214e12$export$c25acd513dcc8062 = ({ children: children , color: color , size: size , onClick: onClick  })=>{
    return /*#__PURE__*/ $1mgSD$createElement($b99f2b448f214e12$var$IconButtonWrapper, {
        size: size,
        onClick: onClick,
        type: "button",
        color: color
    }, /*#__PURE__*/ $1mgSD$createElement((0, $e1c47a8b6d5f9c8f$export$210ea85e49c56827), {
        verticallyAlignContent: true,
        horizontallyAlignContent: true
    }, children));
};
$b99f2b448f214e12$export$c25acd513dcc8062.defaultProps = {
    onClick: ()=>{},
    size: (0, $fd37c165946cdbcc$export$70173e1228291b3c)
};


$parcel$exportWildcard($75998ca0c1da2553$exports, $2cef4ff485e6f14d$exports);
$parcel$exportWildcard($75998ca0c1da2553$exports, $7865a0a530ffec11$exports);
$parcel$exportWildcard($75998ca0c1da2553$exports, $b99f2b448f214e12$exports);



const $39bb0824f3103092$export$3cf951393a6db573 = "24px";
function $39bb0824f3103092$var$getDisabledColors(props) {
    switch(props.kind){
        case "tertiary":
            return `
        background-color: transparent,
        color: ${0, $aaac76de4690e7ff$export$1dfa4a610aaefe1},
      `;
        case "primary":
        default:
            return `
        background-color: ${0, $aaac76de4690e7ff$export$545251b0d520f8ad},
        color: ${0, $aaac76de4690e7ff$export$1dfa4a610aaefe1},
      `;
    }
}
function $39bb0824f3103092$var$getColors(props) {
    if (props.disabled) return $39bb0824f3103092$var$getDisabledColors(props);
    if (props.kind === "primary") return `
      background-color: ${0, $aaac76de4690e7ff$export$8789b5d1f1beb293};
      &:focus&:not(:disabled) {
        background-color: ${0, $aaac76de4690e7ff$export$8789b5d1f1beb293};
      }
      &:active&:not(:disabled) {
        background-color: ${0, $aaac76de4690e7ff$export$8789b5d1f1beb293};
      }
      &:hover&:not(:disabled) {
        background-color: ${0, $aaac76de4690e7ff$export$8789b5d1f1beb293};
      }
    `;
    return `
    &:hover&:not(:disabled) {
      background-color: ${0, $aaac76de4690e7ff$export$6d4bd4305d16dfab};
    }
  `;
}
const $39bb0824f3103092$export$44ec3a22a81b2461 = (0, $1mgSD$styledcomponents)((0, $2cef4ff485e6f14d$export$353f5b6fc5456de1)).attrs(()=>({
        role: "radio"
    }))`
  white-space: nowrap;
  border-radius: ${$39bb0824f3103092$export$3cf951393a6db573};
  ${$39bb0824f3103092$var$getColors}
`;


const $a88452d480b51f6d$var$StyledRow = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$b59bdbef9ce70de2))`
  background-color: ${(0, $aaac76de4690e7ff$export$87a86361d063ff10)};
  border-radius: ${(0, $39bb0824f3103092$export$3cf951393a6db573)};
  height: ${(0, $fd37c165946cdbcc$export$545718d17558da76)};
  min-width: max-content;
`;
function $a88452d480b51f6d$export$3ba8ae974671cc59({ disabled: disabled , onChange: onChange , options: options , value: controlledValue  }) {
    const isControlled = typeof controlledValue !== "undefined";
    const initialValue = isControlled ? controlledValue : options[0].value;
    const [uncontrolledValue, setUncontrolledValue] = (0, $1mgSD$useState)(initialValue);
    const selectedValue = isControlled ? controlledValue : uncontrolledValue;
    const selectorOptions = options.map((option)=>{
        const isSelected = selectedValue === option.value;
        const kind = isSelected ? "primary" : "tertiary";
        const onClick = ()=>{
            setUncontrolledValue(option.value);
            onChange(option.value);
        };
        return /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $39bb0824f3103092$export$44ec3a22a81b2461), {
            "aria-label": option.label,
            "aria-checked": isSelected,
            disabled: disabled,
            full: true,
            key: String(option.value),
            kind: kind,
            onClick: onClick
        }, option.label);
    });
    return /*#__PURE__*/ (0, $1mgSD$react).createElement($a88452d480b51f6d$var$StyledRow, {
        evenlySpaceContent: true,
        growToParentWidth: true,
        role: "radiogroup"
    }, selectorOptions);
}
$a88452d480b51f6d$export$3ba8ae974671cc59.defaultProps = {
    disabled: false,
    value: undefined
};


$parcel$exportWildcard($f1f82bf952edd00c$exports, $a88452d480b51f6d$exports);



var $905c2d2db2a42528$exports = {};
var $12b081e83e24a09b$exports = {};

$parcel$export($12b081e83e24a09b$exports, "Header", function () { return $12b081e83e24a09b$export$8b251419efc915eb; });


var $5c4c6b5a115de467$exports = {};

$parcel$export($5c4c6b5a115de467$exports, "fonts", function () { return $5c4c6b5a115de467$export$f45fbea8fe20ca8a; });
$parcel$export($5c4c6b5a115de467$exports, "palette", function () { return $5c4c6b5a115de467$export$eaad8caa32d2521d; });
$parcel$export($5c4c6b5a115de467$exports, "shadows", function () { return $5c4c6b5a115de467$export$3eb26d38a832ce9a; });
$parcel$export($5c4c6b5a115de467$exports, "spacing", function () { return $5c4c6b5a115de467$export$5458b64234d1333c; });



const $5d0b63b3a27c519d$export$1bacaec662ba54d4 = `
  0 0 0 1px rgba(147,156,163,0.1),
  0 3px 5px 0 rgba(195,207,217,0.3),
  0 5px 15px 0 rgba(195,207,217,0.3)
`;
const $5d0b63b3a27c519d$export$46d81d760d7a8a64 = `
  0 0 1px 0 rgba(131,149,163,0.1),
  0 2px 6px 0 rgba(84,102,120,0.1),
  0 5px 10px 0 rgba(84,102,120,0.2),
  0 13px 28px 0 rgba(84,102,120,0.2)
`;
const $5d0b63b3a27c519d$export$400b8f528beb1869 = (0, $1mgSD$css)`
  box-shadow: ${$5d0b63b3a27c519d$export$1bacaec662ba54d4};
`;
const $5d0b63b3a27c519d$export$f7266ad9837f2dc4 = (0, $1mgSD$css)`
  box-shadow: ${$5d0b63b3a27c519d$export$46d81d760d7a8a64};
`;



var $4195c89b4f4a4178$exports = {};

$parcel$export($4195c89b4f4a4178$exports, "sizes", function () { return $4195c89b4f4a4178$export$c647cb0ee6e282fe; });
$parcel$export($4195c89b4f4a4178$exports, "media", function () { return $4195c89b4f4a4178$export$987d49ffe1b0900f; });

const $4195c89b4f4a4178$export$c647cb0ee6e282fe = {
    smDesktop: 1200,
    tablet: 767,
    smTablet: 601,
    phone: 415
};
const $4195c89b4f4a4178$export$987d49ffe1b0900f = {
    desktop: (strings, ...interpolations)=>(0, $1mgSD$css)`
    @media (min-width: ${$4195c89b4f4a4178$export$c647cb0ee6e282fe.smDesktop + 1}px) {
      ${(0, $1mgSD$css)(strings, ...interpolations)}
    }
  `,
    smDesktop: (strings, ...interpolations)=>(0, $1mgSD$css)`
    @media (max-width: ${$4195c89b4f4a4178$export$c647cb0ee6e282fe.smDesktop}px) {
      ${(0, $1mgSD$css)(strings, ...interpolations)}
    }
  `,
    tablet: (strings, ...interpolations)=>(0, $1mgSD$css)`
    @media (max-width: ${$4195c89b4f4a4178$export$c647cb0ee6e282fe.tablet}px) {
      ${(0, $1mgSD$css)(strings, ...interpolations)}
    }
  `,
    smTablet: (strings, ...interpolations)=>(0, $1mgSD$css)`
    @media (max-width: ${$4195c89b4f4a4178$export$c647cb0ee6e282fe.smTablet}px) {
      ${(0, $1mgSD$css)(strings, ...interpolations)}
    }
  `,
    phone: (strings, ...interpolations)=>(0, $1mgSD$css)`
    @media (max-width: ${$4195c89b4f4a4178$export$c647cb0ee6e282fe.phone}px) {
      ${(0, $1mgSD$css)(strings, ...interpolations)}
    }
  `
};


const $5c4c6b5a115de467$export$f45fbea8fe20ca8a = {
    fontFamily: $fe72a230606ab94c$export$a5975749f0374264,
    fontFamilyBodySemibold: $fe72a230606ab94c$export$ed2f7e77161669d,
    fontFamilyGalaxie: $fe72a230606ab94c$export$ff91d0cf36643325,
    fontStyle: $fe72a230606ab94c$export$a827189a08c5a3a3,
    letterSpacing: $fe72a230606ab94c$export$3eb52878e4502ad1,
    letterSpacingTight: $fe72a230606ab94c$export$a6217a59b1799372
};
const $5c4c6b5a115de467$export$eaad8caa32d2521d = {
    altoColorsP1: $aaac76de4690e7ff$export$e73d0868f38cb1d,
    altoColorsP2: $aaac76de4690e7ff$export$b33c7b711cacd17d,
    altoColorsP2Hover: $aaac76de4690e7ff$export$fe1c5ace6f02cfbf,
    altoColorsP2Active: $aaac76de4690e7ff$export$33af1cdf0dd1ede7,
    altoColorsP3: $aaac76de4690e7ff$export$87a86361d063ff10,
    altoColorsP3Hover: $aaac76de4690e7ff$export$6d4bd4305d16dfab,
    altoColorsS1: $aaac76de4690e7ff$export$8789b5d1f1beb293,
    altoColorsS2: $aaac76de4690e7ff$export$d913daa7170c2f9f,
    altoColorsS2Hover: $aaac76de4690e7ff$export$775ceeacde47cab2,
    altoColorsS2Active: $aaac76de4690e7ff$export$3fba6270ac3a5805,
    altoColorsS3: $aaac76de4690e7ff$export$d64337d93117d1ad,
    altoColorsT1: $aaac76de4690e7ff$export$efbeee5f72946d45,
    altoColorsT2: $aaac76de4690e7ff$export$2cc8ba0276e7dc05,
    altoColorsT2Hover: $aaac76de4690e7ff$export$5c7005e62f2afea,
    altoColorsT2Active: $aaac76de4690e7ff$export$9d750e1fb2345249,
    altoColorsT3: $aaac76de4690e7ff$export$5057a5936ce0c0a5,
    altoColorsR1: $aaac76de4690e7ff$export$689894fd5b69c1a5,
    altoColorsR2: $aaac76de4690e7ff$export$4c90220182e0b14,
    altoColorsR2Hover: $aaac76de4690e7ff$export$a9a9aec38bf931d8,
    altoColorsR2Active: $aaac76de4690e7ff$export$af7315ffdcd84ac3,
    altoColorsR3: $aaac76de4690e7ff$export$6c9b3104157f8389,
    altoColorsR3Hover: $aaac76de4690e7ff$export$da9db0a7af92f233,
    altoColorsR3Active: $aaac76de4690e7ff$export$ff334fa2eb55a335,
    altoColorsG1: $aaac76de4690e7ff$export$df5574606a94f191,
    altoColorsG2: $aaac76de4690e7ff$export$e52bbaa2db5579b1,
    altoColorsG3: $aaac76de4690e7ff$export$7e843862c500fadd,
    altoColorsLG2: $aaac76de4690e7ff$export$fc4f51108032ddec,
    altoColorsLG3: $aaac76de4690e7ff$export$df987b01b59e4e45,
    altoColorsY1: $aaac76de4690e7ff$export$eafd9d6862ca17a9,
    altoColorsY2: $aaac76de4690e7ff$export$a407bb5b45f88e9f,
    altoColorsY3: $aaac76de4690e7ff$export$f8a16a30e3179648,
    altoColorsY3Transparent: $aaac76de4690e7ff$export$5785ba937f4c5d42,
    altoColorsO3: $aaac76de4690e7ff$export$55064c834975c010,
    altoColorsB1: $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f,
    altoColorsB2: $aaac76de4690e7ff$export$7b1dbb1d9e615f91,
    altoColorsB3: $aaac76de4690e7ff$export$abc95940fda32f98,
    altoColorsB4: $aaac76de4690e7ff$export$1dfa4a610aaefe1,
    altoColorsB5: $aaac76de4690e7ff$export$545251b0d520f8ad,
    altoColorsB6: $aaac76de4690e7ff$export$40e746099f73c094,
    altoColorsB7: $aaac76de4690e7ff$export$ed73c413f4c945c9,
    altoColorsB12: $aaac76de4690e7ff$export$ea856c4df433fa56,
    altoColorsWB1: $aaac76de4690e7ff$export$91270c6916e25d70,
    altoColorsWB2: $aaac76de4690e7ff$export$6206133e1543f249,
    altoColorsWB3: $aaac76de4690e7ff$export$76ad689e70c7691d,
    altoColorsW: $aaac76de4690e7ff$export$3b058bf22d3a92e9,
    altoColorsHighlight: $aaac76de4690e7ff$export$f858cd7b6506d226,
    lightNavy: $aaac76de4690e7ff$export$3209604dab7b9537,
    royalBlue: $aaac76de4690e7ff$export$2ad0c329ccd958f8,
    teal: $aaac76de4690e7ff$export$8bf7dff220b82b4a,
    lightTeal: $aaac76de4690e7ff$export$6d8f981b04aed00b,
    yellow: $aaac76de4690e7ff$export$594c5a8758200c32,
    lightYellow: $aaac76de4690e7ff$export$2f350c514d155d6c,
    red: $aaac76de4690e7ff$export$a90204d1394caf30,
    lightRed: $aaac76de4690e7ff$export$2f95049e6b041020,
    darkNavy: $aaac76de4690e7ff$export$9fc8e71a68236410,
    navy: $aaac76de4690e7ff$export$54a390250b5a3226,
    navyTint1: $aaac76de4690e7ff$export$141f6f97ca17eff0,
    navyTint2: $aaac76de4690e7ff$export$d36ef3fb6733a582,
    royal1: $aaac76de4690e7ff$export$4b03d8f78bb232ec,
    warmGrey: $aaac76de4690e7ff$export$3c81d76652c0ee8d,
    black1: $aaac76de4690e7ff$export$cb81ca6e31dfb4ee,
    grey1: $aaac76de4690e7ff$export$26de6a0f89719481,
    grey2: $aaac76de4690e7ff$export$15e963ace12d673f,
    white: $aaac76de4690e7ff$export$8fa4e5556fd77a60,
    dividerGrey: $aaac76de4690e7ff$export$b44088c8267d4ac8,
    teal1: $aaac76de4690e7ff$export$5b28b8c0b3900263,
    teal2: $aaac76de4690e7ff$export$6005560f036eee53,
    yellow1: $aaac76de4690e7ff$export$6b4b2f601e928a30,
    yellow2: $aaac76de4690e7ff$export$42bbe197447f32ff,
    red1: $aaac76de4690e7ff$export$338a087f70a8f978,
    red2: $aaac76de4690e7ff$export$83bd2a8eab79c8b7,
    citrus: $aaac76de4690e7ff$export$9c1c8f508a671b92,
    darkCitrus: $aaac76de4690e7ff$export$3d1aee436109f0d0,
    citrusTint2: $aaac76de4690e7ff$export$30eb1f683e21ee98,
    orangeTint2: $aaac76de4690e7ff$export$5bf79effc7eac03b
};
const $5c4c6b5a115de467$export$3eb26d38a832ce9a = {
    boxShadow1: $5d0b63b3a27c519d$export$400b8f528beb1869,
    boxShadow1Raw: $5d0b63b3a27c519d$export$1bacaec662ba54d4,
    boxShadow2: $5d0b63b3a27c519d$export$f7266ad9837f2dc4,
    boxShadow2Raw: $5d0b63b3a27c519d$export$46d81d760d7a8a64
};
const $5c4c6b5a115de467$export$5458b64234d1333c = {
    borderRadius: $fd37c165946cdbcc$export$7a57f79000377ca2,
    borderWidth: $fd37c165946cdbcc$export$12879c7697ed953d,
    buttonBorderRadius: $fd37c165946cdbcc$export$f0eadff003889631,
    containerBorderRadius: $fd37c165946cdbcc$export$efa65fa1092f7420,
    lgSpacing: $fd37c165946cdbcc$export$9b8cd5b0d7315663,
    mdSpacing: $fd37c165946cdbcc$export$70173e1228291b3c,
    smSpacing: $fd37c165946cdbcc$export$54c7853c55b55e72,
    xlSpacing: $fd37c165946cdbcc$export$545718d17558da76,
    xsSpacing: $fd37c165946cdbcc$export$79a18a7d58eb5909,
    xxlSpacing: $fd37c165946cdbcc$export$c34a6c87634beb3f,
    xxsSpacing: $fd37c165946cdbcc$export$4c16e5a80ec60b32
};
$parcel$exportWildcard($5c4c6b5a115de467$exports, $4195c89b4f4a4178$exports);




var $e1ec4f377287ccce$exports = {};
var $c82a557ce75f4fea$exports = {};

$parcel$export($c82a557ce75f4fea$exports, "Danger", function () { return $c82a557ce75f4fea$export$95d05bdc75950145; });

var $5c5b602ecf9ac4bf$exports = {};

$parcel$export($5c5b602ecf9ac4bf$exports, "Span", function () { return $5c5b602ecf9ac4bf$export$5f1714a13ed34c01; });
$parcel$export($5c5b602ecf9ac4bf$exports, "Paragraph", function () { return $5c5b602ecf9ac4bf$export$358a232cca1ab2ac; });
$parcel$export($5c5b602ecf9ac4bf$exports, "Text", function () { return $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6; });




function $5c5b602ecf9ac4bf$var$getColor({ active: active , currency: currency , danger: danger , light: light , success: success , warning: warning  }) {
    if (currency) return 0, $aaac76de4690e7ff$export$efbeee5f72946d45;
    if (success) return 0, $aaac76de4690e7ff$export$e52bbaa2db5579b1;
    if (warning) return 0, $aaac76de4690e7ff$export$eafd9d6862ca17a9;
    if (danger) return 0, $aaac76de4690e7ff$export$4c90220182e0b14;
    if (light) return 0, $aaac76de4690e7ff$export$abc95940fda32f98;
    if (active) return 0, $aaac76de4690e7ff$export$d913daa7170c2f9f;
    return 0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f;
}
const $5c5b602ecf9ac4bf$var$textMixin = (0, $1mgSD$css)`
  -webkit-font-smoothing: antialiased;
  color: ${$5c5b602ecf9ac4bf$var$getColor};
  font-family: ${({ bold: bold  })=>bold ? (0, $fe72a230606ab94c$export$ed2f7e77161669d) : (0, $fe72a230606ab94c$export$a5975749f0374264)};
  font-size: ${({ small: small  })=>small ? ".875rem" : "1rem"};
  font-weight: initial;
  line-height: ${({ short: short  })=>short ? "1.125rem" : "1.5rem"};
  min-height: ${({ short: short  })=>short ? "1.125rem" : "1.5rem"};
  margin: 0;
  ${({ multiLine: multiLine  })=>multiLine && "white-space: pre;"}
  ${({ center: center  })=>center && "text-align: center;"}
`;
const $5c5b602ecf9ac4bf$export$5f1714a13ed34c01 = (0, $1mgSD$styledcomponents).span`
  ${$5c5b602ecf9ac4bf$var$textMixin}
`;
const $5c5b602ecf9ac4bf$export$358a232cca1ab2ac = (0, $1mgSD$styledcomponents).p`
  ${$5c5b602ecf9ac4bf$var$textMixin}
`;
const $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6 = ({ inline: inline , ...props })=>inline ? /*#__PURE__*/ (0, $1mgSD$react).createElement($5c5b602ecf9ac4bf$export$5f1714a13ed34c01, props) : /*#__PURE__*/ (0, $1mgSD$react).createElement($5c5b602ecf9ac4bf$export$358a232cca1ab2ac, props);
$5c5b602ecf9ac4bf$export$5f1af8db9871e1d6.defaultProps = {
    active: false,
    bold: false,
    center: false,
    children: null,
    currency: false,
    danger: false,
    inline: false,
    light: false,
    small: false,
    short: false,
    success: false,
    warning: false,
    multiLine: false
};


const $c82a557ce75f4fea$export$95d05bdc75950145 = (props)=>/*#__PURE__*/ (0, $1mgSD$react).createElement((0, $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6), {
        short: true,
        small: true,
        danger: true,
        ...props
    });


var $40d88124347685f5$exports = {};

$parcel$export($40d88124347685f5$exports, "H1", function () { return $40d88124347685f5$export$5523b16adee8048; });






const $40d88124347685f5$var$StyledH1 = (0, $1mgSD$styledcomponents).h1`
  -webkit-font-smoothing: antialiased;
  color: ${({ light: light  })=>light ? (0, $aaac76de4690e7ff$export$abc95940fda32f98) : (0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f)};
  font-family: ${(0, $fe72a230606ab94c$export$ff91d0cf36643325)};
  font-size: ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)};
  font-weight: initial;
  line-height: ${(0, $fd37c165946cdbcc$export$9b8cd5b0d7315663)};
  letter-spacing: ${(0, $fe72a230606ab94c$export$3eb52878e4502ad1)};
  margin: 0;
  min-height: ${(0, $fd37c165946cdbcc$export$9b8cd5b0d7315663)};
  ${({ announceToScreenReader: announceToScreenReader  })=>announceToScreenReader ? "outline: 0;" : ""}
`;
var $40d88124347685f5$var$_PureComponent;
class $40d88124347685f5$var$BasicH1 extends ($40d88124347685f5$var$_PureComponent = (0, $1mgSD$react).PureComponent) {
    componentDidMount() {
        var ref;
        const { announceToScreenReader: announceToScreenReader  } = this.props;
        if (announceToScreenReader && ((ref = this.h1Ref) === null || ref === void 0 ? void 0 : ref.current)) this.h1Ref.current.focus();
    }
    render() {
        const { forwardedRef: forwardedRef , announceToScreenReader: announceToScreenReader  } = this.props;
        if (announceToScreenReader) return /*#__PURE__*/ (0, $1mgSD$react).createElement($40d88124347685f5$var$StyledH1, {
            role: "heading",
            "aria-level": 1,
            "tab-index": "-1",
            ref: this.h1Ref,
            ...this.props
        });
        if (forwardedRef) return /*#__PURE__*/ (0, $1mgSD$react).createElement($40d88124347685f5$var$StyledH1, {
            ref: forwardedRef,
            ...this.props
        });
        return /*#__PURE__*/ (0, $1mgSD$react).createElement($40d88124347685f5$var$StyledH1, this.props);
    }
    constructor(props){
        super(props);
        const { announceToScreenReader: announceToScreenReader  } = this.props;
        if (announceToScreenReader) this.h1Ref = /*#__PURE__*/ (0, $1mgSD$react).createRef();
    }
}
(0, $1mgSD$swchelperslib_define_propertyjs)($40d88124347685f5$var$BasicH1, "defaultProps", {
    light: false,
    announceToScreenReader: false,
    forwardedRef: null
});
const $40d88124347685f5$export$5523b16adee8048 = /*#__PURE__*/ (0, $1mgSD$react).forwardRef((props, ref)=>/*#__PURE__*/ (0, $1mgSD$react).createElement($40d88124347685f5$var$BasicH1, {
        forwardedRef: ref,
        ...props
    }, props.children));


var $66e82a5fe7a0e0ea$exports = {};

$parcel$export($66e82a5fe7a0e0ea$exports, "H2", function () { return $66e82a5fe7a0e0ea$export$cb94397127ac9363; });




const $66e82a5fe7a0e0ea$export$cb94397127ac9363 = (0, $1mgSD$styledcomponents).h2`
  -webkit-font-smoothing: antialiased;
  color: ${({ light: light  })=>light ? (0, $aaac76de4690e7ff$export$abc95940fda32f98) : (0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f)};
  font-family: ${(0, $fe72a230606ab94c$export$ed2f7e77161669d)};
  font-size: ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)};
  font-weight: initial;
  line-height: ${(0, $fd37c165946cdbcc$export$9b8cd5b0d7315663)};
  min-height: ${(0, $fd37c165946cdbcc$export$9b8cd5b0d7315663)};
  margin: 0;
`;


var $a65c84ab085b2e8e$exports = {};

$parcel$export($a65c84ab085b2e8e$exports, "H3", function () { return $a65c84ab085b2e8e$export$746be9e3a3dfff1f; });






const $a65c84ab085b2e8e$var$StyledH3 = (0, $1mgSD$styledcomponents).h3`
  -webkit-font-smoothing: antialiased;
  color: ${({ light: light  })=>light ? (0, $aaac76de4690e7ff$export$abc95940fda32f98) : (0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f)};
  font-family: ${(0, $fe72a230606ab94c$export$ed2f7e77161669d)};
  font-size: 1.125rem;
  font-weight: initial;
  line-height: ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)};
  margin: 0;
  min-height: ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)};
  ${({ announceToScreenReader: announceToScreenReader  })=>announceToScreenReader ? "outline: 0;" : ""}
`;
var $a65c84ab085b2e8e$var$_PureComponent;
class $a65c84ab085b2e8e$var$BasicH3 extends ($a65c84ab085b2e8e$var$_PureComponent = (0, $1mgSD$react).PureComponent) {
    componentDidMount() {
        var ref;
        const { announceToScreenReader: announceToScreenReader  } = this.props;
        if (announceToScreenReader && ((ref = this.h3Ref) === null || ref === void 0 ? void 0 : ref.current)) this.h3Ref.current.focus();
    }
    render() {
        const { forwardedRef: forwardedRef , announceToScreenReader: announceToScreenReader  } = this.props;
        if (announceToScreenReader) return /*#__PURE__*/ (0, $1mgSD$react).createElement($a65c84ab085b2e8e$var$StyledH3, {
            role: "heading",
            "aria-level": 3,
            "tab-index": "-1",
            ref: this.h3Ref,
            ...this.props
        });
        if (forwardedRef) return /*#__PURE__*/ (0, $1mgSD$react).createElement($a65c84ab085b2e8e$var$StyledH3, {
            ref: forwardedRef,
            ...this.props
        });
        return /*#__PURE__*/ (0, $1mgSD$react).createElement($a65c84ab085b2e8e$var$StyledH3, this.props);
    }
    constructor(props){
        super(props);
        const { announceToScreenReader: announceToScreenReader  } = this.props;
        if (announceToScreenReader) this.h3Ref = /*#__PURE__*/ (0, $1mgSD$react).createRef();
    }
}
(0, $1mgSD$swchelperslib_define_propertyjs)($a65c84ab085b2e8e$var$BasicH3, "defaultProps", {
    light: false,
    forwardedRef: null,
    announceToScreenReader: false
});
const $a65c84ab085b2e8e$export$746be9e3a3dfff1f = /*#__PURE__*/ (0, $1mgSD$react).forwardRef((props, ref)=>/*#__PURE__*/ (0, $1mgSD$react).createElement($a65c84ab085b2e8e$var$BasicH3, {
        forwardedRef: ref,
        ...props
    }, props.children));


var $ebd2ff14df5e4ed4$exports = {};

$parcel$export($ebd2ff14df5e4ed4$exports, "H4", function () { return $ebd2ff14df5e4ed4$export$cc5e069d64fda823; });




const $ebd2ff14df5e4ed4$export$cc5e069d64fda823 = (0, $1mgSD$styledcomponents).h4`
  -webkit-font-smoothing: antialiased;
  color: ${({ light: light  })=>light ? (0, $aaac76de4690e7ff$export$abc95940fda32f98) : (0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f)};
  font-family: ${(0, $fe72a230606ab94c$export$ed2f7e77161669d)};
  font-size: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  font-weight: initial;
  line-height: ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)};
  margin: 0;
  min-height: ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)};
`;


var $7c81b819332fca34$exports = {};

$parcel$export($7c81b819332fca34$exports, "H5", function () { return $7c81b819332fca34$export$88ef9fdaf11f7a1f; });




const $7c81b819332fca34$export$88ef9fdaf11f7a1f = (0, $1mgSD$styledcomponents).h5`
  -webkit-font-smoothing: antialiased;
  color: ${({ light: light  })=>light ? (0, $aaac76de4690e7ff$export$abc95940fda32f98) : (0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f)};
  font-family: ${(0, $fe72a230606ab94c$export$ed2f7e77161669d)};
  font-size: 0.875rem;
  font-weight: initial;
  line-height: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  margin: 0;
  min-height: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
`;


var $7c7949b58e9af13d$exports = {};

$parcel$export($7c7949b58e9af13d$exports, "InfoText", function () { return $7c7949b58e9af13d$export$ed2cd9eb2d1973f0; });


const $7c7949b58e9af13d$export$ed2cd9eb2d1973f0 = (props)=>/*#__PURE__*/ (0, $1mgSD$react).createElement((0, $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6), {
        light: true,
        short: true,
        small: true,
        ...props
    });


var $557c3ea4bde01476$exports = {};

$parcel$export($557c3ea4bde01476$exports, "Label", function () { return $557c3ea4bde01476$export$b04be29aa201d4f5; });




const $557c3ea4bde01476$export$b04be29aa201d4f5 = (0, $1mgSD$styledcomponents).label`
  -webkit-font-smoothing: antialiased;
  color: ${({ light: light  })=>light ? (0, $aaac76de4690e7ff$export$abc95940fda32f98) : (0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f)};
  display: inline-block;
  font-family: ${(0, $fe72a230606ab94c$export$ed2f7e77161669d)};
  font-size: 0.875rem;
  font-weight: initial;
  line-height: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  margin: 0;
  min-height: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
`;


var $637b1423c417142a$exports = {};

$parcel$export($637b1423c417142a$exports, "Link", function () { return $637b1423c417142a$export$a6c7ac8248d6e38a; });



const $637b1423c417142a$export$a6c7ac8248d6e38a = (0, $1mgSD$styledcomponents).a`
  -webkit-font-smoothing: antialiased;
  color: ${(0, $aaac76de4690e7ff$export$d913daa7170c2f9f)};
  cursor: pointer;
  display: inline-block;
  font-family: ${(0, $fe72a230606ab94c$export$ed2f7e77161669d)};
  font-size: ${({ small: small  })=>small ? ".75rem" : "1rem"};
  font-weight: initial;
  line-height: ${({ small: small  })=>small ? "1rem" : "1.5rem"};
  min-height: ${({ small: small  })=>small ? "1rem" : "1.5rem"};
  text-decoration: none;
  text-transform: ${({ small: small  })=>small ? "uppercase" : "none"};

  &:hover {
    color: ${(0, $aaac76de4690e7ff$export$fe1c5ace6f02cfbf)};
  }
  &:active {
    color: ${(0, $aaac76de4690e7ff$export$b33c7b711cacd17d)};
  }
`;



$parcel$exportWildcard($e1ec4f377287ccce$exports, $c82a557ce75f4fea$exports);
$parcel$exportWildcard($e1ec4f377287ccce$exports, $40d88124347685f5$exports);
$parcel$exportWildcard($e1ec4f377287ccce$exports, $66e82a5fe7a0e0ea$exports);
$parcel$exportWildcard($e1ec4f377287ccce$exports, $a65c84ab085b2e8e$exports);
$parcel$exportWildcard($e1ec4f377287ccce$exports, $ebd2ff14df5e4ed4$exports);
$parcel$exportWildcard($e1ec4f377287ccce$exports, $7c81b819332fca34$exports);
$parcel$exportWildcard($e1ec4f377287ccce$exports, $7c7949b58e9af13d$exports);
$parcel$exportWildcard($e1ec4f377287ccce$exports, $557c3ea4bde01476$exports);
$parcel$exportWildcard($e1ec4f377287ccce$exports, $637b1423c417142a$exports);
$parcel$exportWildcard($e1ec4f377287ccce$exports, $5c5b602ecf9ac4bf$exports);



const $12b081e83e24a09b$var$StyledRow = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$b59bdbef9ce70de2))`
  position: relative;
  background-color: ${({ color: color  })=>color};
  justify-content: center;
`;
const $12b081e83e24a09b$var$StyledIconContainer = (0, $1mgSD$styledcomponents).div`
  position: absolute;
  color: ${({ color: color  })=>color};
`;
const $12b081e83e24a09b$var$LeftIconContainer = (0, $1mgSD$styledcomponents)($12b081e83e24a09b$var$StyledIconContainer)`
  left: ${(0, $fd37c165946cdbcc$export$79a18a7d58eb5909)};
`;
const $12b081e83e24a09b$var$RightIconContainer = (0, $1mgSD$styledcomponents)($12b081e83e24a09b$var$StyledIconContainer)`
  right: ${(0, $fd37c165946cdbcc$export$79a18a7d58eb5909)};
`;
const $12b081e83e24a09b$var$StyledH4 = (0, $1mgSD$styledcomponents)((0, $ebd2ff14df5e4ed4$export$cc5e069d64fda823))`
  margin: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)} auto;
  color: ${({ color: color  })=>color};
`;
const $12b081e83e24a09b$var$StyledChildren = (0, $1mgSD$styledcomponents).span`
  margin: auto;
`;
const $12b081e83e24a09b$export$8b251419efc915eb = ({ backgroundColor: backgroundColor , color: color , title: title , leftIcon: leftIcon , leftOnClick: leftOnClick , rightIcon: rightIcon , rightOnClick: rightOnClick , children: children  })=>/*#__PURE__*/ $1mgSD$createElement($12b081e83e24a09b$var$StyledRow, {
        growToParent: true,
        color: (0, $5c4c6b5a115de467$export$eaad8caa32d2521d)[backgroundColor],
        verticallyAlignContent: true
    }, leftIcon && /*#__PURE__*/ $1mgSD$createElement($12b081e83e24a09b$var$LeftIconContainer, {
        color: (0, $5c4c6b5a115de467$export$eaad8caa32d2521d)[color],
        onClick: leftOnClick
    }, leftIcon), rightIcon && /*#__PURE__*/ $1mgSD$createElement($12b081e83e24a09b$var$RightIconContainer, {
        color: (0, $5c4c6b5a115de467$export$eaad8caa32d2521d)[color],
        onClick: rightOnClick
    }, rightIcon), /*#__PURE__*/ $1mgSD$createElement((0, $e1c47a8b6d5f9c8f$export$b59bdbef9ce70de2), {
        spacing: (0, $fd37c165946cdbcc$export$4c16e5a80ec60b32)
    }, /*#__PURE__*/ $1mgSD$createElement($12b081e83e24a09b$var$StyledH4, {
        color: (0, $5c4c6b5a115de467$export$eaad8caa32d2521d)[color]
    }, title), children && /*#__PURE__*/ $1mgSD$createElement($12b081e83e24a09b$var$StyledChildren, null, children)));
$12b081e83e24a09b$export$8b251419efc915eb.defaultProps = {
    backgroundColor: (0, $aaac76de4690e7ff$export$3b058bf22d3a92e9),
    color: (0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f),
    leftIcon: undefined,
    leftOnClick: undefined,
    rightIcon: undefined,
    rightOnClick: undefined,
    children: undefined
};


$parcel$exportWildcard($905c2d2db2a42528$exports, $12b081e83e24a09b$exports);


var $ebde5abb93da027d$exports = {};
var $10ede891be2e50f8$exports = {};

$parcel$export($10ede891be2e50f8$exports, "ActionCard", function () { return $10ede891be2e50f8$export$e1abe0f3fc33f39e; });




var $4c66280bc58b30dd$exports = {};

$parcel$export($4c66280bc58b30dd$exports, "Card", function () { return $4c66280bc58b30dd$export$60332b2344f7fe41; });



const $4c66280bc58b30dd$export$60332b2344f7fe41 = (0, $1mgSD$styledcomponents).div`
  padding: ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)} ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  background-color: ${(0, $aaac76de4690e7ff$export$ed73c413f4c945c9)};
`;


function $10ede891be2e50f8$var$getBackgroundColor({ grey: grey  }) {
    if (grey) return 0, $aaac76de4690e7ff$export$545251b0d520f8ad;
    return 0, $aaac76de4690e7ff$export$3b058bf22d3a92e9;
}
function $10ede891be2e50f8$var$getStatusIndicatorColor({ danger: danger , success: success  }) {
    if (danger) return 0, $aaac76de4690e7ff$export$4c90220182e0b14;
    if (success) return 0, $aaac76de4690e7ff$export$e52bbaa2db5579b1;
    return 0, $aaac76de4690e7ff$export$3b058bf22d3a92e9;
}
function $10ede891be2e50f8$var$getHeaderTextColor({ danger: danger , success: success  }) {
    if (danger) return 0, $aaac76de4690e7ff$export$4c90220182e0b14;
    if (success) return 0, $aaac76de4690e7ff$export$e52bbaa2db5579b1;
    return "";
}
const $10ede891be2e50f8$var$greyColorStyle = `color: ${(0, $aaac76de4690e7ff$export$abc95940fda32f98)};`;
const $10ede891be2e50f8$var$getHeaderTextColorStyle = (props)=>`color: ${$10ede891be2e50f8$var$getHeaderTextColor(props)};`;
const $10ede891be2e50f8$var$StyledCard = (0, $1mgSD$styledcomponents)((0, $4c66280bc58b30dd$export$60332b2344f7fe41))`
  background-color: ${$10ede891be2e50f8$var$getBackgroundColor};
  padding: 0;
  position: relative;
  cursor: ${({ onClick: onClick  })=>onClick ? "pointer" : "default"};
  .action-card-body {
    ${({ collapsed: collapsed  })=>collapsed && "display: none;"}
  }
  > *,
  p {
    ${({ grey: grey  })=>grey && $10ede891be2e50f8$var$greyColorStyle}
  }
  .action-card-header * {
    ${({ collapsed: collapsed , ...props })=>!collapsed && $10ede891be2e50f8$var$getHeaderTextColorStyle(props)}
  }
`;
const $10ede891be2e50f8$var$LeftStatusIndicator = (0, $1mgSD$styledcomponents).div`
  background-color: ${$10ede891be2e50f8$var$getStatusIndicatorColor};
  bottom: 0;
  left: 0;
  position: absolute;
  top: 0;
  width: ${(0, $fd37c165946cdbcc$export$79a18a7d58eb5909)};
`;
const $10ede891be2e50f8$export$e1abe0f3fc33f39e = ({ children: children , className: className , collapsed: collapsed , danger: danger , grey: grey , success: success , onClick: onClick  })=>{
    return /*#__PURE__*/ $1mgSD$createElement($10ede891be2e50f8$var$StyledCard, {
        className: className,
        collapsed: collapsed,
        danger: danger,
        grey: grey,
        success: success,
        onClick: onClick,
        // @ts-expect-error the following are all likely wrong but we shouldn't remove without verifying
        evenlySizeContent: true,
        spacing: (0, $fd37c165946cdbcc$export$79a18a7d58eb5909),
        growToParent: true,
        verticallyAlignContent: true
    }, (danger || success) && /*#__PURE__*/ $1mgSD$createElement($10ede891be2e50f8$var$LeftStatusIndicator, {
        danger: danger,
        success: success
    }), children);
};
$10ede891be2e50f8$export$e1abe0f3fc33f39e.defaultProps = {
    children: null,
    className: undefined,
    collapsed: undefined,
    danger: undefined,
    grey: undefined,
    success: undefined,
    onClick: undefined
};


var $d1838b596c71cd06$exports = {};

$parcel$export($d1838b596c71cd06$exports, "ActionCardBody", function () { return $d1838b596c71cd06$export$29b0d7e0ab5d250a; });



const $d1838b596c71cd06$var$StyledDiv = (0, $1mgSD$styledcomponents).div`
  .action-card-body-section:not(:first-child) {
    border-top: 1px solid ${(0, $aaac76de4690e7ff$export$545251b0d520f8ad)};
  }
`;
const $d1838b596c71cd06$export$29b0d7e0ab5d250a = ({ children: children , className: className  })=>{
    return /*#__PURE__*/ $1mgSD$createElement($d1838b596c71cd06$var$StyledDiv, {
        className: `action-card-body ${className || ""}`
    }, children);
};
$d1838b596c71cd06$export$29b0d7e0ab5d250a.defaultProps = {
    children: null,
    className: undefined
};


var $e4189bdaac4c4d3f$exports = {};

$parcel$export($e4189bdaac4c4d3f$exports, "ActionCardBodySection", function () { return $e4189bdaac4c4d3f$export$3e0e9cfc44d80ea2; });



const $e4189bdaac4c4d3f$var$getPaddingStyle = ({ padding: padding  })=>`padding: ${padding || (0, $fd37c165946cdbcc$export$54c7853c55b55e72)};`;
const $e4189bdaac4c4d3f$var$StyledDiv = (0, $1mgSD$styledcomponents).div`
  ${$e4189bdaac4c4d3f$var$getPaddingStyle}
  &:first-child {
    padding-top: 0;
  }
`;
const $e4189bdaac4c4d3f$export$3e0e9cfc44d80ea2 = ({ children: children , className: className , padding: padding  })=>{
    return /*#__PURE__*/ $1mgSD$createElement($e4189bdaac4c4d3f$var$StyledDiv, {
        className: `action-card-body-section ${className || ""}`,
        padding: padding
    }, children);
};
$e4189bdaac4c4d3f$export$3e0e9cfc44d80ea2.defaultProps = {
    children: null,
    className: undefined,
    padding: undefined
};


var $4acf5fc835d21075$exports = {};

$parcel$export($4acf5fc835d21075$exports, "ActionCardHeader", function () { return $4acf5fc835d21075$export$3607f7b79c644a3c; });






function $4acf5fc835d21075$var$getColor({ danger: danger , grey: grey , success: success  }) {
    if (grey) return 0, $aaac76de4690e7ff$export$abc95940fda32f98;
    if (danger || success) return 0, $aaac76de4690e7ff$export$3b058bf22d3a92e9;
    return 0, $aaac76de4690e7ff$export$abc95940fda32f98;
}
function $4acf5fc835d21075$var$getBackgroundColor({ danger: danger , grey: grey , success: success  }) {
    if (grey) return 0, $aaac76de4690e7ff$export$545251b0d520f8ad;
    if (danger) return 0, $aaac76de4690e7ff$export$4c90220182e0b14;
    if (success) return 0, $aaac76de4690e7ff$export$e52bbaa2db5579b1;
    return "";
}
const $4acf5fc835d21075$var$StyledRow = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$b59bdbef9ce70de2))`
  background-color: ${$4acf5fc835d21075$var$getBackgroundColor};
  padding: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  * {
    color: ${$4acf5fc835d21075$var$getColor};
  }
`;
const $4acf5fc835d21075$var$StyledText = (0, $1mgSD$styledcomponents)((0, $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6))`
  color: ${$4acf5fc835d21075$var$getColor};
  flex: 1;
`;
const $4acf5fc835d21075$export$3607f7b79c644a3c = ({ className: className , danger: danger , grey: grey , leftIcon: leftIcon , renderActions: renderActions , rightIcon: rightIcon , success: success , title: title  })=>{
    return /*#__PURE__*/ $1mgSD$createElement($4acf5fc835d21075$var$StyledRow, {
        className: `action-card-header ${className || ""}`,
        danger: danger,
        evenlySizeContent: true,
        grey: grey,
        growToParent: true,
        leftIcon: leftIcon,
        rightIcon: rightIcon,
        spacing: (0, $fd37c165946cdbcc$export$79a18a7d58eb5909),
        success: success,
        verticallyAlignContent: true
    }, !!leftIcon && leftIcon, /*#__PURE__*/ $1mgSD$createElement($4acf5fc835d21075$var$StyledText, {
        danger: danger,
        grey: grey,
        success: success
    }, title), !!rightIcon && rightIcon, !!renderActions && renderActions());
};
$4acf5fc835d21075$export$3607f7b79c644a3c.defaultProps = {
    className: undefined,
    danger: undefined,
    grey: undefined,
    leftIcon: undefined,
    renderActions: undefined,
    rightIcon: undefined,
    success: undefined,
    title: undefined
};



var $26ecfcbf18b1fb5d$exports = {};

$parcel$export($26ecfcbf18b1fb5d$exports, "TaskActionCard", function () { return $26ecfcbf18b1fb5d$export$3597e8e6c4686a02; });







const $26ecfcbf18b1fb5d$var$StyledH4 = (0, $1mgSD$styledcomponents)((0, $ebd2ff14df5e4ed4$export$cc5e069d64fda823))`
  color: ${(0, $aaac76de4690e7ff$export$abc95940fda32f98)};
`;
const $26ecfcbf18b1fb5d$var$StyledIconContainer = (0, $1mgSD$styledcomponents).div`
  color: ${(0, $aaac76de4690e7ff$export$abc95940fda32f98)};
`;
function $26ecfcbf18b1fb5d$export$3597e8e6c4686a02({ actionIcon: actionIcon , actionText: actionText , primaryInfo: primaryInfo , secondaryInfo: secondaryInfo , tertiaryInfo: tertiaryInfo  }) {
    return /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $4c66280bc58b30dd$export$60332b2344f7fe41), null, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e1c47a8b6d5f9c8f$export$816b5d811295e6bc), {
        spacing: (0, $fd37c165946cdbcc$export$54c7853c55b55e72)
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e1c47a8b6d5f9c8f$export$b59bdbef9ce70de2), {
        verticallyAlignContent: true,
        spacing: (0, $fd37c165946cdbcc$export$79a18a7d58eb5909)
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement($26ecfcbf18b1fb5d$var$StyledIconContainer, null, actionIcon), /*#__PURE__*/ (0, $1mgSD$react).createElement($26ecfcbf18b1fb5d$var$StyledH4, null, actionText)), /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e1c47a8b6d5f9c8f$export$816b5d811295e6bc), null, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $66e82a5fe7a0e0ea$export$cb94397127ac9363), null, primaryInfo), !!secondaryInfo && /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $ebd2ff14df5e4ed4$export$cc5e069d64fda823), null, secondaryInfo)), !!tertiaryInfo && /*#__PURE__*/ (0, $1mgSD$react).createElement($26ecfcbf18b1fb5d$var$StyledH4, null, tertiaryInfo)));
}
$26ecfcbf18b1fb5d$export$3597e8e6c4686a02.defaultProps = {
    secondaryInfo: undefined,
    tertiaryInfo: undefined
};


var $eea8a5efeb78e831$exports = {};

$parcel$export($eea8a5efeb78e831$exports, "CardContainer", function () { return $eea8a5efeb78e831$export$8a23e74e5cf3ca41; });





const $eea8a5efeb78e831$var$StyledColumn = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$816b5d811295e6bc))`
  background-color: ${(0, $aaac76de4690e7ff$export$91270c6916e25d70)};
`;
function $eea8a5efeb78e831$export$8a23e74e5cf3ca41({ children: children  }) {
    return /*#__PURE__*/ (0, $1mgSD$react).createElement($eea8a5efeb78e831$var$StyledColumn, {
        spacing: (0, $fd37c165946cdbcc$export$4c16e5a80ec60b32)
    }, children);
}


var $a26a549454f77336$exports = {};

$parcel$export($a26a549454f77336$exports, "ResultCard", function () { return $a26a549454f77336$export$3219b0bbd5caee8; });








function $a26a549454f77336$var$getBackgroundColor({ danger: danger  }) {
    return danger ? (0, $aaac76de4690e7ff$export$689894fd5b69c1a5) : (0, $aaac76de4690e7ff$export$df5574606a94f191);
}
function $a26a549454f77336$var$getCursor({ onClick: onClick  }) {
    return onClick ? "cursor: pointer;" : "";
}
const $a26a549454f77336$var$StyledCard = (0, $1mgSD$styledcomponents)((0, $4c66280bc58b30dd$export$60332b2344f7fe41))`
  background-color: ${(props)=>$a26a549454f77336$var$getBackgroundColor(props)};
  ${(props)=>$a26a549454f77336$var$getCursor(props)}
`;
const $a26a549454f77336$var$StyledFontAwesomeIcon = (0, $1mgSD$styledcomponents)((0, $1mgSD$FontAwesomeIcon))`
  color: ${(0, $aaac76de4690e7ff$export$3b058bf22d3a92e9)};
  font-size: ${(0, $fd37c165946cdbcc$export$9b8cd5b0d7315663)};
`;
const $a26a549454f77336$var$StyledH2 = (0, $1mgSD$styledcomponents)((0, $66e82a5fe7a0e0ea$export$cb94397127ac9363))`
  color: ${(0, $aaac76de4690e7ff$export$3b058bf22d3a92e9)};
`;
function $a26a549454f77336$export$3219b0bbd5caee8({ text: text , danger: danger , onClick: onClick  }) {
    const resultIcon = danger ? "times-circle" : "check-circle";
    return /*#__PURE__*/ (0, $1mgSD$react).createElement($a26a549454f77336$var$StyledCard, {
        danger: danger,
        onClick: onClick
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e1c47a8b6d5f9c8f$export$816b5d811295e6bc), {
        horizontallyAlignContent: true,
        spacing: (0, $fd37c165946cdbcc$export$79a18a7d58eb5909)
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement($a26a549454f77336$var$StyledFontAwesomeIcon, {
        icon: [
            "fas",
            resultIcon
        ]
    }), /*#__PURE__*/ (0, $1mgSD$react).createElement($a26a549454f77336$var$StyledH2, null, text)));
}
$a26a549454f77336$export$3219b0bbd5caee8.defaultProps = {
    danger: false,
    onClick: undefined
};


$parcel$exportWildcard($ebde5abb93da027d$exports, $10ede891be2e50f8$exports);
$parcel$exportWildcard($ebde5abb93da027d$exports, $d1838b596c71cd06$exports);
$parcel$exportWildcard($ebde5abb93da027d$exports, $e4189bdaac4c4d3f$exports);
$parcel$exportWildcard($ebde5abb93da027d$exports, $4acf5fc835d21075$exports);
$parcel$exportWildcard($ebde5abb93da027d$exports, $4c66280bc58b30dd$exports);
$parcel$exportWildcard($ebde5abb93da027d$exports, $26ecfcbf18b1fb5d$exports);
$parcel$exportWildcard($ebde5abb93da027d$exports, $eea8a5efeb78e831$exports);
$parcel$exportWildcard($ebde5abb93da027d$exports, $a26a549454f77336$exports);


var $0a2316950772fa28$exports = {};
var $a30e48c20455bff0$exports = {};

$parcel$export($a30e48c20455bff0$exports, "SimpleContainer", function () { return $a30e48c20455bff0$export$eeaa45a7d92663a6; });




const $a30e48c20455bff0$export$eeaa45a7d92663a6 = (0, $1mgSD$styledcomponents).div`
  ${({ shadow: shadow  })=>{
    if (shadow && ![
        1,
        2
    ].includes(shadow)) throw new Error("Invalid shadow value. Must be 1 or 2.");
    switch(shadow){
        case 2:
            return 0, $5d0b63b3a27c519d$export$f7266ad9837f2dc4;
        case 1:
        default:
            return 0, $5d0b63b3a27c519d$export$400b8f528beb1869;
    }
}};

  background-color: ${(0, $aaac76de4690e7ff$export$3b058bf22d3a92e9)};
  border-radius: ${(0, $fd37c165946cdbcc$export$7a57f79000377ca2)};

  > *:not(:last-child) {
    border-bottom: ${(0, $fd37c165946cdbcc$export$12879c7697ed953d)} solid ${(0, $aaac76de4690e7ff$export$545251b0d520f8ad)};
  }
`;


var $2e7c7887a7057eac$exports = {};

$parcel$export($2e7c7887a7057eac$exports, "SimpleContainerHeader", function () { return $2e7c7887a7057eac$export$7410b45a5f58ef2b; });





var $028b26d7944ce561$exports = {};

$parcel$export($028b26d7944ce561$exports, "SimpleContainerSection", function () { return $028b26d7944ce561$export$202ffdafe1e1a746; });


const $028b26d7944ce561$export$202ffdafe1e1a746 = (0, $1mgSD$styledcomponents).div`
  padding: ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)};
`;


const $2e7c7887a7057eac$var$SimpleContainerHeaderContainer = (0, $1mgSD$styledcomponents)((0, $028b26d7944ce561$export$202ffdafe1e1a746))`
  align-items: center;
  background-color: ${(0, $aaac76de4690e7ff$export$76ad689e70c7691d)};
  display: flex;
  height: 3rem;
  justify-content: space-between;
  padding: 0 ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)};
`;
const $2e7c7887a7057eac$export$7410b45a5f58ef2b = (props)=>{
    const { className: className , children: children , linkText: linkText , onClick: onClick  } = props;
    return /*#__PURE__*/ (0, $1mgSD$react).createElement($2e7c7887a7057eac$var$SimpleContainerHeaderContainer, {
        className: className
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $a65c84ab085b2e8e$export$746be9e3a3dfff1f), null, children), linkText && /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $637b1423c417142a$export$a6c7ac8248d6e38a), {
        small: true,
        onClick: onClick
    }, linkText));
};
$2e7c7887a7057eac$export$7410b45a5f58ef2b.defaultProps = {
    className: "",
    linkText: ""
};



var $9d3b54d6837e427d$exports = {};

$parcel$export($9d3b54d6837e427d$exports, "SectionContainer", function () { return $9d3b54d6837e427d$export$be4c8679ebfd988; });



const $9d3b54d6837e427d$export$be4c8679ebfd988 = (0, $1mgSD$styledcomponents).div`
  border: ${(0, $fd37c165946cdbcc$export$12879c7697ed953d)} solid ${(0, $aaac76de4690e7ff$export$545251b0d520f8ad)};
  border-radius: 0.25rem;

  > *:not(:last-child) {
    border-bottom: ${(0, $fd37c165946cdbcc$export$12879c7697ed953d)} solid ${(0, $aaac76de4690e7ff$export$545251b0d520f8ad)};
  }
`;


var $6ba821a3bca8e184$exports = {};

$parcel$export($6ba821a3bca8e184$exports, "SectionContainerHeader", function () { return $6ba821a3bca8e184$export$5282a815cf9a8195; });





const $6ba821a3bca8e184$var$SectionContainerHeaderWrapper = (0, $1mgSD$styledcomponents)((0, $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6))`
  align-items: center;
  background-color: ${(0, $aaac76de4690e7ff$export$76ad689e70c7691d)};
  color: ${(0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f)};
  display: flex;
  font-size: 0.75rem;
  font-weight: 600;
  height: 1.5rem;
  padding: ${(0, $fd37c165946cdbcc$export$4c16e5a80ec60b32)} ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
`;
const $6ba821a3bca8e184$export$5282a815cf9a8195 = ({ children: children  })=>/*#__PURE__*/ (0, $1mgSD$react).createElement($6ba821a3bca8e184$var$SectionContainerHeaderWrapper, null, children);


var $a983d38bfafe8ba2$exports = {};

$parcel$export($a983d38bfafe8ba2$exports, "SectionContainerSection", function () { return $a983d38bfafe8ba2$export$2afed638eb3a7931; });


const $a983d38bfafe8ba2$export$2afed638eb3a7931 = (0, $1mgSD$styledcomponents).div`
  padding: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
`;


$parcel$exportWildcard($0a2316950772fa28$exports, $a30e48c20455bff0$exports);
$parcel$exportWildcard($0a2316950772fa28$exports, $2e7c7887a7057eac$exports);
$parcel$exportWildcard($0a2316950772fa28$exports, $028b26d7944ce561$exports);
$parcel$exportWildcard($0a2316950772fa28$exports, $9d3b54d6837e427d$exports);
$parcel$exportWildcard($0a2316950772fa28$exports, $6ba821a3bca8e184$exports);
$parcel$exportWildcard($0a2316950772fa28$exports, $a983d38bfafe8ba2$exports);


var $f8e7c499f0a72e56$exports = {};
var $d8acc43864342a37$exports = {};

$parcel$export($d8acc43864342a37$exports, "Form", function () { return $d8acc43864342a37$export$a7fed597f4b8afd8; });

class $d8acc43864342a37$export$a7fed597f4b8afd8 extends (0, $1mgSD$react).PureComponent {
    handleSubmit(e) {
        const { onSubmit: onSubmit , submitting: submitting  } = this.props;
        // prevent page reload
        e.preventDefault();
        // only submit if we aren't already submitting
        if (!submitting && onSubmit) onSubmit();
    }
    render() {
        const { children: children  } = this.props;
        return /*#__PURE__*/ (0, $1mgSD$react).createElement("form", {
            ...this.props,
            onSubmit: this.handleSubmit
        }, children);
    }
    constructor(props){
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
}


$parcel$exportWildcard($f8e7c499f0a72e56$exports, $d8acc43864342a37$exports);


var $887ef06c6be72fdb$exports = {};
var $9839253b5696f77a$exports = {};

$parcel$export($9839253b5696f77a$exports, "InfoBox", function () { return $9839253b5696f77a$export$aff4fc93593c3bcf; });






const $9839253b5696f77a$var$INFO_BOX_BORDER_WIDTH = "1px";
const $9839253b5696f77a$var$getBorderStyle = ({ danger: danger , warning: warning , secondary: secondary  })=>{
    if (danger) return `
      border: ${$9839253b5696f77a$var$INFO_BOX_BORDER_WIDTH} solid ${0, $aaac76de4690e7ff$export$4c90220182e0b14};
      background-color: ${0, $aaac76de4690e7ff$export$6c9b3104157f8389};
    `;
    if (warning) return `
      border: ${$9839253b5696f77a$var$INFO_BOX_BORDER_WIDTH} solid ${0, $aaac76de4690e7ff$export$a407bb5b45f88e9f};
      background-color: ${0, $aaac76de4690e7ff$export$f8a16a30e3179648};
    `;
    if (secondary) return `
      border: ${$9839253b5696f77a$var$INFO_BOX_BORDER_WIDTH} solid ${0, $aaac76de4690e7ff$export$545251b0d520f8ad};
      background-color: ${0, $aaac76de4690e7ff$export$3b058bf22d3a92e9};
    `;
    return `
    border: ${$9839253b5696f77a$var$INFO_BOX_BORDER_WIDTH} solid ${0, $aaac76de4690e7ff$export$545251b0d520f8ad};
    background-color: ${0, $aaac76de4690e7ff$export$3b058bf22d3a92e9};
  `;
};
const $9839253b5696f77a$var$Box = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$210ea85e49c56827))`
  ${$9839253b5696f77a$var$getBorderStyle}
  border-radius: ${(0, $fd37c165946cdbcc$export$efa65fa1092f7420)};
  margin-bottom: ${(0, $fd37c165946cdbcc$export$79a18a7d58eb5909)};
`;
const $9839253b5696f77a$var$Title = (0, $1mgSD$styledcomponents)((0, $ebd2ff14df5e4ed4$export$cc5e069d64fda823))`
  color: ${({ danger: danger , warning: warning , secondary: secondary  })=>{
    if (danger) return 0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f;
    if (warning) return 0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f;
    if (secondary) return 0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f;
    return 0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f;
}};
`;
const $9839253b5696f77a$export$aff4fc93593c3bcf = (props)=>{
    const { title: title , children: children , danger: danger , warning: warning , secondary: secondary , editButton: editButton , ...rest } = props;
    return /*#__PURE__*/ $1mgSD$createElement($9839253b5696f77a$var$Box, {
        ...rest,
        padding: (0, $fd37c165946cdbcc$export$54c7853c55b55e72),
        warning: warning,
        danger: danger,
        secondary: secondary
    }, title || !danger && !warning && editButton ? /*#__PURE__*/ $1mgSD$createElement((0, $e1c47a8b6d5f9c8f$export$b1a401d0eced3e7), {
        spacing: (0, $fd37c165946cdbcc$export$79a18a7d58eb5909),
        evenlySpaceContent: true
    }, title ? /*#__PURE__*/ $1mgSD$createElement($9839253b5696f77a$var$Title, {
        warning: warning,
        danger: danger,
        secondary: secondary
    }, title) : null, !danger && !warning && editButton) : null, children);
};
$9839253b5696f77a$export$aff4fc93593c3bcf.defaultProps = {
    title: "",
    isEditable: false,
    danger: false,
    warning: false,
    secondary: false,
    editButton: null
};


$parcel$exportWildcard($887ef06c6be72fdb$exports, $9839253b5696f77a$exports);


var $4a4b332837f5a160$exports = {};

$parcel$export($4a4b332837f5a160$exports, "InputBlockAsyncSelect", function () { return $4a4b332837f5a160$export$cefd80352569a33f; });
$parcel$export($4a4b332837f5a160$exports, "InputBlockIcon", function () { return $4a4b332837f5a160$export$c96a0b7a2d13d2eb; });
$parcel$export($4a4b332837f5a160$exports, "InputBlockPassword", function () { return $4a4b332837f5a160$export$3afa4f47ece1183e; });
$parcel$export($4a4b332837f5a160$exports, "InputBlockRadio", function () { return $4a4b332837f5a160$export$bc6fd9e82d599a3d; });
$parcel$export($4a4b332837f5a160$exports, "InputBlockSelect", function () { return $4a4b332837f5a160$export$f08696a21e869131; });
$parcel$export($4a4b332837f5a160$exports, "InputBlockText", function () { return $4a4b332837f5a160$export$661bf7bf48ebd697; });
$parcel$export($4a4b332837f5a160$exports, "InputBlockTextArea", function () { return $4a4b332837f5a160$export$6513660e47c22334; });
$parcel$export($4a4b332837f5a160$exports, "InputBlockCheckbox", function () { return $4a4b332837f5a160$export$cfe4211e9d3c9baf; });
$parcel$export($4a4b332837f5a160$exports, "InputUploadImage", function () { return $4a4b332837f5a160$export$7b65cb28f38300b0; });
$parcel$export($4a4b332837f5a160$exports, "Input", function () { return $d8a8286d48fb661d$export$f5b8910cec6cf069; });
$parcel$export($4a4b332837f5a160$exports, "InputBlock", function () { return $64be58195b6ad3f8$export$83678641c7770fa5; });
$parcel$export($4a4b332837f5a160$exports, "InputCheckbox", function () { return $677d84d1ac71479b$export$fa1253a65a9e747d; });
$parcel$export($4a4b332837f5a160$exports, "InputCheckboxCheckmark", function () { return $93edf818f725e4a9$export$4f481e0a96cfbed6; });
$parcel$export($4a4b332837f5a160$exports, "InputIcon", function () { return $94688993bd21fab5$export$f8fea9f50a4bfae6; });
$parcel$export($4a4b332837f5a160$exports, "InputPassword", function () { return $404694754b94de9e$export$66ebaee5e192c141; });
$parcel$export($4a4b332837f5a160$exports, "InputRow", function () { return $24345a848f7a9137$export$2fe4f0576c8a371; });
$parcel$export($4a4b332837f5a160$exports, "InputTextArea", function () { return $a7691ccff838311a$export$26542d43b3209548; });
$parcel$export($4a4b332837f5a160$exports, "InputToggle", function () { return $4d7b46a4a27c7b9a$export$ed3c6fc36a947b6a; });
$parcel$export($4a4b332837f5a160$exports, "inputStylesMixin", function () { return $d8a8286d48fb661d$export$4293276c0c0bdb9d; });
var $bd8ab8f075ca28dd$exports = {};
var $8beeebdb4fa059b6$exports = {};

$parcel$export($8beeebdb4fa059b6$exports, "RadioGroup", function () { return $8beeebdb4fa059b6$export$a98f0dcb43a68a25; });



const $8beeebdb4fa059b6$var$RadioGroupContainer = (0, $1mgSD$styledcomponents).div`
  margin-top: ${(0, $fd37c165946cdbcc$export$79a18a7d58eb5909)};
`;
class $8beeebdb4fa059b6$export$a98f0dcb43a68a25 extends $1mgSD$PureComponent {
    render() {
        const { children: children , className: className , disabled: disabled , input: input  } = this.props;
        return /*#__PURE__*/ $1mgSD$createElement($8beeebdb4fa059b6$var$RadioGroupContainer, {
            "aria-label": input.name,
            className: className,
            role: "radiogroup"
        }, $1mgSD$Children.map(children, (child)=>{
            if (!child) return null;
            // @ts-expect-error technically child could be something that doesn't have a props field
            const { value: value  } = child.props;
            const { name: name , onChange: onChange  } = input;
            // @ts-expect-error react doesn't like cloning a child element since it could be a string
            return /*#__PURE__*/ $1mgSD$cloneElement(child, {
                checked: input.value === value,
                disabled: disabled,
                name: name,
                onChange: onChange,
                value: value
            });
        }));
    }
}


var $f5f1fec5afabd21c$exports = {};

$parcel$export($f5f1fec5afabd21c$exports, "RadioOption", function () { return $f5f1fec5afabd21c$export$82ab7168879267a7; });





const $f5f1fec5afabd21c$var$Input = (0, $1mgSD$styledcomponents).input`
  cursor: pointer;
  opacity: 0;
  position: absolute;
`;
const $f5f1fec5afabd21c$var$getCheckedStyles = ({ checked: checked  })=>checked && `
  background-color: white;
  border-color: ${0, $aaac76de4690e7ff$export$d913daa7170c2f9f};
`;
const $f5f1fec5afabd21c$var$getNotCheckedStyles = ({ checked: checked  })=>!checked && `
  label:hover > & {
    background-color: ${0, $aaac76de4690e7ff$export$775ceeacde47cab2};
  }
`;
const $f5f1fec5afabd21c$var$getDisabledStyles = ({ disabled: disabled  })=>disabled && `
  background-color: ${0, $aaac76de4690e7ff$export$545251b0d520f8ad};
  border-color: ${0, $aaac76de4690e7ff$export$abc95940fda32f98};
`;
const $f5f1fec5afabd21c$var$Circle = (0, $1mgSD$styledcomponents).span`
  border: ${(0, $fd37c165946cdbcc$export$12879c7697ed953d)} solid ${(0, $aaac76de4690e7ff$export$abc95940fda32f98)};
  border-radius: 50%;
  box-sizing: border-box;
  height: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  left: 0;
  position: absolute;
  top: calc((${(0, $fd37c165946cdbcc$export$70173e1228291b3c)} - ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)}) / 2);
  width: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};

  &::after {
    content: '';
    display: ${({ checked: checked  })=>checked ? "block" : "none"};
    position: absolute;
  }

  ${$f5f1fec5afabd21c$var$getCheckedStyles}
  ${$f5f1fec5afabd21c$var$getNotCheckedStyles}
  ${$f5f1fec5afabd21c$var$getDisabledStyles}
`;
const $f5f1fec5afabd21c$var$getDisabledStylesForLabel = ({ disabled: disabled  })=>disabled && `
  cursor: not-allowed;
  color: ${0, $aaac76de4690e7ff$export$abc95940fda32f98};
  > :after {
    background: ${0, $aaac76de4690e7ff$export$abc95940fda32f98};
  }
`;
const $f5f1fec5afabd21c$var$Label = (0, $1mgSD$styledcomponents).label`
  cursor: pointer;
  display: block;
  font-family: ${(0, $fe72a230606ab94c$export$a5975749f0374264)};
  font-weight: initial;
  line-height: ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)};
  margin-bottom: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  padding-left: ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)};
  position: relative;
  color: ${(0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f)};

  > :after {
    background: ${(0, $aaac76de4690e7ff$export$d913daa7170c2f9f)};
    border-radius: 50%;
    height: 8px;
    left: 3px;
    top: 3px;
    width: 8px;
  }

  ${$f5f1fec5afabd21c$var$getDisabledStylesForLabel}
`;
class $f5f1fec5afabd21c$export$82ab7168879267a7 extends $1mgSD$PureComponent {
    render() {
        const { checked: checked , children: children , className: className , disabled: disabled , name: name , onChange: onChange , value: value  } = this.props;
        return /*#__PURE__*/ $1mgSD$createElement($f5f1fec5afabd21c$var$Label, {
            className: className,
            disabled: disabled
        }, children, /*#__PURE__*/ $1mgSD$createElement($f5f1fec5afabd21c$var$Input, {
            checked: checked,
            name: name,
            onChange: onChange,
            type: "radio",
            value: value
        }), /*#__PURE__*/ $1mgSD$createElement($f5f1fec5afabd21c$var$Circle, {
            checked: checked,
            disabled: disabled,
            onChange: onChange
        }));
    }
}


$parcel$exportWildcard($bd8ab8f075ca28dd$exports, $8beeebdb4fa059b6$exports);
$parcel$exportWildcard($bd8ab8f075ca28dd$exports, $f5f1fec5afabd21c$exports);


var $ca99b2599154b655$exports = {};

$parcel$export($ca99b2599154b655$exports, "SelectComponents", function () { return $ca99b2599154b655$re_export$SelectComponents; });

var $ee4112e8be1f7a04$exports = {};

$parcel$export($ee4112e8be1f7a04$exports, "Select", function () { return $ee4112e8be1f7a04$export$ef9b1a59e592288f; });







const { DropdownIndicator: $002f10c2b94ecd77$var$RDropdownIndicator  } = (0, $ca99b2599154b655$re_export$SelectComponents);
// @ts-expect-error ts-migrate(7031) FIXME: Binding element 'invalid' implicitly has an 'any' ... Remove this comment to see the full error message
const $002f10c2b94ecd77$var$dropdownIndicatorColor = ({ invalid: invalid , isFocused: isFocused  })=>{
    if (invalid) return 0, $aaac76de4690e7ff$export$4c90220182e0b14;
    if (isFocused) return 0, $aaac76de4690e7ff$export$abc95940fda32f98;
    return 0, $aaac76de4690e7ff$export$abc95940fda32f98;
};
const $002f10c2b94ecd77$export$e8599ce2b4fced8 = (styles, props, { invalid: invalid  })=>{
    const { isFocused: isFocused  } = props;
    return {
        ...styles,
        color: $002f10c2b94ecd77$var$dropdownIndicatorColor({
            invalid: invalid,
            isFocused: isFocused
        }),
        alignItems: "center",
        "&:hover": {
            color: $002f10c2b94ecd77$var$dropdownIndicatorColor({
                invalid: invalid,
                isFocused: isFocused
            })
        }
    };
};
const $002f10c2b94ecd77$export$ec98719d3db7f2e4 = (props)=>{
    const { // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectProps' does not exist on type 'Opt... Remove this comment to see the full error message
    selectProps: { isSearchable: isSearchable  } ,  } = props;
    if (isSearchable) return null;
    return(// @ts-expect-error ts-migrate(2604) FIXME: JSX element type 'RDropdownIndicator' does not hav... Remove this comment to see the full error message
    /*#__PURE__*/ (0, $1mgSD$react).createElement($002f10c2b94ecd77$var$RDropdownIndicator, props, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $1mgSD$FontAwesomeIcon), {
        color: (0, $aaac76de4690e7ff$export$abc95940fda32f98),
        icon: [
            "far",
            "chevron-down"
        ],
        size: "sm"
    })));
};













const $042d31843d2a0c67$export$7ea42f523253bc68 = "0.75rem";
const $042d31843d2a0c67$var$OptionDescription = (0, $1mgSD$styledcomponents)((0, $7c7949b58e9af13d$export$ed2cd9eb2d1973f0))`
  font-size: 0.75rem;
`;
const $042d31843d2a0c67$var$OptionIcons = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$b1a401d0eced3e7))`
  svg {
    color: ${(0, $aaac76de4690e7ff$export$abc95940fda32f98)};
  }
`;
class $042d31843d2a0c67$export$b381d9a2f3b4390b extends (0, $1mgSD$Component) {
    render() {
        const { optionProps: { data: { label: label , text: text , options: options , icons: icons  } , isSelected: isSelected , isDisabled: isDisabled ,  } , selectProps: { chunky: chunky  } ,  } = this.props;
        return /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e1c47a8b6d5f9c8f$export$b1a401d0eced3e7), {
            padding: `${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)} 0`,
            growToParentWidth: true,
            evenlySpaceContent: true,
            verticallyAlignContent: true
        }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e1c47a8b6d5f9c8f$export$210ea85e49c56827), {
            growToParentWidth: true,
            padding: `0 ${$042d31843d2a0c67$export$7ea42f523253bc68}`
        }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e1c47a8b6d5f9c8f$export$b1a401d0eced3e7), {
            growToParentWidth: true,
            evenlySpaceContent: true,
            verticallyAlignContent: true
        }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6), {
            light: isDisabled,
            active: isSelected,
            bold: chunky
        }, label), isSelected ? /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $1mgSD$FontAwesomeIcon), {
            color: (0, $aaac76de4690e7ff$export$d913daa7170c2f9f),
            icon: [
                "far",
                "check"
            ],
            size: "xs"
        }) : icons && /*#__PURE__*/ (0, $1mgSD$react).createElement($042d31843d2a0c67$var$OptionIcons, {
            spacing: (0, $fd37c165946cdbcc$export$79a18a7d58eb5909)
        }, icons)), chunky && text && /*#__PURE__*/ (0, $1mgSD$react).createElement($042d31843d2a0c67$var$OptionDescription, null, text)), options && options.length && /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e1c47a8b6d5f9c8f$export$210ea85e49c56827), {
            padding: `0 ${$042d31843d2a0c67$export$7ea42f523253bc68}`
        }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $1mgSD$FontAwesomeIcon), {
            color: (0, $aaac76de4690e7ff$export$d913daa7170c2f9f),
            icon: [
                "far",
                "chevron-right"
            ],
            size: "xs"
        })));
    }
}








const $948a4adedcbbe584$var$MultiOptionLabel = (0, $1mgSD$styledcomponents)((0, $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6))`
  padding: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)} 0;
  min-height: auto;
`;
const $948a4adedcbbe584$export$8f81badb01766028 = ({ label: label  })=>/*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e1c47a8b6d5f9c8f$export$b1a401d0eced3e7), {
        padding: `0 ${(0, $042d31843d2a0c67$export$7ea42f523253bc68)}`,
        verticallyAlignContent: true
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement($948a4adedcbbe584$var$MultiOptionLabel, null, label));


const { Option: $befb786a0e8d5237$var$ROption  } = (0, $ca99b2599154b655$re_export$SelectComponents);
// @ts-expect-error ts-migrate(7031) FIXME: Binding element 'isDisabled' implicitly has an 'an... Remove this comment to see the full error message
const $befb786a0e8d5237$var$backgroundColor = ({ isDisabled: isDisabled  })=>{
    if (isDisabled) return 0, $aaac76de4690e7ff$export$545251b0d520f8ad;
    return 0, $aaac76de4690e7ff$export$775ceeacde47cab2;
};
const $befb786a0e8d5237$export$f1c4283ed53254d0 = (styles, { isSelected: isSelected , isDisabled: isDisabled  }, { chunky: chunky  })=>({
        ...styles,
        backgroundColor: isDisabled ? (0, $aaac76de4690e7ff$export$545251b0d520f8ad) : (0, $aaac76de4690e7ff$export$3b058bf22d3a92e9),
        display: "flex",
        flexDirection: "column",
        padding: 0,
        fontWeight: isSelected ? "bold" : "normal",
        justifyContent: chunky ? "space-between" : "center",
        fontSize: ".875rem",
        "&:hover": {
            backgroundColor: $befb786a0e8d5237$var$backgroundColor({
                isDisabled: isDisabled
            }),
            cursor: isDisabled ? "not-allowed" : "pointer"
        },
        "&:first-child": {
            borderTopLeftRadius: (0, $fd37c165946cdbcc$export$7a57f79000377ca2),
            borderTopRightRadius: (0, $fd37c165946cdbcc$export$7a57f79000377ca2)
        },
        "&:last-child": {
            borderBottomLeftRadius: (0, $fd37c165946cdbcc$export$7a57f79000377ca2),
            borderBottomRightRadius: (0, $fd37c165946cdbcc$export$7a57f79000377ca2)
        },
        "&:not(:last-child)": {
            borderBottom: `${0, $fd37c165946cdbcc$export$12879c7697ed953d} solid ${0, $aaac76de4690e7ff$export$545251b0d520f8ad}`
        },
        WebkitFontSmoothing: "antialiased"
    });
const $befb786a0e8d5237$export$36d18380658d5d20 = (optionProps, selectProps)=>{
    const { data: { label: label  } , isMulti: // @ts-expect-error ts-migrate(2339) FIXME: Property 'isMulti' does not exist on type 'OptionP... Remove this comment to see the full error message
    isMulti ,  } = optionProps;
    return(// @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    /*#__PURE__*/ (0, $1mgSD$react).createElement($befb786a0e8d5237$var$ROption, optionProps, isMulti ? /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $948a4adedcbbe584$export$8f81badb01766028), {
        label: label
    }) : /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $042d31843d2a0c67$export$b381d9a2f3b4390b), {
        optionProps: optionProps,
        selectProps: selectProps
    })));
};









const { Group: $9dffb1b349abc812$var$RGroup  } = (0, $ca99b2599154b655$re_export$SelectComponents);
const $9dffb1b349abc812$export$1f19b4185c7ab9b4 = (styles)=>({
        ...styles,
        padding: 0,
        boxShadow: (0, $5d0b63b3a27c519d$export$1bacaec662ba54d4)
    });
const $9dffb1b349abc812$export$a40598d5943af2cd = (menuPlacement, nestedMenuPosition)=>{
    // A way to manually dock the nested menu to the top or the bottom
    // of the option group
    if (nestedMenuPosition) return `${nestedMenuPosition}: 0;`;
    // Menu is docked above the select, dock all nested groups
    // to the bottom of the option
    if (menuPlacement === "top") return "bottom: 0;";
    // Menu is docked below the select, dock all nested groups
    // to the top of the option
    if (menuPlacement === "bottom") return "top: 0;";
    return "top: 0;";
};
const $9dffb1b349abc812$var$GroupWrapper = (0, $1mgSD$styledcomponents).div`
  position: relative;
  &:not(:last-child) {
    border-bottom: ${(0, $fd37c165946cdbcc$export$12879c7697ed953d)} solid ${(0, $aaac76de4690e7ff$export$545251b0d520f8ad)};
  }
`;
const $9dffb1b349abc812$var$getMaxHeightStyle = ({ maxHeight: maxHeight  })=>{
    return maxHeight && `
      max-height: ${maxHeight};
      overflow-y: auto;
    `;
};
const $9dffb1b349abc812$var$StyledGroup = (0, $1mgSD$styledcomponents)($9dffb1b349abc812$var$RGroup)`
  position: absolute;
  right: -100%;
  background-color: ${(0, $aaac76de4690e7ff$export$3b058bf22d3a92e9)};
  ${({ menuPlacement: menuPlacement , nestedMenuPosition: nestedMenuPosition  })=>{
    return $9dffb1b349abc812$export$a40598d5943af2cd(menuPlacement, nestedMenuPosition);
}}
  width: 100%;
  ${$9dffb1b349abc812$var$getMaxHeightStyle}
`;
const $9dffb1b349abc812$var$getBackgroundColor = ({ isSelectedGroup: isSelectedGroup  })=>isSelectedGroup && `background-color: ${0, $aaac76de4690e7ff$export$87a86361d063ff10};`;
const $9dffb1b349abc812$var$GroupOption = (0, $1mgSD$styledcomponents).div`
  cursor: pointer;
  ${$9dffb1b349abc812$var$getBackgroundColor}
  &:hover {
    background-color: ${(0, $aaac76de4690e7ff$export$87a86361d063ff10)};
  }
`;
class $9dffb1b349abc812$export$eb2fcfdbd7ba97d4 extends (0, $1mgSD$react).Component {
    handleSelectGroup() {
        const { onSelectGroup: onSelectGroup , groupProps: groupProps  } = this.props;
        if (groupProps.data && groupProps.data.value) onSelectGroup(groupProps.data.value);
    }
    render() {
        const { groupProps: groupProps , selectProps: selectProps , selectedGroup: selectedGroup  } = this.props;
        const { nestedMenuPosition: nestedMenuPosition , value: value , nestedMenuMaxHeight: nestedMenuMaxHeight  } = groupProps.data;
        const isSelectedGroup = selectedGroup === value;
        return /*#__PURE__*/ (0, $1mgSD$react).createElement($9dffb1b349abc812$var$GroupWrapper, null, /*#__PURE__*/ (0, $1mgSD$react).createElement($9dffb1b349abc812$var$GroupOption, {
            isSelectedGroup: isSelectedGroup,
            onClick: this.handleSelectGroup
        }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $042d31843d2a0c67$export$b381d9a2f3b4390b), {
            optionProps: groupProps,
            selectProps: selectProps
        })), isSelectedGroup && /*#__PURE__*/ (0, $1mgSD$react).createElement($9dffb1b349abc812$var$StyledGroup, {
            ...groupProps,
            maxHeight: nestedMenuMaxHeight,
            nestedMenuPosition: nestedMenuPosition,
            menuPlacement: selectProps.menuPlacement
        }));
    }
    constructor(props){
        super(props);
        this.handleSelectGroup = this.handleSelectGroup.bind(this);
    }
}


var $28f28f30df27e3c4$exports = {};

$parcel$export($28f28f30df27e3c4$exports, "selectStyles", function () { return $28f28f30df27e3c4$export$70a9ea0b017c448a; });
$parcel$export($28f28f30df27e3c4$exports, "findOptions", function () { return $28f28f30df27e3c4$export$a1d110fc478d9732; });
$parcel$export($28f28f30df27e3c4$exports, "findOption", function () { return $28f28f30df27e3c4$export$d072b35edf4f3563; });
$parcel$export($28f28f30df27e3c4$exports, "findGroup", function () { return $28f28f30df27e3c4$export$429bdfed6f5ec72a; });








const $28f28f30df27e3c4$var$backgroundColor = ({ invalid: invalid , isDisabled: isDisabled  })=>{
    if (isDisabled) return 0, $aaac76de4690e7ff$export$545251b0d520f8ad;
    if (invalid) return 0, $aaac76de4690e7ff$export$6c9b3104157f8389;
    return 0, $aaac76de4690e7ff$export$3b058bf22d3a92e9;
};
const $28f28f30df27e3c4$var$borderColor = ({ defaultColor: defaultColor , invalid: invalid , isFocused: isFocused  })=>{
    if (isFocused) return 0, $aaac76de4690e7ff$export$d913daa7170c2f9f;
    if (invalid) return 0, $aaac76de4690e7ff$export$4c90220182e0b14;
    return defaultColor;
};
const $28f28f30df27e3c4$export$70a9ea0b017c448a = ({ chunky: chunky , invalid: invalid , isNested: isNested  })=>({
        control: (styles, { isDisabled: isDisabled , isFocused: isFocused  })=>({
                ...styles,
                backgroundColor: $28f28f30df27e3c4$var$backgroundColor({
                    invalid: invalid,
                    isDisabled: isDisabled
                }),
                borderColor: $28f28f30df27e3c4$var$borderColor({
                    defaultColor: (0, $aaac76de4690e7ff$export$545251b0d520f8ad),
                    invalid: invalid,
                    isFocused: isFocused
                }),
                borderRadius: (0, $fd37c165946cdbcc$export$efa65fa1092f7420),
                borderWidth: $fd37c165946cdbcc$export$12879c7697ed953d,
                boxShadow: "none",
                minHeight: (0, $fd37c165946cdbcc$export$c34a6c87634beb3f),
                "&:hover": {
                    borderColor: $28f28f30df27e3c4$var$borderColor({
                        defaultColor: (0, $aaac76de4690e7ff$export$545251b0d520f8ad),
                        invalid: invalid,
                        isFocused: isFocused
                    }),
                    borderWidth: $fd37c165946cdbcc$export$12879c7697ed953d,
                    cursor: "pointer"
                }
            }),
        dropdownIndicator: (styles, props)=>(0, $002f10c2b94ecd77$export$e8599ce2b4fced8)(styles, props, {
                invalid: invalid
            }),
        indicatorSeparator: ()=>({
                display: "none"
            }),
        menu: (styles)=>({
                ...styles,
                borderRadius: $fd37c165946cdbcc$export$7a57f79000377ca2,
                boxShadow: (0, $5d0b63b3a27c519d$export$1bacaec662ba54d4),
                margin: 0
            }),
        menuList: (styles)=>{
            const newStyles = {
                ...styles,
                padding: 0,
                overflowY: isNested ? "visible" : "auto"
            };
            if (isNested) Object.assign(newStyles, {
                maxHeight: "auto"
            });
            return newStyles;
        },
        group: (styles)=>(0, $9dffb1b349abc812$export$1f19b4185c7ab9b4)(styles),
        option: (styles, props)=>(0, $befb786a0e8d5237$export$f1c4283ed53254d0)(styles, props, {
                chunky: chunky
            }),
        placeholder: (styles)=>({
                ...styles,
                color: (0, $aaac76de4690e7ff$export$abc95940fda32f98),
                margin: 0,
                fontSize: "1rem"
            }),
        singleValue: (styles)=>({
                ...styles,
                color: invalid ? (0, $aaac76de4690e7ff$export$4c90220182e0b14) : (0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f),
                fontSize: ".875rem",
                margin: 0
            }),
        multiValue: (styles)=>({
                ...styles,
                backgroundColor: (0, $aaac76de4690e7ff$export$87a86361d063ff10),
                border: `1px ${0, $aaac76de4690e7ff$export$545251b0d520f8ad} solid`,
                margin: "2px 0",
                borderRadius: 16,
                "&:not(:last-child)": {
                    marginRight: (0, $fd37c165946cdbcc$export$4c16e5a80ec60b32)
                },
                "&:hover": {
                    backgroundColor: (0, $aaac76de4690e7ff$export$6d4bd4305d16dfab)
                }
            }),
        multiValueLabel: (styles)=>({
                ...styles,
                color: (0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f),
                fontFamily: $fe72a230606ab94c$export$a5975749f0374264,
                borderRadius: 0,
                padding: "2px",
                paddingLeft: "8px",
                paddingRight: 0
            }),
        multiValueRemove: (styles)=>({
                ...styles,
                backgroundColor: "transparent",
                color: (0, $aaac76de4690e7ff$export$abc95940fda32f98),
                "&:hover": {
                    backgroundColor: "transparent",
                    color: (0, $aaac76de4690e7ff$export$d913daa7170c2f9f)
                }
            }),
        valueContainer: (styles)=>({
                ...styles,
                fontFamily: $fe72a230606ab94c$export$a5975749f0374264,
                padding: `${0, $fd37c165946cdbcc$export$4c16e5a80ec60b32} ${0, $042d31843d2a0c67$export$7ea42f523253bc68}`
            }),
        loadingMessage: (styles)=>({
                ...styles,
                fontFamily: $fe72a230606ab94c$export$a5975749f0374264
            }),
        noOptionsMessage: (styles)=>({
                ...styles,
                fontFamily: $fe72a230606ab94c$export$a5975749f0374264
            }),
        input: (styles)=>({
                ...styles,
                fontFamily: $fe72a230606ab94c$export$a5975749f0374264,
                fontSize: "1rem"
            })
    });
const $28f28f30df27e3c4$export$a1d110fc478d9732 = (options, value)=>{
    let results = [];
    for (const option of options){
        if (option.options) {
            const result = $28f28f30df27e3c4$export$a1d110fc478d9732(option.options, value);
            if (result) results = [
                ...results,
                ...result
            ];
        } else if (value.some((v)=>v === option.value)) results = [
            ...results,
            option
        ];
    }
    return results;
};
const $28f28f30df27e3c4$export$d072b35edf4f3563 = (options, value)=>{
    for (const option of options){
        if (option.options) {
            const result = $28f28f30df27e3c4$export$d072b35edf4f3563(option.options, value);
            if (result) return result;
        } else if (option.value === value) return option;
    }
    return null;
};
const $28f28f30df27e3c4$export$429bdfed6f5ec72a = (options, value)=>{
    for (const option of options)if (option.options) {
        const result = $28f28f30df27e3c4$export$d072b35edf4f3563(option.options, value);
        if (result) return option;
    }
    return null;
};


var $ee4112e8be1f7a04$var$_Component;
class $ee4112e8be1f7a04$export$ef9b1a59e592288f extends ($ee4112e8be1f7a04$var$_Component = (0, $1mgSD$react).Component) {
    /**
   * react-select expects a ValueType as the value
   */ nextValue() {
        const { input: { value: value  } , options: options , reactSelectConfig: reactSelectConfig ,  } = this.props;
        const { isMulti: isMulti  } = reactSelectConfig || {};
        if (isMulti) {
            const arrayValue = Array.isArray(value) ? value : [
                value
            ];
            // @ts-expect-error value issues
            return (0, $28f28f30df27e3c4$export$a1d110fc478d9732)(options, value ? arrayValue : []);
        }
        // @ts-expect-error value issues
        return (0, $28f28f30df27e3c4$export$d072b35edf4f3563)(options, value);
    }
    /**
   * react-select returns a ValueType to onChange
   */ // @ts-expect-error ts-migrate(2314) FIXME: Generic type 'ValueType' requires 1 type argument(... Remove this comment to see the full error message
    onChange(nextValue) {
        const { input: { onChange: onChange  } , didSelectOption: didSelectOption , reactSelectConfig: reactSelectConfig , options: options ,  } = this.props;
        if (didSelectOption) didSelectOption(nextValue);
        const { isMulti: isMulti  } = reactSelectConfig || {};
        if (isMulti) {
            const value = nextValue && Array.isArray(nextValue) ? nextValue.map((v)=>v.value) : [];
            this.setState({
                value: // @ts-expect-error ts-migrate(2322) FIXME: Type 'any[]' is not assignable to type 'string | n... Remove this comment to see the full error message
                value
            });
            onChange(value);
        } else {
            const value = nextValue ? nextValue.value : null;
            const newState = {
                value: value
            };
            onChange(value);
            const group = (0, $28f28f30df27e3c4$export$429bdfed6f5ec72a)(options, nextValue.value);
            if (!group) Object.assign(newState, {
                selectedGroup: null
            });
            this.setState(newState);
        }
    }
    onMenuClose() {
        this.setState({
            selectedGroup: null
        });
    }
    onMenuOpen() {
        const { options: options  } = this.props;
        const { value: value  } = this.state;
        if (value) {
            const group = (0, $28f28f30df27e3c4$export$429bdfed6f5ec72a)(options, value);
            if (group) this.setState({
                selectedGroup: group.value
            });
        }
    }
    handleSelectGroup(selectedGroup) {
        this.setState({
            selectedGroup: selectedGroup
        });
    }
    renderOption(props) {
        return (0, $befb786a0e8d5237$export$36d18380658d5d20)(props, this.props);
    }
    renderGroup(props) {
        const { selectedGroup: selectedGroup  } = this.state;
        return /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $9dffb1b349abc812$export$eb2fcfdbd7ba97d4), {
            selectedGroup: selectedGroup,
            onSelectGroup: this.handleSelectGroup,
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            groupProps: props,
            selectProps: this.props
        });
    }
    render() {
        const { chunky: chunky , components: selectComponents , disabled: disabled , isClearable: isClearable , isSearchable: isSearchable , // @ts-expect-error ts-migrate(2339) FIXME: Property 'meta' does not exist on type 'Readonly<S... Remove this comment to see the full error message
        meta: { invalid: invalid , touched: touched  } , options: options , reactSelectConfig: reactSelectConfig , menuPlacement: menuPlacement ,  } = this.props;
        const isNested = Boolean(options.find((option)=>option.options));
        return(// @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $1mgSD$reactselect), {
            components: {
                GroupHeading: ()=>null,
                Group: this.renderGroup,
                DropdownIndicator: $002f10c2b94ecd77$export$ec98719d3db7f2e4,
                Option: this.renderOption,
                ...selectComponents
            },
            isDisabled: disabled,
            onMenuClose: this.onMenuClose,
            onMenuOpen: this.onMenuOpen,
            isSearchable: isSearchable,
            isClearable: isClearable,
            onChange: this.onChange,
            options: options,
            menuPlacement: menuPlacement,
            styles: (0, $28f28f30df27e3c4$export$70a9ea0b017c448a)({
                chunky: chunky,
                invalid: invalid && touched,
                isNested: isNested
            }),
            value: this.nextValue(),
            ...reactSelectConfig
        }));
    }
    constructor(props){
        super(props);
        this.nextValue = this.nextValue.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onMenuClose = this.onMenuClose.bind(this);
        this.onMenuOpen = this.onMenuOpen.bind(this);
        this.handleSelectGroup = this.handleSelectGroup.bind(this);
        this.renderGroup = this.renderGroup.bind(this);
        this.renderOption = this.renderOption.bind(this);
        this.state = {
            selectedGroup: null,
            value: null
        };
    }
}
(0, $1mgSD$swchelperslib_define_propertyjs)($ee4112e8be1f7a04$export$ef9b1a59e592288f, "defaultProps", {
    chunky: false,
    components: {},
    didSelectOption: ()=>null,
    disabled: false,
    input: {
        onChange: ()=>{}
    },
    isClearable: false,
    isSearchable: false,
    meta: {}
});



var $ad2f8b73f442f9e6$exports = {};

$parcel$export($ad2f8b73f442f9e6$exports, "AsyncSelect", function () { return $ad2f8b73f442f9e6$export$aca05dd54e009a80; });








var $ad2f8b73f442f9e6$var$_Component;
class $ad2f8b73f442f9e6$export$aca05dd54e009a80 extends ($ad2f8b73f442f9e6$var$_Component = (0, $1mgSD$react).Component) {
    /**
   * react-select expects an ValueType as the value.
   * Try to find it amongst the default options, if there are any,
   * or assume that `value` is well formed.
   */ nextValue() {
        const { // @ts-expect-error ts-migrate(2339) FIXME: Property 'input' does not exist on type 'Readonly<... Remove this comment to see the full error message
        input: { value: value  } , creatable: creatable , reactSelectConfig: reactSelectConfig ,  } = this.props;
        const { currentOptions: currentOptions  } = this.state;
        const { isMulti: isMulti  } = reactSelectConfig || {};
        if (currentOptions && Array.isArray(currentOptions)) {
            if (isMulti) {
                const foundOptions = (0, $28f28f30df27e3c4$export$a1d110fc478d9732)(currentOptions, value || []);
                // if creatable adds value as options to be selected
                if (creatable) for (const v of value || []){
                    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '(option: OptionProps) => boolean... Remove this comment to see the full error message
                    const valueInOptions = foundOptions.some((option)=>v === option.value || v === option.label);
                    if (!valueInOptions) foundOptions.push({
                        label: v,
                        value: v
                    });
                }
                return foundOptions;
            }
            const foundOption = (0, $28f28f30df27e3c4$export$d072b35edf4f3563)(currentOptions, value);
            if (creatable && !foundOption) return {
                label: value,
                value: value
            };
            return (0, $28f28f30df27e3c4$export$d072b35edf4f3563)(currentOptions, value);
        }
        return value;
    }
    /**
   * Call the provided loadOptions function and stash the options that might
   * be needed by nextValue.
   */ loadAndStashOptions(inputValue) {
        const { defaultOptions: defaultOptions , loadOptions: loadOptions  } = this.props;
        return loadOptions(inputValue).then((loadedOptions)=>{
            // If multi-select, nextValue will be an array of options. Otherwise, it
            // will be a single option.
            const nextValue = this.nextValue();
            const selectedOptions = Array.isArray(nextValue) ? nextValue : [
                nextValue
            ];
            const fallbackOptions = Array.isArray(defaultOptions) ? defaultOptions : [];
            const selectedOptionValues = selectedOptions.map((selectedOption)=>selectedOption && selectedOption.value);
            const loadedOptionValues = loadedOptions.map(({ value: value  })=>value);
            // Filter out any loaded options that are already present in selected options
            const dedupedLoadedOptions = loadedOptions.filter((loadedOption)=>{
                return selectedOptionValues.indexOf(loadedOption.value) < 0;
            });
            // Filter out any default options that are already present in loaded or selected options
            const dedupedDefaultOptions = fallbackOptions.filter((defaultOption)=>{
                return loadedOptionValues.indexOf(defaultOption.value) < 0 && selectedOptionValues.indexOf(defaultOption.value) < 0;
            });
            // Be cautious and put the newly loaded, the default, and the currently
            // selected options in currentOptions to ensure that nextValue can find the
            // appropriate option
            const currentOptions = [
                ...selectedOptions,
                ...dedupedLoadedOptions,
                ...dedupedDefaultOptions
            ];
            this.setState({
                currentOptions: currentOptions
            });
            // Only display the newly loaded options based on the search term
            return loadedOptions;
        });
    }
    /**
   * react-select returns a ValueType to onChange
   */ // @ts-expect-error ts-migrate(2314) FIXME: Generic type 'ValueType' requires 1 type argument(... Remove this comment to see the full error message
    onChange(nextValue) {
        const { // @ts-expect-error ts-migrate(2339) FIXME: Property 'input' does not exist on type 'Readonly<... Remove this comment to see the full error message
        input: { onChange: onChange  } , didSelectOption: didSelectOption , reactSelectConfig: reactSelectConfig , defaultOptions: defaultOptions ,  } = this.props;
        const { currentOptions: currentOptions  } = this.state;
        if (didSelectOption) didSelectOption(nextValue);
        const { isMulti: isMulti  } = reactSelectConfig || {};
        if (isMulti) {
            const value = nextValue && Array.isArray(nextValue) ? nextValue.map((v)=>v.value) : [];
            this.setState({
                value: // @ts-expect-error ts-migrate(2322) FIXME: Type 'any[]' is not assignable to type 'string | n... Remove this comment to see the full error message
                value
            });
            onChange(value);
        } else {
            const value = nextValue ? nextValue.value : null;
            const newState = {
                value: value,
                currentOptions: currentOptions
            };
            onChange(value);
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean | any[] | undefined' is ... Remove this comment to see the full error message
            const group = value && (0, $28f28f30df27e3c4$export$429bdfed6f5ec72a)(defaultOptions, value);
            if (!group) newState.selectedGroup = null;
            this.setState(newState);
        }
    }
    onMenuClose() {
        this.setState({
            selectedGroup: null
        });
    }
    onMenuOpen() {
        const { defaultOptions: defaultOptions  } = this.props;
        const { value: value  } = this.state;
        if (value) {
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean | any[] | undefined' is ... Remove this comment to see the full error message
            const group = (0, $28f28f30df27e3c4$export$429bdfed6f5ec72a)(defaultOptions, value);
            if (group) this.setState({
                selectedGroup: group.value
            });
        }
    }
    handleSelectGroup(selectedGroup) {
        this.setState({
            selectedGroup: selectedGroup
        });
    }
    renderOption(props) {
        return (0, $befb786a0e8d5237$export$36d18380658d5d20)(props, this.props);
    }
    renderGroup(props) {
        const { selectedGroup: selectedGroup  } = this.state;
        return /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $9dffb1b349abc812$export$eb2fcfdbd7ba97d4), {
            selectedGroup: selectedGroup,
            onSelectGroup: this.handleSelectGroup,
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            groupProps: props,
            selectProps: this.props
        });
    }
    render() {
        const { chunky: chunky , creatable: creatable , disabled: disabled , // @ts-expect-error ts-migrate(2339) FIXME: Property 'meta' does not exist on type 'Readonly<A... Remove this comment to see the full error message
        meta: { invalid: invalid , touched: touched  } , defaultOptions: defaultOptions , cacheOptions: cacheOptions , isClearable: isClearable , components: selectComponents , reactSelectConfig: reactSelectConfig , menuPlacement: menuPlacement ,  } = this.props;
        const Select = creatable ? (0, $1mgSD$reactselectlibAsyncCreatable) : (0, $1mgSD$reactselectlibAsync);
        const selectProps = {
            value: this.nextValue()
        };
        return(// @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        /*#__PURE__*/ (0, $1mgSD$react).createElement(Select, {
            ...reactSelectConfig,
            components: {
                GroupHeading: ()=>null,
                Group: this.renderGroup,
                DropdownIndicator: $002f10c2b94ecd77$export$ec98719d3db7f2e4,
                Option: this.renderOption,
                ...selectComponents
            },
            isDisabled: disabled,
            isClearable: isClearable,
            onChange: this.onChange,
            styles: (0, $28f28f30df27e3c4$export$70a9ea0b017c448a)({
                chunky: chunky,
                invalid: invalid && touched
            }),
            loadOptions: this.loadAndStashOptions,
            cacheOptions: cacheOptions,
            defaultOptions: defaultOptions,
            menuPlacement: menuPlacement,
            ...selectProps
        }));
    }
    constructor(props){
        super(props);
        this.nextValue = this.nextValue.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onMenuClose = this.onMenuClose.bind(this);
        this.onMenuOpen = this.onMenuOpen.bind(this);
        this.handleSelectGroup = this.handleSelectGroup.bind(this);
        this.renderGroup = this.renderGroup.bind(this);
        this.renderOption = this.renderOption.bind(this);
        this.loadAndStashOptions = this.loadAndStashOptions.bind(this);
        const { defaultOptions: defaultOptions  } = props;
        this.state = {
            selectedGroup: null,
            value: null,
            currentOptions: Array.isArray(defaultOptions) ? defaultOptions : []
        };
    }
}
(0, $1mgSD$swchelperslib_define_propertyjs)($ad2f8b73f442f9e6$export$aca05dd54e009a80, "defaultProps", {
    cacheOptions: true,
    chunky: false,
    components: {},
    creatable: false,
    defaultOptions: true,
    didSelectOption: ()=>null,
    disabled: false,
    input: {},
    isClearable: false,
    loadOptions: ()=>Promise.resolve([]),
    meta: {}
});


$parcel$exportWildcard($ca99b2599154b655$exports, $ee4112e8be1f7a04$exports);
$parcel$exportWildcard($ca99b2599154b655$exports, $28f28f30df27e3c4$exports);
$parcel$exportWildcard($ca99b2599154b655$exports, $ad2f8b73f442f9e6$exports);







const $d8a8286d48fb661d$export$4293276c0c0bdb9d = (0, $1mgSD$css)`
  -webkit-font-smoothing: antialiased;
  appearance: none;
  background-color: ${({ disabled: disabled , invalid: invalid , touched: touched  })=>{
    if (disabled) return 0, $aaac76de4690e7ff$export$545251b0d520f8ad;
    if (invalid && touched) return 0, $aaac76de4690e7ff$export$6c9b3104157f8389;
    return 0, $aaac76de4690e7ff$export$3b058bf22d3a92e9;
}};
  border: ${(0, $fd37c165946cdbcc$export$12879c7697ed953d)} solid ${({ invalid: invalid , touched: touched  })=>invalid && touched ? (0, $aaac76de4690e7ff$export$4c90220182e0b14) : (0, $aaac76de4690e7ff$export$545251b0d520f8ad)};
  border-radius: ${(0, $fd37c165946cdbcc$export$efa65fa1092f7420)};
  box-sizing: border-box;
  color: ${(0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f)};
  font-family: ${(0, $fe72a230606ab94c$export$a5975749f0374264)};
  font-size: 1rem;
  font-weight: initial;
  line-height: ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)}
  min-height: ${(0, $fd37c165946cdbcc$export$c34a6c87634beb3f)};
  outline: none;
  padding-left: .75rem;
  width: 100%;

  &::placeholder {
    color: ${(0, $aaac76de4690e7ff$export$abc95940fda32f98)};
  }

  &:disabled {
    border-color: ${(0, $aaac76de4690e7ff$export$545251b0d520f8ad)};
    cursor: not-allowed;
  }

  &:hover:not(:disabled), &:placeholder-shown:hover:not(:disabled), &:hover:not(:focus) {
    border-color: ${({ invalid: invalid , touched: touched  })=>invalid && touched ? (0, $aaac76de4690e7ff$export$4c90220182e0b14) : (0, $aaac76de4690e7ff$export$545251b0d520f8ad)};
  }

  &:focus:not(:disabled), &:focus:not(:disabled):hover {
    border-color: ${({ invalid: invalid , touched: touched  })=>invalid && touched ? (0, $aaac76de4690e7ff$export$4c90220182e0b14) : (0, $aaac76de4690e7ff$export$d913daa7170c2f9f)};
  }
`;
const $d8a8286d48fb661d$var$StyledInput = (0, $1mgSD$styledcomponents).input`
  ${$d8a8286d48fb661d$export$4293276c0c0bdb9d}

  height: ${(0, $fd37c165946cdbcc$export$c34a6c87634beb3f)};
`;
const $d8a8286d48fb661d$export$f5b8910cec6cf069 = ({ input: input , meta: meta , ...props })=>/*#__PURE__*/ (0, $1mgSD$react).createElement($d8a8286d48fb661d$var$StyledInput, {
        ...input,
        ...meta,
        ...props
    });






var $1213d3db19f84ee9$exports = {};
var $53c9552000f8bf77$exports = {};

$parcel$export($53c9552000f8bf77$exports, "Tooltip", function () { return $53c9552000f8bf77$export$28c660c63b792dea; });
$parcel$export($53c9552000f8bf77$exports, "InfoTooltip", function () { return $53c9552000f8bf77$export$dbdcde5ca046596e; });







const $53c9552000f8bf77$var$tooltipOptions = {
    modifiers: {
        addZIndex: {
            enabled: true,
            order: 810,
            fn: (data)=>({
                    ...data,
                    styles: {
                        ...data.styles,
                        zIndex: 20000,
                        fontFamily: (0, $fe72a230606ab94c$export$a5975749f0374264)
                    }
                })
        }
    }
};
const $53c9552000f8bf77$var$TooltipText = (0, $1mgSD$styledcomponents)((0, $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6))`
  color: ${(0, $aaac76de4690e7ff$export$3b058bf22d3a92e9)};
`;
const $53c9552000f8bf77$export$28c660c63b792dea = ({ content: content , children: children , position: position  })=>{
    const contentIsReactElement = /*#__PURE__*/ (0, $1mgSD$react).isValidElement(content);
    const tooltipProps = {
        position: position,
        popperOptions: $53c9552000f8bf77$var$tooltipOptions,
        arrow: true,
        animation: "fade",
        html: contentIsReactElement ? /*#__PURE__*/ (0, $1mgSD$react).createElement($53c9552000f8bf77$var$TooltipText, {
            small: true
        }, content) : undefined,
        title: typeof content === "string" ? content : undefined
    };
    return /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $1mgSD$Tooltip), tooltipProps, children);
};
$53c9552000f8bf77$export$28c660c63b792dea.defaultProps = {
    position: "top"
};
const $53c9552000f8bf77$export$dbdcde5ca046596e = ({ content: content  })=>/*#__PURE__*/ (0, $1mgSD$react).createElement($53c9552000f8bf77$export$28c660c63b792dea, {
        content: content
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement("span", null, "\xa0", /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $1mgSD$FontAwesomeIcon), {
        icon: [
            "far",
            "info-circle"
        ],
        color: (0, $aaac76de4690e7ff$export$4b03d8f78bb232ec)
    })));


$parcel$exportWildcard($1213d3db19f84ee9$exports, $53c9552000f8bf77$exports);


const $64be58195b6ad3f8$var$InputBlockContainer = (0, $1mgSD$styledcomponents).div`
  width: 100%;
`;
const $64be58195b6ad3f8$var$LabelContainer = (0, $1mgSD$styledcomponents).div`
  line-height: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  margin-bottom: ${(0, $fd37c165946cdbcc$export$4c16e5a80ec60b32)};
  padding-left: 1px;
`;
const $64be58195b6ad3f8$var$ErrorInfoContainer = (0, $1mgSD$styledcomponents).div`
  min-height: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  margin-top: ${(0, $fd37c165946cdbcc$export$79a18a7d58eb5909)};
  padding-left: 1px;
`;
const $64be58195b6ad3f8$var$Required = (0, $1mgSD$styledcomponents).span`
  -webkit-font-smoothing: antialiased;
  font-size: 1.125rem;
  font-weight: bold;
  vertical-align: middle;
`;
const $64be58195b6ad3f8$var$Sublabel = (0, $1mgSD$styledcomponents)((0, $557c3ea4bde01476$export$b04be29aa201d4f5)).attrs({
    light: true
})`
  padding-left: 5px;
`;
function $64be58195b6ad3f8$export$83678641c7770fa5(Component) {
    const InputBlockComponent = (props)=>{
        const { className: className , disabled: disabled , info: info , label: label , sublabel: sublabel , meta: meta , name: name , required: required , tooltip: tooltip  } = props;
        const { error: error , touched: touched  } = meta || {};
        const hasError = error && touched;
        return /*#__PURE__*/ (0, $1mgSD$react).createElement($64be58195b6ad3f8$var$InputBlockContainer, {
            className: className
        }, label ? /*#__PURE__*/ (0, $1mgSD$react).createElement($64be58195b6ad3f8$var$LabelContainer, null, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $557c3ea4bde01476$export$b04be29aa201d4f5), {
            htmlFor: name,
            light: disabled
        }, label), sublabel && /*#__PURE__*/ (0, $1mgSD$react).createElement($64be58195b6ad3f8$var$Sublabel, null, sublabel), /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $557c3ea4bde01476$export$b04be29aa201d4f5), {
            htmlFor: name,
            light: disabled
        }, required ? /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $c82a557ce75f4fea$export$95d05bdc75950145), {
            inline: true
        }, "\xa0", /*#__PURE__*/ (0, $1mgSD$react).createElement($64be58195b6ad3f8$var$Required, null, "*")) : null, tooltip && /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $53c9552000f8bf77$export$dbdcde5ca046596e), {
            content: tooltip
        }))) : null, /*#__PURE__*/ (0, $1mgSD$react).createElement(Component, props), (hasError || info) && /*#__PURE__*/ (0, $1mgSD$react).createElement($64be58195b6ad3f8$var$ErrorInfoContainer, null, hasError ? /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $c82a557ce75f4fea$export$95d05bdc75950145), null, error) : null, !hasError && info ? /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $7c7949b58e9af13d$export$ed2cd9eb2d1973f0), null, info) : null));
    };
    return InputBlockComponent;
}
$64be58195b6ad3f8$export$83678641c7770fa5.defaultProps = {
    input: {},
    meta: {}
};













const $93edf818f725e4a9$var$getHoverStyles = ({ value: value , invalid: invalid , isDisabled: isDisabled , touched: touched  })=>!value && !isDisabled && `
  label:hover > &, input[type="checkbox"]:focus + &, &:hover {
    background-color: ${invalid && touched ? (0, $aaac76de4690e7ff$export$da9db0a7af92f233) : (0, $aaac76de4690e7ff$export$775ceeacde47cab2)};
  }
`;
const $93edf818f725e4a9$export$763817fece9a8c9d = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$210ea85e49c56827))`
  background-color: ${({ value: value , invalid: invalid , isDisabled: isDisabled , touched: touched  })=>{
    if (isDisabled) return 0, $aaac76de4690e7ff$export$545251b0d520f8ad;
    if (invalid && touched) return value ? (0, $aaac76de4690e7ff$export$689894fd5b69c1a5) : (0, $aaac76de4690e7ff$export$6c9b3104157f8389);
    return value ? (0, $aaac76de4690e7ff$export$d913daa7170c2f9f) : "transparent";
}};
  border: ${(0, $fd37c165946cdbcc$export$12879c7697ed953d)} solid;
  border-color: ${({ value: value , invalid: invalid , isDisabled: isDisabled , touched: touched  })=>{
    if (isDisabled) return 0, $aaac76de4690e7ff$export$abc95940fda32f98;
    if (invalid && touched) return 0, $aaac76de4690e7ff$export$689894fd5b69c1a5;
    return value ? (0, $aaac76de4690e7ff$export$d913daa7170c2f9f) : (0, $aaac76de4690e7ff$export$abc95940fda32f98);
}};
  border-radius: ${(0, $fd37c165946cdbcc$export$7a57f79000377ca2)};
  box-sizing: border-box;
  height: 1rem;
  margin-right: ${(0, $fd37c165946cdbcc$export$79a18a7d58eb5909)};
  min-width: 1rem;
  width: 1rem;

  ${$93edf818f725e4a9$var$getHoverStyles}
  }
`;
const $93edf818f725e4a9$export$4f481e0a96cfbed6 = ({ value: value , isDisabled: isDisabled , isPartial: isPartial , meta: meta  })=>{
    return /*#__PURE__*/ $1mgSD$createElement($93edf818f725e4a9$export$763817fece9a8c9d, {
        ...meta,
        verticallyAlignContent: true,
        horizontallyAlignContent: true,
        value: value,
        isDisabled: isDisabled
    }, value && !isPartial && /*#__PURE__*/ $1mgSD$createElement((0, $1mgSD$FontAwesomeIcon), {
        size: "20",
        icon: [
            "far",
            "check"
        ],
        color: (0, $aaac76de4690e7ff$export$3b058bf22d3a92e9)
    }), value && isPartial && /*#__PURE__*/ $1mgSD$createElement((0, $1mgSD$FontAwesomeIcon), {
        size: "20",
        icon: [
            "far",
            "minus"
        ],
        color: (0, $aaac76de4690e7ff$export$3b058bf22d3a92e9)
    }));
};
$93edf818f725e4a9$export$4f481e0a96cfbed6.defaultProps = {
    isPartial: false,
    isDisabled: false
};


const $677d84d1ac71479b$var$Checkbox = (0, $1mgSD$styledcomponents).input`
  opacity: 0;
  position: absolute;
  z-index: -1;
`;
const $677d84d1ac71479b$var$Label = (0, $1mgSD$styledcomponents).label`
  align-items: flex-start;
  color: ${({ disabled: disabled  })=>disabled ? (0, $aaac76de4690e7ff$export$abc95940fda32f98) : (0, $aaac76de4690e7ff$export$c8d3f3dd12c2ba5f)};
  cursor: ${({ disabled: disabled  })=>disabled ? "not-allowed" : "pointer"};
  display: flex;
  font-family: ${(0, $fe72a230606ab94c$export$a5975749f0374264)};
  font-size: 0.875rem;
  font-weight: initial;
  text-transform: none;
  letter-spacing: 0;
  margin: 0;
`;
var $677d84d1ac71479b$var$_PureComponent;
class $677d84d1ac71479b$export$fa1253a65a9e747d extends ($677d84d1ac71479b$var$_PureComponent = $1mgSD$PureComponent) {
    render() {
        const { className: className , input: input , children: children , disabled: disabled , meta: meta  } = this.props;
        // Workaround since input is an optional property.
        const value = (input === null || input === void 0 ? void 0 : input.value) ? input.value : false;
        return /*#__PURE__*/ $1mgSD$createElement($677d84d1ac71479b$var$Label, {
            className: className,
            disabled: disabled
        }, /*#__PURE__*/ $1mgSD$createElement($677d84d1ac71479b$var$Checkbox, {
            ...input,
            disabled: disabled,
            type: "checkbox",
            checked: !!value
        }), /*#__PURE__*/ $1mgSD$createElement((0, $93edf818f725e4a9$export$4f481e0a96cfbed6), {
            value: value === true || value === "true",
            isDisabled: disabled,
            meta: meta || {}
        }), children);
    }
}
(0, $1mgSD$swchelperslib_define_propertyjs)($677d84d1ac71479b$export$fa1253a65a9e747d, "defaultProps", {
    children: null,
    className: "",
    disabled: false,
    meta: {}
});






const $94688993bd21fab5$var$InputIconContainer = (0, $1mgSD$styledcomponents).div`
  position: relative;
`;
const $94688993bd21fab5$var$IconContainer = (0, $1mgSD$styledcomponents).div`
  position: absolute;
  left: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  top: 50%;
  transform: translateY(-50%);
`;
const $94688993bd21fab5$var$PaddedInput = (0, $1mgSD$styledcomponents)((0, $d8a8286d48fb661d$export$f5b8910cec6cf069))`
  padding-left: ${(0, $fd37c165946cdbcc$export$545718d17558da76)};
`;
class $94688993bd21fab5$export$f8fea9f50a4bfae6 extends (0, $1mgSD$react).PureComponent {
    render() {
        const { className: className , icon: icon , ...props } = this.props;
        return /*#__PURE__*/ (0, $1mgSD$react).createElement($94688993bd21fab5$var$InputIconContainer, {
            className: className
        }, /*#__PURE__*/ (0, $1mgSD$react).createElement($94688993bd21fab5$var$IconContainer, null, icon), /*#__PURE__*/ (0, $1mgSD$react).createElement($94688993bd21fab5$var$PaddedInput, props));
    }
}







const $404694754b94de9e$var$InputPasswordContainer = (0, $1mgSD$styledcomponents).div`
  position: relative;
`;
const $404694754b94de9e$var$MaskPasswordToggle = (0, $1mgSD$styledcomponents)((0, $637b1423c417142a$export$a6c7ac8248d6e38a))`
  position: absolute;
  right: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  top: 50%;
  transform: translateY(-50%);
`;
class $404694754b94de9e$export$66ebaee5e192c141 extends (0, $1mgSD$react).PureComponent {
    toggleMasked() {
        this.setState((prevState)=>({
                masked: !prevState.masked
            }));
    }
    render() {
        const { className: className  } = this.props;
        const { masked: masked  } = this.state;
        return /*#__PURE__*/ (0, $1mgSD$react).createElement($404694754b94de9e$var$InputPasswordContainer, {
            className: className
        }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $d8a8286d48fb661d$export$f5b8910cec6cf069), {
            ...this.props,
            type: masked ? "password" : "text"
        }), /*#__PURE__*/ (0, $1mgSD$react).createElement($404694754b94de9e$var$MaskPasswordToggle, {
            small: true,
            onClick: this.toggleMasked
        }, masked ? "Show" : "Hide"));
    }
    constructor(props){
        super(props);
        this.toggleMasked = this.toggleMasked.bind(this);
        this.state = {
            masked: true
        };
    }
}





const $24345a848f7a9137$var$inputRowPhoneCss = (0, $1mgSD$css)`
  flex-direction: column;
  align-items: stretch;
  > *:not(:last-child) {
    margin: auto auto ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  }
`;
const $24345a848f7a9137$var$getEvenlyGrowContentProps = ({ children: children , evenlyGrowContent: evenlyGrowContent  })=>{
    return evenlyGrowContent && `
    > * {
      ${undefined /* @ts-expect-error technically children can be a string */ }
      width: calc((100% / ${children === null || children === void 0 ? void 0 : children.length}));
    }
  `;
};
const $24345a848f7a9137$var$phoneStyle = (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).phone`${$24345a848f7a9137$var$inputRowPhoneCss}`;
const $24345a848f7a9137$export$2fe4f0576c8a371 = (0, $1mgSD$styledcomponents).div`
  display: flex;
  margin-bottom: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};

  ${$24345a848f7a9137$var$getEvenlyGrowContentProps}

  > *:not(:last-child) {
    margin-right: ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)};
  }

  ${$24345a848f7a9137$var$phoneStyle}
`;





const $a7691ccff838311a$var$StyledInputTextArea = (0, $1mgSD$styledcomponents).textarea`
  ${(0, $d8a8286d48fb661d$export$4293276c0c0bdb9d)}

  display: block; // removes default textarea margin
  height: ${({ small: small  })=>small ? "4rem" : "5rem"};
  padding: 0.75rem;
  resize: none;
`;
const $a7691ccff838311a$export$26542d43b3209548 = ({ input: input , meta: meta , ...props })=>/*#__PURE__*/ (0, $1mgSD$react).createElement($a7691ccff838311a$var$StyledInputTextArea, {
        ...input,
        ...meta,
        ...props
    });









const $4d7b46a4a27c7b9a$var$WhiteIcon = (0, $1mgSD$styledcomponents)((0, $1mgSD$FontAwesomeIcon))`
  color: ${(0, $5c4c6b5a115de467$export$eaad8caa32d2521d).altoColorsW};
  margin-top: ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).xsSpacing};
  .svg-inline--fa {
    height: ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).xsSpacing};
  }
`;
const $4d7b46a4a27c7b9a$var$getDisabledStylesForLabel = ({ disabled: disabled  })=>disabled && `
  cursor: not-allowed;
`;
const $4d7b46a4a27c7b9a$var$Label = (0, $1mgSD$styledcomponents).label`
  align-items: center;
  color: ${(0, $5c4c6b5a115de467$export$eaad8caa32d2521d).altoColorsB3};
  cursor: pointer;
  display: flex;
  font-family: ${(0, $fe72a230606ab94c$export$ed2f7e77161669d)};
  font-size: 0.875rem;
  font-weight: initial;

  ${$4d7b46a4a27c7b9a$var$getDisabledStylesForLabel}
`;
const $4d7b46a4a27c7b9a$var$SpacedToggle = (0, $1mgSD$styledcomponents)((0, $1mgSD$reacttoggle))`
  margin-right: ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).xsSpacing};
  .react-toggle-track-check {
    margin-top: ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).xxsSpacing};
    svg {
      margin-top: 0;
    }
  }
`;
class $4d7b46a4a27c7b9a$export$ed3c6fc36a947b6a extends $1mgSD$PureComponent {
    render() {
        const { className: className , input: input , disabled: disabled , children: children  } = this.props;
        const { value: value , onChange: onChange  } = input;
        return /*#__PURE__*/ $1mgSD$createElement($4d7b46a4a27c7b9a$var$Label, {
            className: className,
            disabled: disabled
        }, /*#__PURE__*/ $1mgSD$createElement($4d7b46a4a27c7b9a$var$SpacedToggle, {
            checked: !!value || false,
            onChange: onChange,
            disabled: disabled,
            icons: {
                checked: /*#__PURE__*/ $1mgSD$createElement($4d7b46a4a27c7b9a$var$WhiteIcon, {
                    icon: [
                        "far",
                        "check"
                    ]
                }),
                unchecked: null
            }
        }), children);
    }
}












const $c328e71ca7dcf855$var$ImageContainer = (0, $1mgSD$styledcomponents).div`
  width: 100%;
  background-color: ${(0, $5c4c6b5a115de467$export$eaad8caa32d2521d).altoColorsP3};
  border-radius: 8px;
  padding: ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).smSpacing};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  overflow: hidden;
`;
const $c328e71ca7dcf855$var$ActionButton = (0, $1mgSD$styledcomponents)((0, $2cef4ff485e6f14d$export$353f5b6fc5456de1))`
  width: 100%;
  margin-top: ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).smSpacing};
`;
const $c328e71ca7dcf855$var$getBackgroundImageStyle = ({ url: url  })=>`url(${url})`;
const $c328e71ca7dcf855$var$ImagePreview = (0, $1mgSD$styledcomponents).div`
  position: relative;
  height: 200px;
  width: 100%;
  background-image: ${$c328e71ca7dcf855$var$getBackgroundImageStyle};
  background-color: transparent;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
`;
const $c328e71ca7dcf855$var$Centered = (0, $1mgSD$styledcomponents).div`
  text-align: center;
`;
const $c328e71ca7dcf855$var$TrashButton = (0, $1mgSD$styledcomponents)((0, $2cef4ff485e6f14d$export$353f5b6fc5456de1))`
  position: absolute;
  top: ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).smSpacing};
  right: ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).smSpacing};
  height: calc(${(0, $5c4c6b5a115de467$export$5458b64234d1333c).buttonBorderRadius} * 2);
  width: calc(${(0, $5c4c6b5a115de467$export$5458b64234d1333c).buttonBorderRadius} * 2);
`;
const $c328e71ca7dcf855$export$eaa555e7f7268368 = ({ onChange: onChange , value: value , uploadText: uploadText , removeText: removeText , id: id , types: types , disabled: disabled  })=>{
    const onDrop = (filesToUpload)=>{
        onChange(filesToUpload);
    };
    const onClickRemove = (e)=>{
        e.stopPropagation();
        onDrop(null);
    };
    let previewURL;
    if (value) {
        if (typeof value === "string") previewURL = value;
        else if (value[0]) previewURL = value[0].preview;
    }
    return /*#__PURE__*/ $1mgSD$createElement((0, $1mgSD$reactdropzone), {
        disableClick: disabled,
        accept: types,
        className: "image-drop",
        inputProps: {
            id: id
        },
        multiple: false,
        onDrop: onDrop
    }, /*#__PURE__*/ $1mgSD$createElement($c328e71ca7dcf855$var$ImageContainer, null, previewURL ? /*#__PURE__*/ $1mgSD$createElement($c328e71ca7dcf855$var$ImagePreview, {
        url: previewURL
    }, /*#__PURE__*/ $1mgSD$createElement($c328e71ca7dcf855$var$TrashButton, {
        disabled: disabled,
        onClick: onClickRemove,
        "aria-label": removeText
    }, /*#__PURE__*/ $1mgSD$createElement((0, $1mgSD$FontAwesomeIcon), {
        icon: (0, $1mgSD$faTrashAlt),
        color: (0, $5c4c6b5a115de467$export$eaad8caa32d2521d).altoColorsB7,
        size: "sm"
    }))) : /*#__PURE__*/ $1mgSD$createElement($c328e71ca7dcf855$var$Centered, {
        key: "icon"
    }, /*#__PURE__*/ $1mgSD$createElement((0, $1mgSD$FontAwesomeIcon), {
        icon: (0, $1mgSD$faCamera),
        color: (0, $5c4c6b5a115de467$export$eaad8caa32d2521d).altoColorsP1,
        size: "lg"
    }), /*#__PURE__*/ $1mgSD$createElement($c328e71ca7dcf855$var$ActionButton, {
        kind: "secondary",
        onClick: ()=>{}
    }, uploadText))));
};
$c328e71ca7dcf855$export$eaa555e7f7268368.defaultProps = {
    disabled: false,
    meta: {},
    uploadText: "Upload File",
    id: "ImgInput",
    removeText: "Remove Image",
    types: ".png, .jpg, .jpeg, .svg, .bmp, .heic"
};


/**
 * These are convenience components so that they don't have
 * to be redefined for each form.
 */ const $4a4b332837f5a160$export$cefd80352569a33f = (0, $64be58195b6ad3f8$export$83678641c7770fa5)((0, $ad2f8b73f442f9e6$export$aca05dd54e009a80));
const $4a4b332837f5a160$export$c96a0b7a2d13d2eb = (0, $64be58195b6ad3f8$export$83678641c7770fa5)((0, $94688993bd21fab5$export$f8fea9f50a4bfae6));
const $4a4b332837f5a160$export$3afa4f47ece1183e = (0, $64be58195b6ad3f8$export$83678641c7770fa5)((0, $404694754b94de9e$export$66ebaee5e192c141));
const $4a4b332837f5a160$export$bc6fd9e82d599a3d = (0, $64be58195b6ad3f8$export$83678641c7770fa5)((0, $8beeebdb4fa059b6$export$a98f0dcb43a68a25));
const $4a4b332837f5a160$export$f08696a21e869131 = (0, $64be58195b6ad3f8$export$83678641c7770fa5)((0, $ee4112e8be1f7a04$export$ef9b1a59e592288f));
const $4a4b332837f5a160$export$661bf7bf48ebd697 = (0, $64be58195b6ad3f8$export$83678641c7770fa5)((0, $d8a8286d48fb661d$export$f5b8910cec6cf069));
const $4a4b332837f5a160$export$6513660e47c22334 = (0, $64be58195b6ad3f8$export$83678641c7770fa5)((0, $a7691ccff838311a$export$26542d43b3209548));
const $4a4b332837f5a160$export$cfe4211e9d3c9baf = (0, $64be58195b6ad3f8$export$83678641c7770fa5)((0, $677d84d1ac71479b$export$fa1253a65a9e747d));
const $4a4b332837f5a160$export$7b65cb28f38300b0 = (0, $64be58195b6ad3f8$export$83678641c7770fa5)((0, $c328e71ca7dcf855$export$eaa555e7f7268368));



var $d48ae88a90296eff$exports = {};
var $e874f83c8a1f6111$exports = {};

$parcel$export($e874f83c8a1f6111$exports, "LoaderImage", function () { return $e874f83c8a1f6111$export$c018a577d7622cc2; });
$parcel$export($e874f83c8a1f6111$exports, "spinnerStyles", function () { return $e874f83c8a1f6111$export$ce595ec7e5ee3717; });
$parcel$export($e874f83c8a1f6111$exports, "Loader", function () { return $e874f83c8a1f6111$export$3b0d6d7590275603; });






const $e874f83c8a1f6111$export$c018a577d7622cc2 = (0, $1mgSD$styledcomponents)((0, $1mgSD$reactspinner))`
  margin: 0 auto;
  display: block;
  transform: translateX(50%);
  ${(0, $7865a0a530ffec11$export$c9da7f48cc950c1c)}
  > .react-spinner_bar {
    background-color: ${({ color: color  })=>color || (0, $aaac76de4690e7ff$export$abc95940fda32f98)};
  }
`;
const $e874f83c8a1f6111$var$LoaderText = (0, $1mgSD$styledcomponents).div`
  text-align: center;
  margin: 5px auto;
  color: ${(0, $aaac76de4690e7ff$export$b33c7b711cacd17d)};
  font-weight: 600;
  font-size: 16px;
`;
const $e874f83c8a1f6111$export$ce595ec7e5ee3717 = {
    ...(0, $7865a0a530ffec11$export$42ce4cda9cbee2be)({}),
    display: "block"
};
const $e874f83c8a1f6111$export$3b0d6d7590275603 = ({ text: text = "Loading..." , color: color  })=>/*#__PURE__*/ (0, $1mgSD$react).createElement("div", null, /*#__PURE__*/ (0, $1mgSD$react).createElement($e874f83c8a1f6111$export$c018a577d7622cc2, {
        color: color,
        style: $e874f83c8a1f6111$export$ce595ec7e5ee3717
    }), /*#__PURE__*/ (0, $1mgSD$react).createElement($e874f83c8a1f6111$var$LoaderText, null, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6), null, text)));


$parcel$exportWildcard($d48ae88a90296eff$exports, $e874f83c8a1f6111$exports);


var $ed023db431241b6d$exports = {};
var $0727668633077655$exports = {};

$parcel$export($0727668633077655$exports, "MenuList", function () { return $0727668633077655$export$d4c4e98c5044dc8; });




const $0727668633077655$var$StyledColumn = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$816b5d811295e6bc))`
  background-color: ${(0, $aaac76de4690e7ff$export$91270c6916e25d70)};
  > *:not(:last-child) {
    border-bottom: none;
  }
`;
function $0727668633077655$export$d4c4e98c5044dc8({ children: children  }) {
    return /*#__PURE__*/ (0, $1mgSD$react).createElement($0727668633077655$var$StyledColumn, null, children);
}


var $cf62e53ea5c67b66$exports = {};

$parcel$export($cf62e53ea5c67b66$exports, "MenuListSection", function () { return $cf62e53ea5c67b66$export$5bba17a75e56148; });





const $cf62e53ea5c67b66$var$HeaderCell = (0, $1mgSD$styledcomponents).div`
  background-color: ${(0, $aaac76de4690e7ff$export$91270c6916e25d70)};
  padding: ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)} ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)} ${(0, $fd37c165946cdbcc$export$79a18a7d58eb5909)};
`;
const $cf62e53ea5c67b66$var$StyledSection = (0, $1mgSD$styledcomponents).div`
  border: ${(0, $fd37c165946cdbcc$export$12879c7697ed953d)} solid ${(0, $aaac76de4690e7ff$export$545251b0d520f8ad)};
  > *:not(:last-child) {
    border-bottom: ${(0, $fd37c165946cdbcc$export$12879c7697ed953d)} solid ${(0, $aaac76de4690e7ff$export$545251b0d520f8ad)};
  }
`;
function $cf62e53ea5c67b66$export$5bba17a75e56148({ children: children , header: header  }) {
    return /*#__PURE__*/ (0, $1mgSD$react).createElement($cf62e53ea5c67b66$var$StyledSection, null, header && /*#__PURE__*/ (0, $1mgSD$react).createElement($cf62e53ea5c67b66$var$HeaderCell, null, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $7c81b819332fca34$export$88ef9fdaf11f7a1f), null, header)), children);
}
$cf62e53ea5c67b66$export$5bba17a75e56148.defaultProps = {
    header: undefined
};


var $f0a679e1c872a301$exports = {};

$parcel$export($f0a679e1c872a301$exports, "MenuItemCell", function () { return $f0a679e1c872a301$export$7b4818872fbcdbad; });



const $f0a679e1c872a301$export$7b4818872fbcdbad = (0, $1mgSD$styledcomponents).div`
  background-color: ${(0, $aaac76de4690e7ff$export$ed73c413f4c945c9)};
  padding: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)} ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  ${({ onClick: onClick  })=>onClick ? "cursor: pointer;" : ""}
`;


var $037ea5c68628999e$exports = {};

$parcel$export($037ea5c68628999e$exports, "ActionMenuItemCell", function () { return $037ea5c68628999e$export$fc84c46964d578db; });





function $037ea5c68628999e$export$fc84c46964d578db({ leftText: leftText , onClick: onClick , rightText: rightText , rightIcon: rightIcon  }) {
    return /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $f0a679e1c872a301$export$7b4818872fbcdbad), {
        onClick: onClick
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e1c47a8b6d5f9c8f$export$b59bdbef9ce70de2), {
        evenlySizeContent: true,
        verticallyAlignContent: true
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6), null, leftText), /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e1c47a8b6d5f9c8f$export$b59bdbef9ce70de2), {
        rightAlignContent: true,
        verticallyAlignContent: true,
        spacing: (0, $fd37c165946cdbcc$export$54c7853c55b55e72)
    }, rightText && /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6), null, rightText), rightIcon)));
}
$037ea5c68628999e$export$fc84c46964d578db.defaultProps = {
    rightText: undefined
};


var $5a09e5884d653722$exports = {};

$parcel$export($5a09e5884d653722$exports, "CustomActionMenuItemCell", function () { return $5a09e5884d653722$export$90b86373fbbb2510; });





function $5a09e5884d653722$export$90b86373fbbb2510({ children: children , onClick: onClick , rightText: rightText , rightIcon: rightIcon  }) {
    return /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $f0a679e1c872a301$export$7b4818872fbcdbad), {
        onClick: onClick
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e1c47a8b6d5f9c8f$export$b59bdbef9ce70de2), {
        evenlySpaceContent: true,
        verticallyAlignContent: true
    }, children, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e1c47a8b6d5f9c8f$export$b59bdbef9ce70de2), {
        rightAlignContent: true,
        verticallyAlignContent: true,
        spacing: (0, $fd37c165946cdbcc$export$54c7853c55b55e72)
    }, rightText && /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6), null, rightText), rightIcon)));
}
$5a09e5884d653722$export$90b86373fbbb2510.defaultProps = {
    rightText: undefined
};


$parcel$exportWildcard($ed023db431241b6d$exports, $0727668633077655$exports);
$parcel$exportWildcard($ed023db431241b6d$exports, $cf62e53ea5c67b66$exports);
$parcel$exportWildcard($ed023db431241b6d$exports, $f0a679e1c872a301$exports);
$parcel$exportWildcard($ed023db431241b6d$exports, $037ea5c68628999e$exports);
$parcel$exportWildcard($ed023db431241b6d$exports, $5a09e5884d653722$exports);


var $de8e1bbf6e418695$exports = {};
var $18402993803c3fd1$exports = {};

$parcel$export($18402993803c3fd1$exports, "ModalBody", function () { return $18402993803c3fd1$export$cb540d8b0ef7906c; });
$parcel$export($18402993803c3fd1$exports, "ALIGNMENTS", function () { return $18402993803c3fd1$export$ef140b2b29a1e3bc; });
$parcel$export($18402993803c3fd1$exports, "ModalContent", function () { return $18402993803c3fd1$export$6da19a24bf249f17; });
$parcel$export($18402993803c3fd1$exports, "ModalHeader", function () { return $18402993803c3fd1$export$f50a68e3694789ee; });
$parcel$export($18402993803c3fd1$exports, "ModalFooter", function () { return $18402993803c3fd1$export$519437715052e656; });
$parcel$export($18402993803c3fd1$exports, "ModalContainer", function () { return $18402993803c3fd1$export$c9554889b3e706cd; });
$parcel$export($18402993803c3fd1$exports, "Modal", function () { return $18402993803c3fd1$export$2b77a92f1a5ad772; });




var $21a048999b0ee84d$exports = {};
var $3b833d90f77be911$exports = {};

$parcel$export($3b833d90f77be911$exports, "Overlay", function () { return $3b833d90f77be911$export$c6fdb837b070b4ff; });





const $00e92e0211fb909f$export$82e6205b15e6c637 = (0, $1mgSD$keyframes)`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;


const $3b833d90f77be911$var$DURATION = 300; // ms
const $3b833d90f77be911$var$durationCss = (0, $1mgSD$css)`
  ${(0, $00e92e0211fb909f$export$82e6205b15e6c637)} ${$3b833d90f77be911$var$DURATION}ms
`;
const $3b833d90f77be911$var$OverlayContainer = (0, $1mgSD$styledcomponents).span`
  align-items: center;
  animation: ${({ transitionState: transitionState , disableTransition: disableTransition  })=>{
    if (disableTransition) return "none";
    switch(transitionState){
        case "entering":
        case "entered":
            return $3b833d90f77be911$var$durationCss;
        default:
            return "none";
    }
}};
  bottom: 0;
  display: ${({ showing: showing  })=>showing ? "block" : "none"};
  left: 0;
  overflow-y: auto;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1000;
`;
var $3b833d90f77be911$var$_PureComponent;
class $3b833d90f77be911$export$c6fdb837b070b4ff extends ($3b833d90f77be911$var$_PureComponent = (0, $1mgSD$react).PureComponent) {
    componentWillUnmount() {
        if (document.body) document.body.removeEventListener("keydown", this.onEsc);
    }
    onClickContainer(e) {
        const { dismissable: dismissable , onClose: onClose  } = this.props;
        // currentTarget is the overlay itself, so don't close if we're clicking
        // another element (ie, the overlay's children)
        if (e.target !== e.currentTarget) return;
        if (dismissable) onClose();
    }
    onEntering() {
        if (document.body) document.body.addEventListener("keydown", this.onEsc);
    }
    onExiting() {
        if (document.body) document.body.removeEventListener("keydown", this.onEsc);
    }
    onEsc(e) {
        const { dismissable: dismissable , onClose: onClose  } = this.props;
        if (e.keyCode === 27 && dismissable) onClose();
    }
    render() {
        const { children: children , showing: showing , disableTransition: disableTransition  } = this.props;
        return /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $1mgSD$Transition), {
            appear: true,
            in: showing,
            onEntering: this.onEntering,
            onExiting: this.onExiting,
            timeout: $3b833d90f77be911$var$DURATION
        }, (state)=>/*#__PURE__*/ (0, $1mgSD$react).createElement($3b833d90f77be911$var$OverlayContainer, {
                onClick: this.onClickContainer,
                showing: showing,
                transitionState: state,
                disableTransition: disableTransition
            }, children));
    }
    constructor(props){
        super(props);
        this.onClickContainer = this.onClickContainer.bind(this);
        this.onEntering = this.onEntering.bind(this);
        this.onExiting = this.onExiting.bind(this);
        this.onEsc = this.onEsc.bind(this);
    }
}
(0, $1mgSD$swchelperslib_define_propertyjs)($3b833d90f77be911$export$c6fdb837b070b4ff, "defaultProps", {
    children: null,
    dismissable: true,
    disableTransition: undefined
});


$parcel$exportWildcard($21a048999b0ee84d$exports, $3b833d90f77be911$exports);






const $18402993803c3fd1$var$Backdrop = (0, $1mgSD$styledcomponents).div`
  transition: all 0.5s;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
`;
const $18402993803c3fd1$var$tabletStyles = (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).smTablet`
  max-width: unset;
  width: 100%;
  max-height: calc(100% - ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).mdSpacing} * 2);
`;
const $18402993803c3fd1$export$cb540d8b0ef7906c = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$210ea85e49c56827))`
  position: relative;
  overflow: hidden;
  background: ${(0, $5c4c6b5a115de467$export$eaad8caa32d2521d).white};
  border-radius: ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).smSpacing};
  max-width: 512px;
  width: 100%;
  max-height: calc(100% - ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).xlSpacing} * 2);
  ${$18402993803c3fd1$var$tabletStyles}
`;
const $18402993803c3fd1$var$fullscreenCss = (0, $1mgSD$css)`
  padding: 0;
  &:before,
  &:after {
    content: none;
  }
  ${$18402993803c3fd1$export$cb540d8b0ef7906c} {
    width: 100%;
    flex: 1;
    border-radius: 0;
    max-width: none;
  }
`;
const $18402993803c3fd1$var$DismissContainer = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$210ea85e49c56827)).attrs({
    verticallyAlignContent: true,
    horizontallyAlignContent: true
})`
  background-color: ${(0, $5c4c6b5a115de467$export$eaad8caa32d2521d).navyTint2};
  height: ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).lgSpacing};
  width: ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).lgSpacing};
  border-radius: 50%;
  margin-left: auto;
`;
const $18402993803c3fd1$export$ef140b2b29a1e3bc = {
    CENTER: "center",
    JUSTIFY: "justify",
    LEFT: "left",
    RIGHT: "right"
};
const $18402993803c3fd1$var$getBackgroundColor = ({ light: light  })=>light && `background-color: ${(0, $5c4c6b5a115de467$export$eaad8caa32d2521d).altoColorsWB3}`;
const $18402993803c3fd1$var$Outer = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$210ea85e49c56827))`
  overflow-y: auto;
  flex: 1;
  ${$18402993803c3fd1$var$getBackgroundColor};
`;
const $18402993803c3fd1$var$getPaddingStyle = ({ padding: padding  })=>`padding: ${padding || (0, $5c4c6b5a115de467$export$5458b64234d1333c).mdSpacing}`;
const $18402993803c3fd1$var$getTextAlignStyle = ({ textAlignment: textAlignment  })=>`text-align: ${textAlignment}`;
const $18402993803c3fd1$var$Inner = (0, $1mgSD$styledcomponents).div`
  ${$18402993803c3fd1$var$getPaddingStyle};
  ${$18402993803c3fd1$var$getTextAlignStyle};
`;
const $18402993803c3fd1$export$6da19a24bf249f17 = ({ light: light , children: children , className: className , padding: padding , textAlignment: textAlignment  })=>{
    return /*#__PURE__*/ (0, $1mgSD$react).createElement($18402993803c3fd1$var$Outer, {
        className: className,
        light: light
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement($18402993803c3fd1$var$Inner, {
        textAlignment: textAlignment,
        padding: padding
    }, children));
};
$18402993803c3fd1$export$6da19a24bf249f17.defaultProps = {
    light: undefined,
    className: undefined,
    padding: undefined,
    textAlignment: $18402993803c3fd1$export$ef140b2b29a1e3bc.CENTER
};
const $18402993803c3fd1$var$StyledH1 = (0, $1mgSD$styledcomponents)((0, $40d88124347685f5$export$5523b16adee8048))`
  grid-column-start: 2;
  text-align: center;
`;
const $18402993803c3fd1$export$f50a68e3694789ee = (0, $1mgSD$styledcomponents).div`
  display: grid;
  /* to center title while having dismiss button to the far right */
  grid-template-columns: 1fr auto 1fr;
  justify-items: center;
  padding: ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).mdSpacing} ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).mdSpacing} 0 ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).mdSpacing};
  position: relative;
`;
const $18402993803c3fd1$var$getBorderStyle = ({ borderless: borderless  })=>!borderless && `border-top: 1px solid ${(0, $5c4c6b5a115de467$export$eaad8caa32d2521d).dividerGrey};`;
const $18402993803c3fd1$export$519437715052e656 = (0, $1mgSD$styledcomponents).div`
  ${$18402993803c3fd1$var$getBorderStyle};
  padding: ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).mdSpacing};
`;
const $18402993803c3fd1$var$DismissIcon = (0, $1mgSD$styledcomponents)((0, $1mgSD$FontAwesomeIcon))`
  font-size: ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).smSpacing};
  color: ${(0, $5c4c6b5a115de467$export$eaad8caa32d2521d).grey1};
  &:hover {
    cursor: pointer;
  }
`;
const $18402993803c3fd1$var$noTitleCss = (0, $1mgSD$css)`
  ${$18402993803c3fd1$var$Inner} {
    padding-top: 0;
  }
  ${$18402993803c3fd1$export$f50a68e3694789ee} {
    padding-bottom: 0;
  }
`;
const $18402993803c3fd1$var$beforeFlexTablet = (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).smTablet`flex: 0 0 ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).mdSpacing};`;
const $18402993803c3fd1$var$beforeFlexPhone = (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).phone`flex: 0 0 ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).xsSpacing};`;
const $18402993803c3fd1$var$afterFlexTablet = (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).smTablet`flex: 0 1 ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).mdSpacing};`;
const $18402993803c3fd1$var$afterFlexPhone = (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).phone`flex: 0 0 ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).smSpacing};`;
const $18402993803c3fd1$var$phonePadding = (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).phone`padding: 0 ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).xsSpacing};`;
const $18402993803c3fd1$export$c9554889b3e706cd = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$210ea85e49c56827))`
  min-height: 100vh;
  padding: 0 ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).mdSpacing};
  justify-content: space-between;
  &:before {
    content: '';
    display: flex;
    flex: 0 0 ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).xlSpacing};
    ${$18402993803c3fd1$var$beforeFlexTablet}
    margin: auto;
    ${$18402993803c3fd1$var$beforeFlexPhone}
  }
  &:after {
    content: '';
    display: flex;
    flex: 0 1 ${(0, $5c4c6b5a115de467$export$5458b64234d1333c).xlSpacing};
    ${$18402993803c3fd1$var$afterFlexTablet}
    margin: auto;
    ${$18402993803c3fd1$var$afterFlexPhone}
  }
  ${({ fullscreen: fullscreen  })=>{
    if (fullscreen) return $18402993803c3fd1$var$fullscreenCss;
    return $18402993803c3fd1$var$phonePadding;
}}
  ${({ title: title  })=>!title && $18402993803c3fd1$var$noTitleCss}
`;
function $18402993803c3fd1$export$2b77a92f1a5ad772(props) {
    const { children: children , onClose: onClose , showDismiss: showDismiss , dismissOnOutsideClick: dismissOnOutsideClick , fullscreen: fullscreen , title: title , className: className , isLoading: isLoading  } = props;
    const onOutsideClick = ()=>{
        if (dismissOnOutsideClick) onClose();
    };
    return /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $1mgSD$react).Fragment, null, /*#__PURE__*/ (0, $1mgSD$react).createElement($18402993803c3fd1$var$Backdrop, null), /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $3b833d90f77be911$export$c6fdb837b070b4ff), {
        showing: true,
        dismissable: dismissOnOutsideClick,
        onClose: onClose,
        disableTransition: fullscreen
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement($18402993803c3fd1$export$c9554889b3e706cd, {
        horizontallyAlignContent: true,
        onClick: onOutsideClick,
        fullscreen: fullscreen,
        title: title,
        className: className
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement($18402993803c3fd1$export$cb540d8b0ef7906c, {
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement($18402993803c3fd1$export$f50a68e3694789ee, {
        className: "modal-header"
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement($18402993803c3fd1$var$StyledH1, null, title || ""), showDismiss && /*#__PURE__*/ (0, $1mgSD$react).createElement($18402993803c3fd1$var$DismissContainer, null, /*#__PURE__*/ (0, $1mgSD$react).createElement($18402993803c3fd1$var$DismissIcon, {
        icon: (0, $1mgSD$faTimes1),
        role: "button",
        "aria-label": "Close",
        onClick: onClose
    }))), isLoading && /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e874f83c8a1f6111$export$3b0d6d7590275603), null), !isLoading && children))));
}
$18402993803c3fd1$export$2b77a92f1a5ad772.defaultProps = {
    dismissOnOutsideClick: true,
    showDismiss: true,
    fullscreen: undefined,
    title: undefined,
    className: undefined
};


var $1cfc6f0a39d3d679$exports = {};

$parcel$export($1cfc6f0a39d3d679$exports, "DeprecatedModalHeader", function () { return $1cfc6f0a39d3d679$export$c1bd7a02ddc56666; });
$parcel$export($1cfc6f0a39d3d679$exports, "DeprecatedModalContainer", function () { return $1cfc6f0a39d3d679$export$f324f57e9339ad14; });
$parcel$export($1cfc6f0a39d3d679$exports, "DeprecatedModalContent", function () { return $1cfc6f0a39d3d679$export$ad4600fa0440495c; });
$parcel$export($1cfc6f0a39d3d679$exports, "DeprecatedModalFooter", function () { return $1cfc6f0a39d3d679$export$68fbfda2546c8c48; });
$parcel$export($1cfc6f0a39d3d679$exports, "DeprecatedModal", function () { return $1cfc6f0a39d3d679$export$49630308cfac7721; });











var $0f17e68a089fddfe$exports = {};

$parcel$export($0f17e68a089fddfe$exports, "ModalBodyWrapper", function () { return $0f17e68a089fddfe$export$e833dfe35f2086ee; });
$parcel$export($0f17e68a089fddfe$exports, "DeprecatedModalBody", function () { return $0f17e68a089fddfe$export$74861647dcdb9861; });




function $b460ae3a8f8b6d32$export$61fc7d43ac8f84b0(callback, wait) {
    let timeout = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (...args)=>{
        const next = ()=>callback(...args);
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(next, wait);
    };
}




const $0f17e68a089fddfe$var$shadowCss = (0, $1mgSD$css)`
  box-shadow: inset 0 -10px 10px -10px rgba(0, 0, 0, 0.1);
`;
const $0f17e68a089fddfe$export$e833dfe35f2086ee = (0, $1mgSD$styledcomponents).div`
  overflow-y: ${({ scrollable: scrollable  })=>scrollable ? "auto" : "unset"};
  padding: ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)};
  ${({ overflowed: overflowed , scrolledToBottom: scrolledToBottom  })=>overflowed && !scrolledToBottom && $0f17e68a089fddfe$var$shadowCss}
`;
const $0f17e68a089fddfe$var$ModalBodyContent = (0, $1mgSD$styledcomponents).div`
  min-height: min-content;
`;
var $0f17e68a089fddfe$var$_PureComponent;
class $0f17e68a089fddfe$export$74861647dcdb9861 extends ($0f17e68a089fddfe$var$_PureComponent = (0, $1mgSD$react).PureComponent) {
    componentDidUpdate() {
        /* eslint-disable react/no-did-update-set-state */ if (this.wrapperRef && this.contentRef) {
            if (this.wrapperRef.clientHeight < this.contentRef.clientHeight) this.setState({
                overflowed: true
            });
            else this.setState({
                overflowed: false
            });
        }
    }
    handleScroll() {
        if (this.wrapperRef) {
            if (this.wrapperRef.scrollHeight - this.wrapperRef.scrollTop === this.wrapperRef.clientHeight) this.setState({
                scrolledToBottom: true
            });
            else this.setState({
                scrolledToBottom: false
            });
        }
    }
    render() {
        const { scrollable: scrollable , children: children  } = this.props;
        const { overflowed: overflowed , scrolledToBottom: scrolledToBottom  } = this.state;
        return /*#__PURE__*/ (0, $1mgSD$react).createElement($0f17e68a089fddfe$export$e833dfe35f2086ee, {
            scrollable: scrollable,
            ref: (node)=>{
                this.wrapperRef = node;
            },
            overflowed: overflowed,
            scrolledToBottom: scrolledToBottom,
            onScroll: (0, $b460ae3a8f8b6d32$export$61fc7d43ac8f84b0)(this.handleScroll, 50)
        }, /*#__PURE__*/ (0, $1mgSD$react).createElement($0f17e68a089fddfe$var$ModalBodyContent, {
            ref: (node)=>{
                this.contentRef = node;
            }
        }, children));
    }
    constructor(props){
        super(props);
        this.handleScroll = this.handleScroll.bind(this);
        this.wrapperRef = null;
        this.contentRef = null;
        this.state = {
            overflowed: false,
            scrolledToBottom: false
        };
    }
}
(0, $1mgSD$swchelperslib_define_propertyjs)($0f17e68a089fddfe$export$74861647dcdb9861, "defaultProps", {
    children: null,
    scrollable: false
});


const $1cfc6f0a39d3d679$var$SIZES = Object.freeze({
    NARROW: "narrow",
    WIDE: "wide"
});
const $1cfc6f0a39d3d679$export$c1bd7a02ddc56666 = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$b1a401d0eced3e7))`
  border-top-left-radius: ${(0, $fd37c165946cdbcc$export$7a57f79000377ca2)};
  border-top-right-radius: ${(0, $fd37c165946cdbcc$export$7a57f79000377ca2)};
  box-sizing: border-box;
  background-color: ${(0, $aaac76de4690e7ff$export$76ad689e70c7691d)};
  border-bottom: ${(0, $fd37c165946cdbcc$export$12879c7697ed953d)} solid ${(0, $aaac76de4690e7ff$export$545251b0d520f8ad)};

  > *:not(:last-child) {
    margin-right: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  }
`;
const $1cfc6f0a39d3d679$var$ModalClose = (0, $1mgSD$styledcomponents)((0, $1mgSD$FontAwesomeIcon))`
  cursor: pointer;
`;
const $1cfc6f0a39d3d679$var$getModalWidth = (size)=>{
    if (size === $1cfc6f0a39d3d679$var$SIZES.NARROW) return "20rem";
    if (size === $1cfc6f0a39d3d679$var$SIZES.WIDE) return "60rem";
    return "40rem";
};
const $1cfc6f0a39d3d679$var$getVerticalMargin = (verticallyAlignContent)=>verticallyAlignContent ? "auto" : `${0, $fd37c165946cdbcc$export$70173e1228291b3c} auto`;
const $1cfc6f0a39d3d679$var$verticallyCenteredContainerCss = (0, $1mgSD$css)`
  align-items: center;
  justify-content: center;
  display: flex;
`;
const $1cfc6f0a39d3d679$var$topAlignedContainerCss = (0, $1mgSD$css)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
`;
const $1cfc6f0a39d3d679$var$containerPhoneCss = (0, $1mgSD$css)`
  margin: auto ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
  min-width: unset;
`;
const $1cfc6f0a39d3d679$var$phoneCss = (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).phone`${$1cfc6f0a39d3d679$var$containerPhoneCss}`;
const $1cfc6f0a39d3d679$export$f324f57e9339ad14 = (0, $1mgSD$styledcomponents).div`
  ${({ verticallyAlignContent: verticallyAlignContent  })=>verticallyAlignContent && $1cfc6f0a39d3d679$var$verticallyCenteredContainerCss}
  ${({ verticallyAlignContent: verticallyAlignContent  })=>!verticallyAlignContent && $1cfc6f0a39d3d679$var$topAlignedContainerCss}
  margin: auto ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)};
  min-width: calc(320px - ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)} * 2);
  height: 100%;
  ${$1cfc6f0a39d3d679$var$phoneCss}
`;
const $1cfc6f0a39d3d679$var$scrollingBodyWrapperCss = (0, $1mgSD$css)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;
const $1cfc6f0a39d3d679$var$scrollingContentCss = (0, $1mgSD$css)`
  max-height: calc(100% - ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)} * 2);
  > form {
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    overflow: hidden;
    > ${(0, $0f17e68a089fddfe$export$e833dfe35f2086ee)} {
      ${$1cfc6f0a39d3d679$var$scrollingBodyWrapperCss}
    }
  }
  > ${(0, $0f17e68a089fddfe$export$e833dfe35f2086ee)} {
    ${$1cfc6f0a39d3d679$var$scrollingBodyWrapperCss}
  }
`;
const $1cfc6f0a39d3d679$var$contentPhoneCss = (0, $1mgSD$css)`
  min-width: unset;
`;
const $1cfc6f0a39d3d679$var$modalContentPhoneStyle = (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).phone`${$1cfc6f0a39d3d679$var$contentPhoneCss}`;
const $1cfc6f0a39d3d679$export$ad4600fa0440495c = (0, $1mgSD$styledcomponents).div`
  ${({ scrollable: scrollable  })=>scrollable && $1cfc6f0a39d3d679$var$scrollingContentCss}
  ${(0, $5d0b63b3a27c519d$export$f7266ad9837f2dc4)};
  background-color: ${(0, $aaac76de4690e7ff$export$3b058bf22d3a92e9)};
  border-radius: ${(0, $fd37c165946cdbcc$export$7a57f79000377ca2)};
  margin: ${({ verticallyAlignContent: verticallyAlignContent  })=>$1cfc6f0a39d3d679$var$getVerticalMargin(verticallyAlignContent)};
  display: flex;
  flex-direction: column;
  width: ${({ size: size  })=>$1cfc6f0a39d3d679$var$getModalWidth(size)};
  min-width: calc(320px - ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)});
  @media (max-width: ${({ size: size  })=>$1cfc6f0a39d3d679$var$getModalWidth(size)}) {
    width: 100%;
  }
  ${$1cfc6f0a39d3d679$var$modalContentPhoneStyle}
`;
const $1cfc6f0a39d3d679$var$footerPhoneCss = (0, $1mgSD$css)`
  flex-direction: column-reverse;
  align-items: stretch;
  justify-content: center;
  min-height: min-content;
  > * {
    display: flex;
  }
  > *:not(:last-child) {
    margin-right: unset;
    margin-top: ${(0, $fd37c165946cdbcc$export$79a18a7d58eb5909)};
  }
`;
const $1cfc6f0a39d3d679$var$phoneStyle = (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).phone`${$1cfc6f0a39d3d679$var$footerPhoneCss}`;
const $1cfc6f0a39d3d679$export$68fbfda2546c8c48 = (0, $1mgSD$styledcomponents).div`
  align-items: center;
  border-top: ${(0, $fd37c165946cdbcc$export$12879c7697ed953d)} solid ${(0, $aaac76de4690e7ff$export$545251b0d520f8ad)};
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)} ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)};
  overflow: unset;

  > *:not(:last-child) {
    margin-right: ${(0, $fd37c165946cdbcc$export$79a18a7d58eb5909)};
  }

  ${$1cfc6f0a39d3d679$var$phoneStyle}
`;
const $1cfc6f0a39d3d679$var$ModalBackdrop = (0, $1mgSD$styledcomponents).div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #000;
  opacity: 0.5;
`;
var $1cfc6f0a39d3d679$var$_PureComponent;
class $1cfc6f0a39d3d679$export$49630308cfac7721 extends ($1cfc6f0a39d3d679$var$_PureComponent = (0, $1mgSD$react).PureComponent) {
    onClickContainer(e) {
        const { dismissable: dismissable , onClose: onClose  } = this.props;
        // currentTarget is the overlay itself, so don't close if we're clicking
        // another element (ie, the overlay's children)
        if (e.target !== e.currentTarget) return;
        if (dismissable) onClose();
    }
    render() {
        const { children: children , className: className , dismissable: dismissable , onClose: onClose , backdrop: backdrop , showing: showing , size: size , title: title , verticallyAlignContent: verticallyAlignContent , scrollable: scrollable ,  } = this.props;
        return /*#__PURE__*/ (0, $1mgSD$react).createElement("div", {
            className: className
        }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $3b833d90f77be911$export$c6fdb837b070b4ff), {
            dismissable: dismissable,
            onClose: onClose,
            showing: showing
        }, /*#__PURE__*/ (0, $1mgSD$react).createElement($1cfc6f0a39d3d679$export$f324f57e9339ad14, {
            onClick: this.onClickContainer,
            verticallyAlignContent: verticallyAlignContent
        }, /*#__PURE__*/ (0, $1mgSD$react).createElement($1cfc6f0a39d3d679$export$ad4600fa0440495c, {
            size: size,
            scrollable: scrollable,
            verticallyAlignContent: verticallyAlignContent
        }, /*#__PURE__*/ (0, $1mgSD$react).createElement($1cfc6f0a39d3d679$export$c1bd7a02ddc56666, {
            verticallyAlignContent: true,
            evenlySpaceContent: true,
            padding: `${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)} ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)}`,
            spacing: (0, $fd37c165946cdbcc$export$54c7853c55b55e72)
        }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $a65c84ab085b2e8e$export$746be9e3a3dfff1f), null, title), dismissable ? /*#__PURE__*/ (0, $1mgSD$react).createElement($1cfc6f0a39d3d679$var$ModalClose, {
            color: (0, $aaac76de4690e7ff$export$abc95940fda32f98),
            icon: [
                "far",
                "times"
            ],
            onClick: onClose
        }) : null), children))), showing && backdrop && /*#__PURE__*/ (0, $1mgSD$react).createElement($1cfc6f0a39d3d679$var$ModalBackdrop, null));
    }
    constructor(props){
        super(props);
        this.onClickContainer = this.onClickContainer.bind(this);
    }
}
(0, $1mgSD$swchelperslib_define_propertyjs)($1cfc6f0a39d3d679$export$49630308cfac7721, "defaultProps", {
    className: null,
    dismissable: true,
    size: undefined,
    verticallyAlignContent: true,
    scrollable: false,
    backdrop: true
});



$parcel$exportWildcard($de8e1bbf6e418695$exports, $18402993803c3fd1$exports);
$parcel$exportWildcard($de8e1bbf6e418695$exports, $1cfc6f0a39d3d679$exports);
$parcel$exportWildcard($de8e1bbf6e418695$exports, $0f17e68a089fddfe$exports);





var $9f1dea9396b5bad4$exports = {};
var $7c4394f68bf355bc$exports = {};

$parcel$export($7c4394f68bf355bc$exports, "Slider", function () { return $7c4394f68bf355bc$export$472062a354075cee; });

const $7c4394f68bf355bc$export$472062a354075cee = ({ slides: slides , render: render  })=>{
    const [slideIndex, setSlideIndex] = (0, $1mgSD$useState)(0);
    const CurrentSlideComponent = slides[slideIndex];
    return render({
        CurrentSlideComponent: CurrentSlideComponent,
        slideIndex: slideIndex,
        setSlideIndex: (index)=>{
            // Prevent slide index form going out of bounds
            const withinMax = Math.min(index, slides.length - 1);
            const withinMaxAndMin = Math.max(withinMax, 0);
            setSlideIndex(withinMaxAndMin);
        }
    });
};


var $777c540b44ed2dde$exports = {};

$parcel$export($777c540b44ed2dde$exports, "SliderNavigation", function () { return $777c540b44ed2dde$export$d8784f2bbeda3c7f; });








const $777c540b44ed2dde$var$ArrowButton = (0, $1mgSD$styledcomponents).button`
  border: none;
  border-radius: 50%;
  background: ${(0, $aaac76de4690e7ff$export$3209604dab7b9537)};
  width: ${(0, $fd37c165946cdbcc$export$9b8cd5b0d7315663)};
  height: ${(0, $fd37c165946cdbcc$export$9b8cd5b0d7315663)};
  display: flex;
  justify-content: center;
  align-items: center;
  outline: 0;
  cursor: pointer;
  &:disabled {
    background: none;
    border: 1px solid ${(0, $aaac76de4690e7ff$export$15e963ace12d673f)};
    cursor: auto;
  }
  &:focus&:not(:disabled),
  &:hover&:not(:disabled) {
    background-color: ${(0, $aaac76de4690e7ff$export$6d4bd4305d16dfab)};
  }
`;
const $777c540b44ed2dde$var$Dot = (0, $1mgSD$styledcomponents).div`
  border: 1px solid ${({ active: active  })=>active ? (0, $aaac76de4690e7ff$export$8bf7dff220b82b4a) : (0, $aaac76de4690e7ff$export$26de6a0f89719481)};
  border-radius: 50%;
  background: ${(props)=>props.active ? (0, $aaac76de4690e7ff$export$8bf7dff220b82b4a) : (0, $aaac76de4690e7ff$export$8fa4e5556fd77a60)};
  width: ${(0, $fd37c165946cdbcc$export$79a18a7d58eb5909)};
  height: ${(0, $fd37c165946cdbcc$export$79a18a7d58eb5909)};
`;
const $777c540b44ed2dde$var$CenteredRow = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$b59bdbef9ce70de2))`
  align-items: center;
`;
const $777c540b44ed2dde$export$d8784f2bbeda3c7f = ({ slideCount: slideCount , slideIndex: slideIndex , setSlideIndex: setSlideIndex  })=>{
    if (slideCount < 2) return null;
    const leftArrowDisabled = slideIndex === 0;
    const rightArrowDisabled = slideIndex === slideCount - 1;
    return /*#__PURE__*/ (0, $1mgSD$react).createElement($777c540b44ed2dde$var$CenteredRow, {
        evenlySpaceContent: true
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement($777c540b44ed2dde$var$ArrowButton, {
        "aria-label": "Previous Slide",
        type: "button",
        disabled: leftArrowDisabled,
        onClick: ()=>setSlideIndex(slideIndex - 1)
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $1mgSD$FontAwesomeIcon), {
        icon: (0, $1mgSD$faArrowLeft),
        color: leftArrowDisabled ? (0, $aaac76de4690e7ff$export$15e963ace12d673f) : (0, $aaac76de4690e7ff$export$26de6a0f89719481),
        size: "lg"
    })), /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e1c47a8b6d5f9c8f$export$b59bdbef9ce70de2), {
        spacing: (0, $fd37c165946cdbcc$export$79a18a7d58eb5909)
    }, Array(slideCount).fill(0).map((_, index)=>// eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $1mgSD$react).createElement($777c540b44ed2dde$var$Dot, {
            key: index,
            active: index === slideIndex
        }))), /*#__PURE__*/ (0, $1mgSD$react).createElement($777c540b44ed2dde$var$ArrowButton, {
        "aria-label": "Next Slide",
        type: "button",
        disabled: rightArrowDisabled,
        onClick: ()=>setSlideIndex(slideIndex + 1)
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $1mgSD$FontAwesomeIcon), {
        icon: (0, $1mgSD$faArrowRight),
        color: rightArrowDisabled ? (0, $aaac76de4690e7ff$export$15e963ace12d673f) : (0, $aaac76de4690e7ff$export$26de6a0f89719481),
        size: "lg"
    })));
};


$parcel$exportWildcard($9f1dea9396b5bad4$exports, $7c4394f68bf355bc$exports);
$parcel$exportWildcard($9f1dea9396b5bad4$exports, $777c540b44ed2dde$exports);


var $4d089d0bcc16b83e$exports = {};
var $ab36d9636a477b6c$exports = {};

$parcel$export($ab36d9636a477b6c$exports, "StaticTextBlock", function () { return $ab36d9636a477b6c$export$b3c0e60a51b74e9c; });



const $ab36d9636a477b6c$export$b3c0e60a51b74e9c = ({ className: className , input: input , label: label , tooltip: tooltip , info: info  })=>/*#__PURE__*/ (0, $1mgSD$react).createElement("div", {
        className: className
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $557c3ea4bde01476$export$b04be29aa201d4f5), null, label, tooltip && /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $53c9552000f8bf77$export$dbdcde5ca046596e), {
        content: tooltip
    })), /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6), null, input.value), info && /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $7c7949b58e9af13d$export$ed2cd9eb2d1973f0), null, info));


var $08f8ede1a9d06a70$exports = {};

$parcel$export($08f8ede1a9d06a70$exports, "StaticSelectBlock", function () { return $08f8ede1a9d06a70$export$e4f4a83e740a2b6c; });


class $08f8ede1a9d06a70$export$e4f4a83e740a2b6c extends (0, $1mgSD$react).Component {
    /**
   * react-select expects an OptionType as the value
   */ nextValue() {
        const { input: { value: value  } , options: options ,  } = this.props;
        const option = options.find((o)=>o.value === value);
        return option && option.label;
    }
    render() {
        const { className: className , label: label , info: info  } = this.props;
        return /*#__PURE__*/ (0, $1mgSD$react).createElement("div", {
            className: className
        }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $557c3ea4bde01476$export$b04be29aa201d4f5), null, label), /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6), null, this.nextValue.bind(this)()), info && /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $7c7949b58e9af13d$export$ed2cd9eb2d1973f0), null, info));
    }
    constructor(props){
        super(props);
        this.nextValue = this.nextValue.bind(this);
    }
}


$parcel$exportWildcard($4d089d0bcc16b83e$exports, $ab36d9636a477b6c$exports);
$parcel$exportWildcard($4d089d0bcc16b83e$exports, $08f8ede1a9d06a70$exports);


var $f57a01ae2cc96375$exports = {};
var $517093a4ef23f6fa$exports = {};

$parcel$export($517093a4ef23f6fa$exports, "Subway", function () { return $517093a4ef23f6fa$export$c6303e05f2c4327e; });





const $517093a4ef23f6fa$var$railColor = (colors, isComplete)=>{
    if (isComplete) return colors.complete;
    return colors.incomplete;
};
const $517093a4ef23f6fa$var$horizontalStationListCss = (0, $1mgSD$css)`
  margin-left: ${({ theme: { numStations: numStations  }  })=>100 / (2 * numStations)}%;
`;
const $517093a4ef23f6fa$var$verticalStationListCss = (0, $1mgSD$css)`
  margin-left: unset;
`;
const $517093a4ef23f6fa$var$getHorizontalStyle = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "never" && $517093a4ef23f6fa$var$horizontalStationListCss;
const $517093a4ef23f6fa$var$getHorizontalStyleDesktop = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).desktop`${$517093a4ef23f6fa$var$horizontalStationListCss}`;
const $517093a4ef23f6fa$var$getHorizontalStyleSmallDesktop = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).smDesktop`${$517093a4ef23f6fa$var$horizontalStationListCss}`;
const $517093a4ef23f6fa$var$getHorizontalStyleTablet = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).tablet`${$517093a4ef23f6fa$var$verticalStationListCss}`;
const $517093a4ef23f6fa$var$StationList = (0, $1mgSD$styledcomponents).ol`
  padding: 0;
  ${$517093a4ef23f6fa$var$getHorizontalStyle}
  ${$517093a4ef23f6fa$var$getHorizontalStyleDesktop}
  ${$517093a4ef23f6fa$var$getHorizontalStyleSmallDesktop}
  ${$517093a4ef23f6fa$var$getHorizontalStyleTablet}
`;
const $517093a4ef23f6fa$var$getHorizontalItemWidth = ({ theme: { numStations: numStations , isFinal: isFinal  }  })=>100 / (isFinal ? 4 * numStations - 2 : numStations - 0.5);
const $517093a4ef23f6fa$var$getHorizontalMarginLeft = ({ theme: { numStations: numStations , isInitial: isInitial  }  })=>isInitial ? 100 / (4 * numStations - 2) : 0;
const $517093a4ef23f6fa$var$horizontalStationListItemCss = (0, $1mgSD$css)`
  display: inline-block;
  vertical-align: top;
  width: ${$517093a4ef23f6fa$var$getHorizontalItemWidth}%;
  margin-left: ${$517093a4ef23f6fa$var$getHorizontalMarginLeft}%;
`;
const $517093a4ef23f6fa$var$verticalStationListItemCss = (0, $1mgSD$css)`
  display: block;
  width: unset;
  margin-left: 0;
`;
const $517093a4ef23f6fa$var$stationPadding = "0.75rem";
const $517093a4ef23f6fa$var$getListItemHorizontalStyle = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "never" && $517093a4ef23f6fa$var$horizontalStationListItemCss;
const $517093a4ef23f6fa$var$getListItemHorizontalStyleDesktop = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).desktop`${$517093a4ef23f6fa$var$horizontalStationListItemCss}`;
const $517093a4ef23f6fa$var$getListItemHorizontalStyleSmallDesktop = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).smDesktop`${$517093a4ef23f6fa$var$horizontalStationListItemCss}`;
const $517093a4ef23f6fa$var$getListItemHorizontalStyleTablet = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).tablet`${$517093a4ef23f6fa$var$verticalStationListItemCss}`;
const $517093a4ef23f6fa$var$getListItemHorizontalStyleAlways = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "always" && $517093a4ef23f6fa$var$verticalStationListItemCss;
const $517093a4ef23f6fa$var$StationListItem = (0, $1mgSD$styledcomponents).li`
  padding-bottom: ${$517093a4ef23f6fa$var$stationPadding};
  position: relative;
  z-index: 0;

  ${$517093a4ef23f6fa$var$getListItemHorizontalStyle}
  ${$517093a4ef23f6fa$var$getListItemHorizontalStyleDesktop}
  ${$517093a4ef23f6fa$var$getListItemHorizontalStyleSmallDesktop}
  ${$517093a4ef23f6fa$var$getListItemHorizontalStyleTablet}
  ${$517093a4ef23f6fa$var$getListItemHorizontalStyleAlways}
`;
const $517093a4ef23f6fa$var$baseRailCss = (0, $1mgSD$css)`
  left: 0;
  position: absolute;
  top: 0;
  z-index: -1;
`;
const $517093a4ef23f6fa$var$horizontalRailCss = (0, $1mgSD$css)`
  ${$517093a4ef23f6fa$var$baseRailCss}
  box-shadow: 0 0 0 1px ${({ theme: { colors: colors , isComplete: isComplete  }  })=>$517093a4ef23f6fa$var$railColor(colors, isComplete)};
  height: 0;
  width: 100%;
`;
const $517093a4ef23f6fa$var$verticalRailCss = (0, $1mgSD$css)`
  ${$517093a4ef23f6fa$var$baseRailCss}
  box-shadow: 0 1px 0 1px ${({ theme: { colors: colors , isComplete: isComplete  }  })=>$517093a4ef23f6fa$var$railColor(colors, isComplete)};
  height: 100%;
  width: 0;
`;
const $517093a4ef23f6fa$var$verticalCenteredRailCss = (0, $1mgSD$css)`
  ${$517093a4ef23f6fa$var$verticalRailCss}
  top: 50%;
`;
const $517093a4ef23f6fa$var$getHorizontalRailStyle = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "never" && $517093a4ef23f6fa$var$horizontalRailCss;
const $517093a4ef23f6fa$var$getHorizontalRailStyleDesktop = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).desktop`${$517093a4ef23f6fa$var$horizontalRailCss}`;
const $517093a4ef23f6fa$var$getHorizontalRailStyleSmallDesktop = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).smDesktop`${$517093a4ef23f6fa$var$horizontalRailCss}`;
const $517093a4ef23f6fa$var$getHorizontalRailStyleTabletNoCenter = ({ theme: { verticalEnabled: verticalEnabled , isVerticallyCentered: isVerticallyCentered  }  })=>verticalEnabled === "mobile" && !isVerticallyCentered && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).tablet`${$517093a4ef23f6fa$var$verticalRailCss}`;
const $517093a4ef23f6fa$var$getHorizontalRailStyleTablet = ({ theme: { verticalEnabled: verticalEnabled , isVerticallyCentered: isVerticallyCentered  }  })=>verticalEnabled === "mobile" && isVerticallyCentered && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).tablet`${$517093a4ef23f6fa$var$verticalCenteredRailCss}`;
const $517093a4ef23f6fa$var$getHorizontalRailStyleAlways = ({ theme: { verticalEnabled: verticalEnabled , isVerticallyCentered: isVerticallyCentered  }  })=>verticalEnabled === "always" && !isVerticallyCentered && $517093a4ef23f6fa$var$verticalRailCss;
const $517093a4ef23f6fa$var$railCss = (0, $1mgSD$css)`
  ${$517093a4ef23f6fa$var$getHorizontalRailStyle}
  ${$517093a4ef23f6fa$var$getHorizontalRailStyleDesktop}
  ${$517093a4ef23f6fa$var$getHorizontalRailStyleSmallDesktop}
  ${$517093a4ef23f6fa$var$getHorizontalRailStyleTabletNoCenter}
  ${$517093a4ef23f6fa$var$getHorizontalRailStyleTablet}
  ${$517093a4ef23f6fa$var$getHorizontalRailStyleAlways}
`;
const $517093a4ef23f6fa$var$Rail = (0, $1mgSD$styledcomponents).div`
  ${$517093a4ef23f6fa$var$railCss}
`;
const $517093a4ef23f6fa$var$getTopRailStyle = ({ theme: { colors: colors , isActive: isActive , isComplete: isComplete , isInitial: isInitial  }  })=>{
    if (isInitial) return "";
    const color = isActive || isComplete ? colors.complete : colors.incomplete;
    return (0, $1mgSD$css)`
    ${$517093a4ef23f6fa$var$baseRailCss};
    box-shadow: 0 1px 0 1px ${color};
    height: calc((100% - ${$517093a4ef23f6fa$var$stationPadding}) / 2);
    width: 0;
  `;
};
const $517093a4ef23f6fa$var$topRailCss = (0, $1mgSD$css)`
  ${$517093a4ef23f6fa$var$getTopRailStyle};
`;
const $517093a4ef23f6fa$var$getTopRailStyleTablet = ({ theme: { isVerticallyCentered: isVerticallyCentered , verticalEnabled: verticalEnabled  }  })=>isVerticallyCentered && verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).tablet`${$517093a4ef23f6fa$var$topRailCss}`;
const $517093a4ef23f6fa$var$getTopRailStyleDesktop = ({ theme: { isVerticallyCentered: isVerticallyCentered , verticalEnabled: verticalEnabled  }  })=>isVerticallyCentered && verticalEnabled === "always" && $517093a4ef23f6fa$var$topRailCss;
const $517093a4ef23f6fa$var$TopRail = (0, $1mgSD$styledcomponents).div`
  ${$517093a4ef23f6fa$var$getTopRailStyleTablet};
  ${$517093a4ef23f6fa$var$getTopRailStyleDesktop};
`;
const $517093a4ef23f6fa$var$getBottomRailStyle = ({ theme: { colors: colors , isComplete: isComplete , isFinal: isFinal  }  })=>{
    if (isFinal) return "";
    const color = isComplete ? colors.complete : colors.incomplete;
    return (0, $1mgSD$css)`
    ${$517093a4ef23f6fa$var$baseRailCss};
    box-shadow: 0 1px 0 1px ${color};
    height: calc(((100% - ${$517093a4ef23f6fa$var$stationPadding}) / 2) + ${$517093a4ef23f6fa$var$stationPadding});
    top: calc((100% - ${$517093a4ef23f6fa$var$stationPadding}) / 2);
    width: 0;
  `;
};
const $517093a4ef23f6fa$var$bottomRailCss = (0, $1mgSD$css)`
  ${$517093a4ef23f6fa$var$getBottomRailStyle};
`;
const $517093a4ef23f6fa$var$getBottomRailStyleTablet = ({ theme: { isVerticallyCentered: isVerticallyCentered , verticalEnabled: verticalEnabled  }  })=>isVerticallyCentered && verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).tablet`${$517093a4ef23f6fa$var$bottomRailCss}`;
const $517093a4ef23f6fa$var$getBottomRailStyleGeneral = ({ theme: { isVerticallyCentered: isVerticallyCentered , verticalEnabled: verticalEnabled  }  })=>isVerticallyCentered && verticalEnabled === "always" && $517093a4ef23f6fa$var$bottomRailCss;
const $517093a4ef23f6fa$var$BottomRail = (0, $1mgSD$styledcomponents).div`
  ${$517093a4ef23f6fa$var$getBottomRailStyleTablet};
  ${$517093a4ef23f6fa$var$getBottomRailStyleGeneral};
`;
var $517093a4ef23f6fa$var$_Component;
class $517093a4ef23f6fa$export$c6303e05f2c4327e extends ($517093a4ef23f6fa$var$_Component = (0, $1mgSD$react).Component) {
    render() {
        const { activeStations: activeStations , children: children , colors: colors , small: small , verticalEnabled: verticalEnabled , isVerticallyCentered: isVerticallyCentered , pulseActiveStation: pulseActiveStation  } = this.props;
        const stations = (0, $1mgSD$react).Children.toArray(children);
        const activeIndexes = stations.reduce((acc, station, i)=>{
            acc.concat((activeStations === null || activeStations === void 0 ? void 0 : activeStations.includes(station.props.id)) ? i : []);
            return acc;
        }, []);
        const context = {
            colors: colors,
            numStations: stations.length,
            isVerticallyCentered: isVerticallyCentered,
            verticalEnabled: verticalEnabled,
            small: small,
            pulseActiveStation: pulseActiveStation
        };
        return /*#__PURE__*/ (0, $1mgSD$react).createElement($517093a4ef23f6fa$var$StationList, context, stations.map((child, i)=>{
            const isActive = activeIndexes.includes(i);
            const isComplete = !!activeIndexes.length && i < Math.max(...activeIndexes);
            const isInitial = i === 0;
            const isFinal = i === stations.length - 1;
            const stationContext = {
                ...context,
                isInitial: isInitial,
                isFinal: isFinal,
                isComplete: isComplete,
                isActive: isActive
            };
            return /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $1mgSD$ThemeProvider), {
                theme: stationContext,
                key: child.props.id
            }, /*#__PURE__*/ (0, $1mgSD$react).createElement($517093a4ef23f6fa$var$StationListItem, null, child, !isFinal && /*#__PURE__*/ (0, $1mgSD$react).createElement($517093a4ef23f6fa$var$Rail, null), /*#__PURE__*/ (0, $1mgSD$react).createElement($517093a4ef23f6fa$var$TopRail, null), /*#__PURE__*/ (0, $1mgSD$react).createElement($517093a4ef23f6fa$var$BottomRail, null)));
        }));
    }
}
(0, $1mgSD$swchelperslib_define_propertyjs)($517093a4ef23f6fa$export$c6303e05f2c4327e, "defaultProps", {
    activeStations: [],
    colors: {
        complete: (0, $aaac76de4690e7ff$export$e73d0868f38cb1d),
        incomplete: (0, $aaac76de4690e7ff$export$87a86361d063ff10)
    },
    small: false,
    verticalEnabled: "mobile",
    pulseActiveStation: false
});


var $758643404cb75551$exports = {};

$parcel$export($758643404cb75551$exports, "SubwayStation", function () { return $758643404cb75551$export$999cf6d10d485ef1; });



const $758643404cb75551$var$verticallyCenteredStationWrapperCss = `
  display: flex;
  align-items: center;
`;
const $758643404cb75551$var$getCenterStyleTablet = ({ theme: { verticalEnabled: verticalEnabled , isVerticallyCentered: isVerticallyCentered  }  })=>isVerticallyCentered && verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).tablet`${$758643404cb75551$var$verticallyCenteredStationWrapperCss}`;
const $758643404cb75551$var$getCenterStyleAlways = ({ theme: { verticalEnabled: verticalEnabled , isVerticallyCentered: isVerticallyCentered  }  })=>isVerticallyCentered && verticalEnabled === "always" && $758643404cb75551$var$verticallyCenteredStationWrapperCss;
const $758643404cb75551$var$StationWrapper = (0, $1mgSD$styledcomponents).div`
  cursor: ${({ onClick: onClick  })=>onClick ? "pointer" : "inherit"};

  ${$758643404cb75551$var$getCenterStyleTablet};
  ${$758643404cb75551$var$getCenterStyleAlways};
`;
const $758643404cb75551$var$IndicatorWrapper = (0, $1mgSD$styledcomponents).div`
  float: left;
`;
const $758643404cb75551$var$horizontalIndicatorPositionHelperCss = "margin-top: -50%;";
const $758643404cb75551$var$getPositionHelperStyle = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "never" && $758643404cb75551$var$horizontalIndicatorPositionHelperCss;
const $758643404cb75551$var$getPositionHelperStyleDesktop = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).desktop`${$758643404cb75551$var$horizontalIndicatorPositionHelperCss}`;
const $758643404cb75551$var$getPositionHelperStyleSmallDesktop = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).smDesktop`${$758643404cb75551$var$horizontalIndicatorPositionHelperCss}`;
const $758643404cb75551$var$IndicatorPositionHelper = (0, $1mgSD$styledcomponents).div`
  margin-left: -50%;

  ${$758643404cb75551$var$getPositionHelperStyle}
  ${$758643404cb75551$var$getPositionHelperStyleDesktop}
  ${$758643404cb75551$var$getPositionHelperStyleSmallDesktop}
`;
const $758643404cb75551$var$horizontalTextWrapperCss = `
  clear: left;
  margin-left: -100%;
  text-align: center;
  width: 200%;
`;
const $758643404cb75551$var$verticalTextWrapperCss = `
  width: unset;
  margin-left: 0;
  clear: none;
  transform: translateY(-50%);
`;
const $758643404cb75551$var$verticallyCenteredTextWrapperCss = `
  flex: 1;
`;
const $758643404cb75551$var$getTextWrapperStyle = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "never" && $758643404cb75551$var$horizontalTextWrapperCss;
const $758643404cb75551$var$getTextWrapperStyleDesktop = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).desktop`${$758643404cb75551$var$horizontalTextWrapperCss}`;
const $758643404cb75551$var$getTextWrapperStyleSmallDesktop = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).smDesktop`${$758643404cb75551$var$horizontalTextWrapperCss}`;
const $758643404cb75551$var$getTextWrapperStyleTablet = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).tablet`${$758643404cb75551$var$verticalTextWrapperCss}`;
const $758643404cb75551$var$getTextWrapperCenteredStyleTablet = ({ theme: { verticalEnabled: verticalEnabled , isVerticallyCentered: isVerticallyCentered  }  })=>isVerticallyCentered && verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).tablet`${$758643404cb75551$var$verticallyCenteredTextWrapperCss}`;
const $758643404cb75551$var$getTextWrapperCenteredStyleTabletAlways = ({ theme: { verticalEnabled: verticalEnabled , isVerticallyCentered: isVerticallyCentered  }  })=>isVerticallyCentered && verticalEnabled === "always" && $758643404cb75551$var$verticallyCenteredTextWrapperCss;
const $758643404cb75551$var$TextWrapper = (0, $1mgSD$styledcomponents).div`
  overflow: hidden;

  ${$758643404cb75551$var$getTextWrapperStyle}
  ${$758643404cb75551$var$getTextWrapperStyleDesktop}
  ${$758643404cb75551$var$getTextWrapperStyleSmallDesktop}
  ${$758643404cb75551$var$getTextWrapperStyleTablet}
  ${$758643404cb75551$var$getTextWrapperCenteredStyleTablet};
  ${$758643404cb75551$var$getTextWrapperCenteredStyleTabletAlways}
`;
const $758643404cb75551$export$999cf6d10d485ef1 = ({ id: id , title: title , description: description , indicator: indicator , onClick: onClick  })=>{
    const theme = (0, $1mgSD$useTheme)();
    return /*#__PURE__*/ (0, $1mgSD$react).createElement($758643404cb75551$var$StationWrapper, {
        onClick: onClick,
        key: id,
        theme: theme
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement($758643404cb75551$var$IndicatorWrapper, null, /*#__PURE__*/ (0, $1mgSD$react).createElement($758643404cb75551$var$IndicatorPositionHelper, {
        theme: theme
    }, indicator)), /*#__PURE__*/ (0, $1mgSD$react).createElement($758643404cb75551$var$TextWrapper, {
        theme: theme
    }, title, description));
};


var $55f4cc69c94f9a02$exports = {};

$parcel$export($55f4cc69c94f9a02$exports, "pulseCss", function () { return $55f4cc69c94f9a02$export$de435428d8e5ddf3; });
$parcel$export($55f4cc69c94f9a02$exports, "SubwayStationIndicator", function () { return $55f4cc69c94f9a02$export$80777d51a92d84f1; });
$parcel$export($55f4cc69c94f9a02$exports, "DotSubwayStationIndicator", function () { return $55f4cc69c94f9a02$export$8205b0540cfc4ebb; });


const $55f4cc69c94f9a02$var$pulseAnimation = (0, $1mgSD$keyframes)`
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.3);
  }
  100% {
    box-shadow: 0 0 0 0.5rem rgba(0, 0, 0, 0);
  }
`;
const $55f4cc69c94f9a02$export$de435428d8e5ddf3 = (0, $1mgSD$css)`
  animation: ${$55f4cc69c94f9a02$var$pulseAnimation} 2s linear infinite;
`;
const $55f4cc69c94f9a02$export$80777d51a92d84f1 = (0, $1mgSD$styledcomponents).div`
  font-size: ${({ theme: { small: small  }  })=>small ? 0.75 : 0.9375}rem;
  width: ${({ theme: { small: small  }  })=>small ? 0.75 : 0.9375}rem;
  height: ${({ theme: { small: small  }  })=>small ? 0.75 : 0.9375}rem;
  background-color: ${({ color: color  })=>color || (0, $aaac76de4690e7ff$export$87a86361d063ff10)};
  ${({ theme: { pulseActiveStation: pulseActiveStation , isActive: isActive  }  })=>pulseActiveStation && isActive && $55f4cc69c94f9a02$export$de435428d8e5ddf3}
`;
const $55f4cc69c94f9a02$export$8205b0540cfc4ebb = (0, $1mgSD$styledcomponents)($55f4cc69c94f9a02$export$80777d51a92d84f1)`
  border-radius: 50%;
  ${({ theme: { pulseActiveStation: pulseActiveStation , isActive: isActive  }  })=>pulseActiveStation && isActive && $55f4cc69c94f9a02$export$de435428d8e5ddf3}
`;


var $5a8267f9a827a84a$exports = {};

$parcel$export($5a8267f9a827a84a$exports, "SubwayStationTitle", function () { return $5a8267f9a827a84a$export$713e0e2e7a38a83b; });
$parcel$export($5a8267f9a827a84a$exports, "SubwayStationDescription", function () { return $5a8267f9a827a84a$export$cedc53d8f5b1d1ab; });




const $5a8267f9a827a84a$var$horizontalStationTextCss = (0, $1mgSD$css)`
  ${({ theme: { isFinal: isFinal  }  })=>!isFinal && "margin: 0 30%;"}
  margin-top: 0.25rem;
`;
const $5a8267f9a827a84a$var$verticalStationTextCss = "margin: 0 0.15625rem 0 0; text-align:left;";
const $5a8267f9a827a84a$var$getStationTextStyleHorizontal = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "never" && $5a8267f9a827a84a$var$horizontalStationTextCss;
const $5a8267f9a827a84a$var$getStationTextStyleHorizontalDesktop = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).desktop`${$5a8267f9a827a84a$var$horizontalStationTextCss}`;
const $5a8267f9a827a84a$var$getStationTextStyleHorizontalSmallDesktop = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).smDesktop`${$5a8267f9a827a84a$var$horizontalStationTextCss}`;
const $5a8267f9a827a84a$var$getStationTextStyleVerticalTablet = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "mobile" && (0, $4195c89b4f4a4178$export$987d49ffe1b0900f).tablet`${$5a8267f9a827a84a$var$verticalStationTextCss}`;
const $5a8267f9a827a84a$var$getStationTextStyleVerticalAlways = ({ theme: { verticalEnabled: verticalEnabled  }  })=>verticalEnabled === "always" && $5a8267f9a827a84a$var$verticalStationTextCss;
const $5a8267f9a827a84a$var$StationText = (0, $1mgSD$styledcomponents)((0, $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6))`
  min-height: 0;

  ${$5a8267f9a827a84a$var$getStationTextStyleHorizontal}
  ${$5a8267f9a827a84a$var$getStationTextStyleHorizontalDesktop}
  ${$5a8267f9a827a84a$var$getStationTextStyleHorizontalSmallDesktop}
  ${$5a8267f9a827a84a$var$getStationTextStyleVerticalTablet}
  ${$5a8267f9a827a84a$var$getStationTextStyleVerticalAlways}
`;
const $5a8267f9a827a84a$export$713e0e2e7a38a83b = (0, $1mgSD$styledcomponents)($5a8267f9a827a84a$var$StationText)`
  color: ${(0, $aaac76de4690e7ff$export$e73d0868f38cb1d)};
  font-size: ${({ theme: { small: small  }  })=>small ? 0.75 : 0.8125}rem;
  font-weight: bold;
  line-height: ${({ theme: { small: small  }  })=>small ? 0.875 : 1}rem;
`;
const $5a8267f9a827a84a$export$cedc53d8f5b1d1ab = (0, $1mgSD$styledcomponents)($5a8267f9a827a84a$var$StationText)`
  color: ${(0, $aaac76de4690e7ff$export$1dfa4a610aaefe1)};
  font-size: ${({ theme: { small: small  }  })=>small ? 0.923076923 : 1}rem;
  line-height: ${({ theme: { small: small  }  })=>small ? 1.3125 : 1.5}rem;
  margin-top: 0.25rem;
`;


$parcel$exportWildcard($f57a01ae2cc96375$exports, $517093a4ef23f6fa$exports);
$parcel$exportWildcard($f57a01ae2cc96375$exports, $758643404cb75551$exports);
$parcel$exportWildcard($f57a01ae2cc96375$exports, $55f4cc69c94f9a02$exports);
$parcel$exportWildcard($f57a01ae2cc96375$exports, $5a8267f9a827a84a$exports);


var $6d79432a53b95e47$exports = {};
var $4ecadb055fb3f45d$exports = {};

$parcel$export($4ecadb055fb3f45d$exports, "Tag", function () { return $4ecadb055fb3f45d$export$3288d34c523a1192; });




const $4ecadb055fb3f45d$var$getHoverStyle = ({ onClick: onClick  })=>{
    return onClick ? `
    &:focus&:not(:disabled), &:hover&:not(:disabled), &:active&:not(:disabled) {
      background-color: ${0, $aaac76de4690e7ff$export$87a86361d063ff10};
    }
  ` : "";
};
const $4ecadb055fb3f45d$export$3288d34c523a1192 = (0, $1mgSD$styledcomponents).span`
  -webkit-font-smoothing: antialiased;
  border: ${(0, $fd37c165946cdbcc$export$12879c7697ed953d)} solid ${({ color: color  })=>color};
  border-radius: ${(0, $fd37c165946cdbcc$export$7a57f79000377ca2)};
  color: ${({ color: color , disabled: disabled  })=>{
    if (color) return color;
    if (disabled) return 0, $aaac76de4690e7ff$export$40e746099f73c094;
    return 0, $aaac76de4690e7ff$export$d913daa7170c2f9f;
}};
  cursor: ${({ onClick: onClick  })=>onClick ? "pointer" : "default"};
  font-family: ${(0, $fe72a230606ab94c$export$ed2f7e77161669d)};
  font-size: 0.625rem;
  line-height: 0.75rem;
  padding: 0.1rem 0.2rem;
  text-transform: uppercase;
  user-select: none;

  ${$4ecadb055fb3f45d$var$getHoverStyle}
`;


$parcel$exportWildcard($6d79432a53b95e47$exports, $4ecadb055fb3f45d$exports);


var $7bb5aff0ecc41df8$exports = {};

$parcel$export($7bb5aff0ecc41df8$exports, "toaster", function () { return $7bb5aff0ecc41df8$export$a224d1f4f6f98541; });













function $392b939b287c98f7$var$getColors({ kind: kind  }) {
    switch(kind){
        case "success":
            return {
                backgroundColor: (0, $aaac76de4690e7ff$export$7e843862c500fadd),
                color: (0, $aaac76de4690e7ff$export$df5574606a94f191)
            };
        case "info":
            return {
                backgroundColor: (0, $aaac76de4690e7ff$export$87a86361d063ff10),
                color: (0, $aaac76de4690e7ff$export$8789b5d1f1beb293)
            };
        case "warning":
            return {
                backgroundColor: (0, $aaac76de4690e7ff$export$f8a16a30e3179648),
                color: (0, $aaac76de4690e7ff$export$eafd9d6862ca17a9)
            };
        case "danger":
            return {
                backgroundColor: (0, $aaac76de4690e7ff$export$6c9b3104157f8389),
                color: (0, $aaac76de4690e7ff$export$689894fd5b69c1a5)
            };
        default:
            throw new Error("Must specify toaster kind");
    }
}
const $392b939b287c98f7$var$ToastContainer = (0, $1mgSD$styledcomponents).div`
  ${({ hasDescription: hasDescription  })=>hasDescription ? null : "min-height: 3rem"};

  background-color: ${({ colors: colors  })=>colors.backgroundColor};
  border: ${(0, $fd37c165946cdbcc$export$12879c7697ed953d)} solid ${({ colors: colors  })=>colors.color};
  border-radius: ${(0, $fd37c165946cdbcc$export$7a57f79000377ca2)};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
`;
const $392b939b287c98f7$var$ToastTitleContainer = (0, $1mgSD$styledcomponents).div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;
const $392b939b287c98f7$var$ToastTitle = (0, $1mgSD$styledcomponents)((0, $7c81b819332fca34$export$88ef9fdaf11f7a1f)).attrs((props)=>({
        color: $392b939b287c98f7$var$getColors(props).color
    }))`
  color: ${({ color: color  })=>color};
  padding-right: ${(0, $fd37c165946cdbcc$export$54c7853c55b55e72)};
`;
const $392b939b287c98f7$var$ToastDescription = (0, $1mgSD$styledcomponents)((0, $5c5b602ecf9ac4bf$export$358a232cca1ab2ac)).attrs({
    small: true
})`
  line-height: ${(0, $fd37c165946cdbcc$export$70173e1228291b3c)};
  padding-top: ${(0, $fd37c165946cdbcc$export$79a18a7d58eb5909)};
`;
const $392b939b287c98f7$var$GlyphContainer = (0, $1mgSD$styledcomponents).div`
  color: ${(0, $aaac76de4690e7ff$export$abc95940fda32f98)};
  cursor: pointer;
  height: 1rem;
  width: 1rem;
`;
const $392b939b287c98f7$var$FIVE_SECONDS = 5000; // TODO: animations
var $392b939b287c98f7$var$_PureComponent;
class $392b939b287c98f7$export$8d8dc7d5f743331b extends ($392b939b287c98f7$var$_PureComponent = $1mgSD$PureComponent) {
    componentDidMount() {
        this.startCloseTimer();
    }
    startCloseTimer() {
        const { onClose: onClose  } = this.props;
        this.closeTimer = setTimeout(onClose, $392b939b287c98f7$var$FIVE_SECONDS);
    }
    clearCloseTimer() {
        if (this.closeTimer) {
            clearTimeout(this.closeTimer);
            this.closeTimer = null;
        }
    }
    onClose() {
        const { onClose: onClose  } = this.props;
        this.clearCloseTimer();
        onClose();
    }
    render() {
        const { children: children , title: title , ...rest } = this.props;
        return /*#__PURE__*/ $1mgSD$createElement($392b939b287c98f7$var$ToastContainer, {
            ...rest,
            hasDescription: !!children,
            onMouseEnter: this.clearCloseTimer,
            onMouseLeave: this.startCloseTimer,
            colors: $392b939b287c98f7$var$getColors(this.props)
        }, /*#__PURE__*/ $1mgSD$createElement($392b939b287c98f7$var$ToastTitleContainer, null, /*#__PURE__*/ $1mgSD$createElement($392b939b287c98f7$var$ToastTitle, rest, title), /*#__PURE__*/ $1mgSD$createElement($392b939b287c98f7$var$GlyphContainer, {
            onClick: this.onClose
        }, /*#__PURE__*/ $1mgSD$createElement((0, $1mgSD$FontAwesomeIcon), {
            color: (0, $aaac76de4690e7ff$export$1dfa4a610aaefe1),
            icon: [
                "far",
                "times"
            ]
        }))), children ? /*#__PURE__*/ $1mgSD$createElement($392b939b287c98f7$var$ToastDescription, null, children) : null);
    }
    constructor(props){
        super(props);
        this.startCloseTimer = this.startCloseTimer.bind(this);
        this.clearCloseTimer = this.clearCloseTimer.bind(this);
        this.onClose = this.onClose.bind(this);
    }
}
(0, $1mgSD$swchelperslib_define_propertyjs)($392b939b287c98f7$export$8d8dc7d5f743331b, "defaultProps", {
    children: null
});










const $c0c6c20c875c4840$export$a1d1a2dbce5ef265 = Object.freeze({
    INFO: "info",
    DANGER: "danger",
    WARNING: "warning",
    SUCCESS: "success"
});
const $c0c6c20c875c4840$var$StyledFontAwesomeIcon = (0, $1mgSD$styledcomponents)((0, $1mgSD$FontAwesomeIcon))`
  font-size: 150px;
`;
function $c0c6c20c875c4840$var$getColors(kind) {
    switch(kind){
        case $c0c6c20c875c4840$export$a1d1a2dbce5ef265.SUCCESS:
            return {
                backgroundColor: (0, $aaac76de4690e7ff$export$df5574606a94f191),
                descriptionColor: (0, $aaac76de4690e7ff$export$3b058bf22d3a92e9),
                iconColor: (0, $aaac76de4690e7ff$export$3b058bf22d3a92e9),
                titleColor: (0, $aaac76de4690e7ff$export$3b058bf22d3a92e9)
            };
        case $c0c6c20c875c4840$export$a1d1a2dbce5ef265.INFO:
            return {
                backgroundColor: (0, $aaac76de4690e7ff$export$87a86361d063ff10),
                descriptionColor: (0, $aaac76de4690e7ff$export$8789b5d1f1beb293),
                iconColor: (0, $aaac76de4690e7ff$export$8789b5d1f1beb293),
                titleColor: (0, $aaac76de4690e7ff$export$8789b5d1f1beb293)
            };
        case $c0c6c20c875c4840$export$a1d1a2dbce5ef265.WARNING:
            return {
                backgroundColor: (0, $aaac76de4690e7ff$export$f8a16a30e3179648),
                descriptionColor: (0, $aaac76de4690e7ff$export$eafd9d6862ca17a9),
                iconColor: (0, $aaac76de4690e7ff$export$eafd9d6862ca17a9),
                titleColor: (0, $aaac76de4690e7ff$export$eafd9d6862ca17a9)
            };
        case $c0c6c20c875c4840$export$a1d1a2dbce5ef265.DANGER:
            return {
                backgroundColor: (0, $aaac76de4690e7ff$export$3b058bf22d3a92e9),
                descriptionColor: (0, $aaac76de4690e7ff$export$cb81ca6e31dfb4ee),
                iconColor: (0, $aaac76de4690e7ff$export$689894fd5b69c1a5),
                titleColor: (0, $aaac76de4690e7ff$export$689894fd5b69c1a5)
            };
        default:
            throw new Error("Must specify toaster kind");
    }
}
const $c0c6c20c875c4840$var$ToastIcon = ({ kind: kind  })=>{
    let icon = [
        "fas",
        "check-circle"
    ];
    switch(kind){
        case $c0c6c20c875c4840$export$a1d1a2dbce5ef265.SUCCESS:
            icon = [
                "fas",
                "check-circle"
            ];
            break;
        case $c0c6c20c875c4840$export$a1d1a2dbce5ef265.INFO:
            icon = [
                "fas",
                "info-circle"
            ];
            break;
        case $c0c6c20c875c4840$export$a1d1a2dbce5ef265.WARNING:
            icon = [
                "fas",
                "exclamation-circle"
            ];
            break;
        case $c0c6c20c875c4840$export$a1d1a2dbce5ef265.DANGER:
            icon = [
                "fal",
                "times-circle"
            ];
            break;
        default:
            throw new Error("Must specify toaster kind");
    }
    return /*#__PURE__*/ (0, $1mgSD$react).createElement($c0c6c20c875c4840$var$StyledFontAwesomeIcon, {
        color: $c0c6c20c875c4840$var$getColors(kind).iconColor,
        icon: icon,
        size: "lg"
    });
};
const $c0c6c20c875c4840$var$ToastContainer = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$816b5d811295e6bc))`
  background-color: ${({ kind: kind  })=>$c0c6c20c875c4840$var$getColors(kind).backgroundColor};
  box-sizing: border-box;
  margin: 0;
  padding: calc(${(0, $fd37c165946cdbcc$export$4c16e5a80ec60b32)} + ${(0, $fd37c165946cdbcc$export$9b8cd5b0d7315663)});
`;
const $c0c6c20c875c4840$var$ToastContentContainer = (0, $1mgSD$styledcomponents)((0, $e1c47a8b6d5f9c8f$export$816b5d811295e6bc))`
  text-align: center;
  width: 100%;
`;
const $c0c6c20c875c4840$var$ToastTitle = (0, $1mgSD$styledcomponents)((0, $66e82a5fe7a0e0ea$export$cb94397127ac9363))`
  color: ${({ kind: kind  })=>$c0c6c20c875c4840$var$getColors(kind).titleColor};
`;
const $c0c6c20c875c4840$var$ToastDescription = (0, $1mgSD$styledcomponents)((0, $ebd2ff14df5e4ed4$export$cc5e069d64fda823))`
  color: ${({ kind: kind  })=>$c0c6c20c875c4840$var$getColors(kind).descriptionColor};
`;
const $c0c6c20c875c4840$var$TWO_SECONDS = 2000;
const $c0c6c20c875c4840$export$ce04d9f3f8a79a47 = ({ children: children , onClose: onClose , kind: kind , title: title  })=>{
    const closeTimer = (0, $1mgSD$useRef)();
    const startCloseTimer = ()=>{
        closeTimer.current = setTimeout(onClose, $c0c6c20c875c4840$var$TWO_SECONDS);
    };
    const clearCloseTimer = ()=>{
        if (closeTimer === null || closeTimer === void 0 ? void 0 : closeTimer.current) {
            clearTimeout(closeTimer.current);
            closeTimer.current = undefined;
        }
    };
    const handleClose = ()=>{
        clearCloseTimer();
        onClose();
    };
    (0, $1mgSD$useEffect)(()=>{
        startCloseTimer();
    }, []);
    const isDanger = kind === $c0c6c20c875c4840$export$a1d1a2dbce5ef265.DANGER;
    return /*#__PURE__*/ (0, $1mgSD$react).createElement($c0c6c20c875c4840$var$ToastContainer, {
        horizontallyAlignContent: true,
        kind: kind,
        verticallyAlignContent: true,
        windowHeight: true
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement($c0c6c20c875c4840$var$ToastContentContainer, {
        spacing: "8rem",
        horizontallyAlignContent: true,
        verticallyAlignContent: true
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $e1c47a8b6d5f9c8f$export$816b5d811295e6bc), {
        spacing: (0, $fd37c165946cdbcc$export$9b8cd5b0d7315663),
        horizontallyAlignContent: true,
        verticallyAlignContent: true
    }, /*#__PURE__*/ (0, $1mgSD$react).createElement($c0c6c20c875c4840$var$ToastIcon, {
        kind: kind
    }), /*#__PURE__*/ (0, $1mgSD$react).createElement($c0c6c20c875c4840$var$ToastTitle, {
        kind: kind
    }, title), children ? /*#__PURE__*/ (0, $1mgSD$react).createElement($c0c6c20c875c4840$var$ToastDescription, {
        kind: kind
    }, children) : null), isDanger && /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $2cef4ff485e6f14d$export$353f5b6fc5456de1), {
        full: true,
        onClick: handleClose,
        danger: isDanger
    }, "Close and try again")));
};
$c0c6c20c875c4840$export$ce04d9f3f8a79a47.defaultProps = {
    children: null
};


const $cecf070c8c9e7c4a$var$calcStyle = `calc(20 * ${(0, $fd37c165946cdbcc$export$9b8cd5b0d7315663)})`;
const $cecf070c8c9e7c4a$var$Toasts = (0, $1mgSD$styledcomponents).span`
  left: 0;
  margin: 0 auto;
  max-width: ${({ maxWidth: maxWidth  })=>maxWidth || $cecf070c8c9e7c4a$var$calcStyle};
  position: fixed;
  right: 0;
  top: ${({ offset: offset  })=>offset};
  width: ${({ width: width  })=>width};
  z-index: 1002; // display on top of the Overlay
  > * {
    margin-bottom: 0.5rem;
  }
`;
let $cecf070c8c9e7c4a$var$ID = 0;
var $cecf070c8c9e7c4a$var$_PureComponent;
class $cecf070c8c9e7c4a$export$94c9e29df9deaf57 extends ($cecf070c8c9e7c4a$var$_PureComponent = (0, $1mgSD$react).PureComponent) {
    onClose(id) {
        this.setState((prevState)=>({
                toasts: prevState.toasts.filter((toast)=>toast.id !== id)
            }));
    }
    toast(toast) {
        this.setState((prevState)=>({
                toasts: [
                    this.nextToast(toast),
                    ...prevState.toasts
                ]
            }));
    }
    nextToast(toast) {
        const id = $cecf070c8c9e7c4a$var$ID++;
        return {
            ...toast,
            id: id,
            onClose: ()=>this.onClose(id)
        };
    }
    render() {
        const { offset: offset , width: width , maxWidth: maxWidth  } = this.props;
        const { toasts: toasts  } = this.state;
        return /*#__PURE__*/ (0, $1mgSD$react).createElement($cecf070c8c9e7c4a$var$Toasts, {
            offset: offset,
            width: width,
            maxWidth: maxWidth
        }, toasts.map(({ description: description , id: id , fullscreen: fullscreen , ...rest })=>{
            if (fullscreen) return /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $c0c6c20c875c4840$export$ce04d9f3f8a79a47), {
                ...rest,
                key: id
            }, description);
            return /*#__PURE__*/ (0, $1mgSD$react).createElement((0, $392b939b287c98f7$export$8d8dc7d5f743331b), {
                ...rest,
                key: id
            }, description);
        }));
    }
    constructor(props){
        super(props);
        this.onClose = this.onClose.bind(this);
        this.toast = this.toast.bind(this);
        this.nextToast = this.nextToast.bind(this);
        props.bindToast(this.toast);
        this.state = {
            toasts: []
        };
    }
}
(0, $1mgSD$swchelperslib_define_propertyjs)($cecf070c8c9e7c4a$export$94c9e29df9deaf57, "defaultProps", {
    offset: "1rem",
    width: "60%",
    maxWidth: undefined
});


const $d0986bc3cb9055e7$var$ID = "toaster-outlet";
class $d0986bc3cb9055e7$export$fb98e3a2a4cd92d7 {
    bindToast(addToast) {
        this.addToast = addToast;
    }
    /**
   * Sets available props on the outlet container,
   * currently only supporting `offset` and `width`.
   */ setVisualAttributes(props) {
        const outletContainer = document.getElementById($d0986bc3cb9055e7$var$ID);
        const { offset: offset , width: width , maxWidth: maxWidth  } = props;
        if (outletContainer) (0, $1mgSD$reactdom).render(/*#__PURE__*/ (0, $1mgSD$react).createElement((0, $cecf070c8c9e7c4a$export$94c9e29df9deaf57), {
            bindToast: this.bindToast,
            offset: offset,
            width: width,
            maxWidth: maxWidth
        }), outletContainer);
        else throw new Error("No toaster outlet found.");
    }
    toast(toast) {
        var _obj, ref;
        (ref = (_obj = this).addToast) === null || ref === void 0 ? void 0 : ref.call(_obj, toast);
    }
    constructor(){
        this.bindToast = this.bindToast.bind(this);
        this.setVisualAttributes = this.setVisualAttributes.bind(this);
        this.toast = this.toast.bind(this);
        const outletContainer = document.createElement("div");
        outletContainer.id = $d0986bc3cb9055e7$var$ID;
        if (document.body) document.body.appendChild(outletContainer);
        else throw new Error("Document has no body!");
        (0, $1mgSD$reactdom).render(/*#__PURE__*/ (0, $1mgSD$react).createElement((0, $cecf070c8c9e7c4a$export$94c9e29df9deaf57), {
            bindToast: this.bindToast
        }), outletContainer);
    }
}


const $7bb5aff0ecc41df8$export$a224d1f4f6f98541 = new (0, $d0986bc3cb9055e7$export$fb98e3a2a4cd92d7)();




$parcel$exportWildcard($73d1fdfde4d09865$exports, $5ebe933df9edf9d7$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $914c88bdea61f2b6$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $f1f82bf952edd00c$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $75998ca0c1da2553$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $905c2d2db2a42528$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $ebde5abb93da027d$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $0a2316950772fa28$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $f8e7c499f0a72e56$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $887ef06c6be72fdb$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $4a4b332837f5a160$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $2f44d3c803347644$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $d48ae88a90296eff$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $ed023db431241b6d$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $de8e1bbf6e418695$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $21a048999b0ee84d$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $bd8ab8f075ca28dd$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $ca99b2599154b655$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $9f1dea9396b5bad4$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $4d089d0bcc16b83e$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $f57a01ae2cc96375$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $6d79432a53b95e47$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $7bb5aff0ecc41df8$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $1213d3db19f84ee9$exports);
$parcel$exportWildcard($73d1fdfde4d09865$exports, $e1ec4f377287ccce$exports);


var $1129af8e8f86ac8b$exports = {};
var $f596f8a33e1a74d5$exports = {};

$parcel$export($f596f8a33e1a74d5$exports, "validateEmail", function () { return $f596f8a33e1a74d5$export$18148d12c805c5b0; });
const $f596f8a33e1a74d5$export$18148d12c805c5b0 = (value)=>{
    return value && !/^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/i.test(value) ? "Invalid email address" : undefined;
};


var $8d567a3e8705a3af$exports = {};

$parcel$export($8d567a3e8705a3af$exports, "validateGreaterThan", function () { return $8d567a3e8705a3af$export$f8f4f3954824fcf1; });
function $8d567a3e8705a3af$export$f8f4f3954824fcf1(min, message) {
    return (value)=>{
        if (!value || value.length > min) return undefined;
        return typeof message !== "undefined" ? message(value, min) : `Must be greater than ${min}`;
    };
}


var $e42dbdc3d4d2f15d$exports = {};

$parcel$export($e42dbdc3d4d2f15d$exports, "validatePassword", function () { return $e42dbdc3d4d2f15d$export$4d2a7159fda5dc93; });

const $e42dbdc3d4d2f15d$export$4d2a7159fda5dc93 = (0, $8d567a3e8705a3af$export$f8f4f3954824fcf1)(7, ()=>"Password must be at least 8 characters");


var $5ac088419a9c6878$exports = {};

$parcel$export($5ac088419a9c6878$exports, "validatePhone", function () { return $5ac088419a9c6878$export$375cde19889b052f; });
const $5ac088419a9c6878$export$375cde19889b052f = (value)=>{
    return value && !/^(0|[1-9][0-9]{9})$/i.test(value.replace(/[^\d]/g, "")) ? "Invalid phone number, must be 10 digits" : undefined;
};


var $aea364d2f7768a5f$exports = {};

$parcel$export($aea364d2f7768a5f$exports, "validatePresent", function () { return $aea364d2f7768a5f$export$a6d5e81fecabe8bb; });
const $aea364d2f7768a5f$export$a6d5e81fecabe8bb = (value)=>{
    return value == null || value === "" || value.length === 0 ? "Field is required" : undefined;
};


var $9c36b18690c43607$exports = {};

$parcel$export($9c36b18690c43607$exports, "validatePresentWithMessage", function () { return $9c36b18690c43607$export$4985dee6aa927ede; });

const $9c36b18690c43607$export$4985dee6aa927ede = (label)=>{
    return (value)=>{
        if ((0, $aea364d2f7768a5f$export$a6d5e81fecabe8bb)(value)) return label ? `${label} cannot be blank` : (0, $aea364d2f7768a5f$export$a6d5e81fecabe8bb)(value);
        return null;
    };
};


var $be4649a81768a4e0$exports = {};

$parcel$export($be4649a81768a4e0$exports, "validatePresentIf", function () { return $be4649a81768a4e0$export$6212dbb096e3d50c; });

const $be4649a81768a4e0$export$6212dbb096e3d50c = (rule, label)=>{
    return (value, otherValues)=>{
        if (rule(value, otherValues)) return (0, $9c36b18690c43607$export$4985dee6aa927ede)(label)(value);
        return null;
    };
};


var $efeb559148a13661$exports = {};

$parcel$export($efeb559148a13661$exports, "createValidator", function () { return $efeb559148a13661$export$9a4b8a3ca30b6002; });
function $efeb559148a13661$var$hasError(error) {
    return !!error;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $efeb559148a13661$var$join = (rules)=>{
    return (value, data)=>{
        return rules.map((rule)=>rule(value, data)).filter($efeb559148a13661$var$hasError)[0];
    };
};
const $efeb559148a13661$export$9a4b8a3ca30b6002 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
rules)=>{
    return (data)=>{
        const errors = {};
        Object.keys(rules).forEach((key)=>{
            // @ts-expect-error ignored as part of ts migration -- please fix me if you see this!
            const rule = $efeb559148a13661$var$join([].concat(rules[key])); // concat enables both functions and arrays of functions
            const error = rule(data[key], data);
            if (error) errors[key] = error;
        });
        return errors;
    };
};


$parcel$exportWildcard($1129af8e8f86ac8b$exports, $f596f8a33e1a74d5$exports);
$parcel$exportWildcard($1129af8e8f86ac8b$exports, $8d567a3e8705a3af$exports);
$parcel$exportWildcard($1129af8e8f86ac8b$exports, $e42dbdc3d4d2f15d$exports);
$parcel$exportWildcard($1129af8e8f86ac8b$exports, $5ac088419a9c6878$exports);
$parcel$exportWildcard($1129af8e8f86ac8b$exports, $aea364d2f7768a5f$exports);
$parcel$exportWildcard($1129af8e8f86ac8b$exports, $9c36b18690c43607$exports);
$parcel$exportWildcard($1129af8e8f86ac8b$exports, $be4649a81768a4e0$exports);
$parcel$exportWildcard($1129af8e8f86ac8b$exports, $efeb559148a13661$exports);


var $dbfcbb21edd40a96$exports = {};
var $69c4e61fc99c28a0$exports = {};

$parcel$export($69c4e61fc99c28a0$exports, "formatPhone", function () { return $69c4e61fc99c28a0$export$10c09b2cff9813eb; });
const $69c4e61fc99c28a0$export$10c09b2cff9813eb = (value)=>{
    if (!value) return value;
    const onlyNums = value.replace(/[^\d]/g, "");
    if (onlyNums.length <= 3) return onlyNums;
    if (onlyNums.length <= 7) return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`;
};


$parcel$exportWildcard($dbfcbb21edd40a96$exports, $69c4e61fc99c28a0$exports);


var $caef79058ae17cb7$exports = {};
var $61b36c75b1a6cf10$exports = {};

$parcel$export($61b36c75b1a6cf10$exports, "normalizePhone", function () { return $61b36c75b1a6cf10$export$e9b617754cf28d84; });
const $61b36c75b1a6cf10$export$e9b617754cf28d84 = (value)=>value.replace(/[^\d]/g, "");


$parcel$exportWildcard($caef79058ae17cb7$exports, $61b36c75b1a6cf10$exports);






export {$f8bea99cab290f06$export$e213cebad6250b4a as ActionBar, $f8bea99cab290f06$export$af98ebab6701b942 as ActionBarWrapper, $a88452d480b51f6d$export$3ba8ae974671cc59 as ButtonSelector, $2cef4ff485e6f14d$export$353f5b6fc5456de1 as Button, $2cef4ff485e6f14d$export$62e197caf5c4a718 as getButtonColors, $7865a0a530ffec11$export$42ce4cda9cbee2be as getSpinnerStyle, $7865a0a530ffec11$export$c9da7f48cc950c1c as spinnerCss, $7865a0a530ffec11$export$4ec83e90d030b2f3 as LoadingButton, $b99f2b448f214e12$export$c25acd513dcc8062 as IconButton, $12b081e83e24a09b$export$8b251419efc915eb as Header, $10ede891be2e50f8$export$e1abe0f3fc33f39e as ActionCard, $d1838b596c71cd06$export$29b0d7e0ab5d250a as ActionCardBody, $e4189bdaac4c4d3f$export$3e0e9cfc44d80ea2 as ActionCardBodySection, $4acf5fc835d21075$export$3607f7b79c644a3c as ActionCardHeader, $4c66280bc58b30dd$export$60332b2344f7fe41 as Card, $26ecfcbf18b1fb5d$export$3597e8e6c4686a02 as TaskActionCard, $eea8a5efeb78e831$export$8a23e74e5cf3ca41 as CardContainer, $a26a549454f77336$export$3219b0bbd5caee8 as ResultCard, $a30e48c20455bff0$export$eeaa45a7d92663a6 as SimpleContainer, $2e7c7887a7057eac$export$7410b45a5f58ef2b as SimpleContainerHeader, $028b26d7944ce561$export$202ffdafe1e1a746 as SimpleContainerSection, $9d3b54d6837e427d$export$be4c8679ebfd988 as SectionContainer, $6ba821a3bca8e184$export$5282a815cf9a8195 as SectionContainerHeader, $a983d38bfafe8ba2$export$2afed638eb3a7931 as SectionContainerSection, $d8acc43864342a37$export$a7fed597f4b8afd8 as Form, $9839253b5696f77a$export$aff4fc93593c3bcf as InfoBox, $4a4b332837f5a160$export$cefd80352569a33f as InputBlockAsyncSelect, $4a4b332837f5a160$export$c96a0b7a2d13d2eb as InputBlockIcon, $4a4b332837f5a160$export$3afa4f47ece1183e as InputBlockPassword, $4a4b332837f5a160$export$bc6fd9e82d599a3d as InputBlockRadio, $4a4b332837f5a160$export$f08696a21e869131 as InputBlockSelect, $4a4b332837f5a160$export$661bf7bf48ebd697 as InputBlockText, $4a4b332837f5a160$export$6513660e47c22334 as InputBlockTextArea, $4a4b332837f5a160$export$cfe4211e9d3c9baf as InputBlockCheckbox, $4a4b332837f5a160$export$7b65cb28f38300b0 as InputUploadImage, $d8a8286d48fb661d$export$f5b8910cec6cf069 as Input, $64be58195b6ad3f8$export$83678641c7770fa5 as InputBlock, $677d84d1ac71479b$export$fa1253a65a9e747d as InputCheckbox, $93edf818f725e4a9$export$4f481e0a96cfbed6 as Checkmark, $94688993bd21fab5$export$f8fea9f50a4bfae6 as InputIcon, $404694754b94de9e$export$66ebaee5e192c141 as InputPassword, $24345a848f7a9137$export$2fe4f0576c8a371 as InputRow, $a7691ccff838311a$export$26542d43b3209548 as InputTextArea, $4d7b46a4a27c7b9a$export$ed3c6fc36a947b6a as InputToggle, $d8a8286d48fb661d$export$4293276c0c0bdb9d as inputStylesMixin, $e1c47a8b6d5f9c8f$export$816b5d811295e6bc as Column, $e1c47a8b6d5f9c8f$export$b59bdbef9ce70de2 as Row, $e1c47a8b6d5f9c8f$export$210ea85e49c56827 as FlexRow, $e1c47a8b6d5f9c8f$export$67a48f594b188c22 as WindowHeightRow, $e1c47a8b6d5f9c8f$export$bb829a6fc8fabbe2 as ParentHeightRow, $e1c47a8b6d5f9c8f$export$b1a401d0eced3e7 as FlexColumn, $e1c47a8b6d5f9c8f$export$c44160ab6853d556 as WindowWidthColumn, $e1c47a8b6d5f9c8f$export$db3eb31252bfec8b as ParentWidthColumn, $e874f83c8a1f6111$export$c018a577d7622cc2 as LoaderImage, $e874f83c8a1f6111$export$ce595ec7e5ee3717 as spinnerStyles, $e874f83c8a1f6111$export$3b0d6d7590275603 as Loader, $0727668633077655$export$d4c4e98c5044dc8 as MenuList, $cf62e53ea5c67b66$export$5bba17a75e56148 as MenuListSection, $f0a679e1c872a301$export$7b4818872fbcdbad as MenuItemCell, $037ea5c68628999e$export$fc84c46964d578db as ActionMenuItemCell, $5a09e5884d653722$export$90b86373fbbb2510 as CustomActionMenuItemCell, $18402993803c3fd1$export$cb540d8b0ef7906c as ModalBody, $18402993803c3fd1$export$ef140b2b29a1e3bc as ALIGNMENTS, $18402993803c3fd1$export$6da19a24bf249f17 as ModalContent, $18402993803c3fd1$export$f50a68e3694789ee as ModalHeader, $18402993803c3fd1$export$519437715052e656 as ModalFooter, $18402993803c3fd1$export$c9554889b3e706cd as ModalContainer, $18402993803c3fd1$export$2b77a92f1a5ad772 as Modal, $1cfc6f0a39d3d679$export$c1bd7a02ddc56666 as DeprecatedModalHeader, $1cfc6f0a39d3d679$export$f324f57e9339ad14 as DeprecatedModalContainer, $1cfc6f0a39d3d679$export$ad4600fa0440495c as DeprecatedModalContent, $1cfc6f0a39d3d679$export$68fbfda2546c8c48 as DeprecatedModalFooter, $1cfc6f0a39d3d679$export$49630308cfac7721 as DeprecatedModal, $0f17e68a089fddfe$export$e833dfe35f2086ee as ModalBodyWrapper, $0f17e68a089fddfe$export$74861647dcdb9861 as DeprecatedModalBody, $3b833d90f77be911$export$c6fdb837b070b4ff as Overlay, $8beeebdb4fa059b6$export$a98f0dcb43a68a25 as RadioGroup, $f5f1fec5afabd21c$export$82ab7168879267a7 as RadioOption, $ca99b2599154b655$re_export$SelectComponents as SelectComponents, $ee4112e8be1f7a04$export$ef9b1a59e592288f as Select, $28f28f30df27e3c4$export$70a9ea0b017c448a as selectStyles, $28f28f30df27e3c4$export$a1d110fc478d9732 as findOptions, $28f28f30df27e3c4$export$d072b35edf4f3563 as findOption, $28f28f30df27e3c4$export$429bdfed6f5ec72a as findGroup, $ad2f8b73f442f9e6$export$aca05dd54e009a80 as AsyncSelect, $7c4394f68bf355bc$export$472062a354075cee as Slider, $777c540b44ed2dde$export$d8784f2bbeda3c7f as SliderNavigation, $ab36d9636a477b6c$export$b3c0e60a51b74e9c as StaticTextBlock, $08f8ede1a9d06a70$export$e4f4a83e740a2b6c as StaticSelectBlock, $517093a4ef23f6fa$export$c6303e05f2c4327e as Subway, $758643404cb75551$export$999cf6d10d485ef1 as SubwayStation, $55f4cc69c94f9a02$export$de435428d8e5ddf3 as pulseCss, $55f4cc69c94f9a02$export$80777d51a92d84f1 as SubwayStationIndicator, $55f4cc69c94f9a02$export$8205b0540cfc4ebb as DotSubwayStationIndicator, $5a8267f9a827a84a$export$713e0e2e7a38a83b as SubwayStationTitle, $5a8267f9a827a84a$export$cedc53d8f5b1d1ab as SubwayStationDescription, $4ecadb055fb3f45d$export$3288d34c523a1192 as Tag, $7bb5aff0ecc41df8$export$a224d1f4f6f98541 as toaster, $53c9552000f8bf77$export$28c660c63b792dea as Tooltip, $53c9552000f8bf77$export$dbdcde5ca046596e as InfoTooltip, $c82a557ce75f4fea$export$95d05bdc75950145 as Danger, $40d88124347685f5$export$5523b16adee8048 as H1, $66e82a5fe7a0e0ea$export$cb94397127ac9363 as H2, $a65c84ab085b2e8e$export$746be9e3a3dfff1f as H3, $ebd2ff14df5e4ed4$export$cc5e069d64fda823 as H4, $7c81b819332fca34$export$88ef9fdaf11f7a1f as H5, $7c7949b58e9af13d$export$ed2cd9eb2d1973f0 as InfoText, $557c3ea4bde01476$export$b04be29aa201d4f5 as Label, $637b1423c417142a$export$a6c7ac8248d6e38a as Link, $5c5b602ecf9ac4bf$export$5f1714a13ed34c01 as Span, $5c5b602ecf9ac4bf$export$358a232cca1ab2ac as Paragraph, $5c5b602ecf9ac4bf$export$5f1af8db9871e1d6 as Text, $f596f8a33e1a74d5$export$18148d12c805c5b0 as validateEmail, $8d567a3e8705a3af$export$f8f4f3954824fcf1 as validateGreaterThan, $e42dbdc3d4d2f15d$export$4d2a7159fda5dc93 as validatePassword, $5ac088419a9c6878$export$375cde19889b052f as validatePhone, $aea364d2f7768a5f$export$a6d5e81fecabe8bb as validatePresent, $9c36b18690c43607$export$4985dee6aa927ede as validatePresentWithMessage, $be4649a81768a4e0$export$6212dbb096e3d50c as validatePresentIf, $efeb559148a13661$export$9a4b8a3ca30b6002 as createValidator, $69c4e61fc99c28a0$export$10c09b2cff9813eb as formatPhone, $61b36c75b1a6cf10$export$e9b617754cf28d84 as normalizePhone, $5c4c6b5a115de467$export$f45fbea8fe20ca8a as fonts, $5c4c6b5a115de467$export$eaad8caa32d2521d as palette, $5c4c6b5a115de467$export$3eb26d38a832ce9a as shadows, $5c4c6b5a115de467$export$5458b64234d1333c as spacing, $4195c89b4f4a4178$export$c647cb0ee6e282fe as sizes, $4195c89b4f4a4178$export$987d49ffe1b0900f as media};
//# sourceMappingURL=module.js.map
